
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c8b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c8b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("72z4V", function(module, exports) {

$parcel$export(module.exports, "DefaultAmplify", () => $8462ca0fe1ef67cb$export$11ac3725994bec7b);

var $1qbEC = parcelRequire("1qbEC");
var $lKsZv = parcelRequire("lKsZv");
var $57Of0 = parcelRequire("57Of0");

var $FIaO4 = parcelRequire("FIaO4");

var $e2NQk = parcelRequire("e2NQk");
var $54W3M = parcelRequire("54W3M");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8462ca0fe1ef67cb$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourceConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $FIaO4.parseAWSExports)(resourceConfig);
        else resolvedResourceConfig = resourceConfig;
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) return (0, $1qbEC.Amplify).configure(resolvedResourceConfig, libraryOptions);
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) return (0, $1qbEC.Amplify).configure(resolvedResourceConfig, libraryOptions);
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $1qbEC.Amplify).libraryOptions.Auth) {
            (0, $54W3M.cognitoUserPoolsTokenProvider).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $54W3M.cognitoUserPoolsTokenProvider).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $lKsZv.CookieStorage)({
                sameSite: "lax"
            }) : (0, $57Of0.defaultStorage));
            return (0, $1qbEC.Amplify).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $54W3M.cognitoUserPoolsTokenProvider),
                    credentialsProvider: (0, $e2NQk.cognitoCredentialsProvider)
                }
            });
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $54W3M.cognitoUserPoolsTokenProvider).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $lKsZv.CookieStorage)({
                sameSite: "lax"
            }) : (0, $57Of0.defaultStorage));
            return (0, $1qbEC.Amplify).configure(resolvedResourceConfig, {
                Auth: (0, $1qbEC.Amplify).libraryOptions.Auth,
                ...libraryOptions
            });
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $1qbEC.Amplify).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $1qbEC.Amplify).getConfig();
    }
};

});
parcelRegister("1qbEC", function(module, exports) {

$parcel$export(module.exports, "Amplify", () => $30fdc25c6f443021$export$a3858a9a153cffc7);

var $hMbLp = parcelRequire("hMbLp");

var $5RCQ5 = parcelRequire("5RCQ5");

var $FIaO4 = parcelRequire("FIaO4");



var $iceoz = parcelRequire("iceoz");

var $43O8I = parcelRequire("43O8I");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $30fdc25c6f443021$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $hMbLp.AuthClass)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourcesConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $FIaO4.parseAWSExports)(resourcesConfig);
        else resolvedResourceConfig = resourcesConfig;
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $iceoz.deepFreeze)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $5RCQ5.Hub).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $5RCQ5.AMPLIFY_SYMBOL));
        this.notifyOAuthListener();
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $43O8I.ADD_OAUTH_LISTENER)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` is responsible for orchestrating cross-category communication within the library.
 */ const $30fdc25c6f443021$export$a3858a9a153cffc7 = new $30fdc25c6f443021$export$b412d755cfa0136();

});
parcelRegister("hMbLp", function(module, exports) {

$parcel$export(module.exports, "isTokenExpired", () => $af0fe83fb084e5d7$export$b007d77a962aa175);
$parcel$export(module.exports, "AuthClass", () => $af0fe83fb084e5d7$export$eeff9d1a8b8c057b);
function $af0fe83fb084e5d7$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $af0fe83fb084e5d7$export$eeff9d1a8b8c057b {
    constructor(){}
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let tokens;
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        if (this.authOptions?.credentialsProvider) return await this.authOptions.credentialsProvider.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}

});

parcelRegister("5RCQ5", function(module, exports) {

$parcel$export(module.exports, "AMPLIFY_SYMBOL", () => $008d8f6886d8544f$export$aadf71dd9875dd20);
$parcel$export(module.exports, "Hub", () => $008d8f6886d8544f$export$8c41bb232f1008b1);

var $gJw02 = parcelRequire("gJw02");

var $1ZViM = parcelRequire("1ZViM");

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $008d8f6886d8544f$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $008d8f6886d8544f$var$logger = new (0, $gJw02.ConsoleLogger)("Hub");
class $008d8f6886d8544f$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $008d8f6886d8544f$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $008d8f6886d8544f$export$aadf71dd9875dd20;
            if (!hasAccess) $008d8f6886d8544f$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $008d8f6886d8544f$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $e0exy.AmplifyError)({
            name: (0, $1ZViM.NO_HUBCALLBACK_PROVIDED_EXCEPTION),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $008d8f6886d8544f$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $008d8f6886d8544f$var$logger.error(e);
            }
        });
    }
}
/*We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/ const $008d8f6886d8544f$export$8c41bb232f1008b1 = new $008d8f6886d8544f$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $008d8f6886d8544f$export$45dde0743a4c8d6e = new $008d8f6886d8544f$export$6b38ef2be9abbbb9("internal-hub");

});
parcelRegister("gJw02", function(module, exports) {

$parcel$export(module.exports, "ConsoleLogger", () => $4b398182966a4810$export$ba6a9c7ac8291f7f);

var $4qg9e = parcelRequire("4qg9e");

var $1ZViM = parcelRequire("1ZViM");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4b398182966a4810$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ class $4b398182966a4810$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $4qg9e.LogType).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let logger_level_name = this.level;
        if ($4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL) logger_level_name = $4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        const logger_level = $4b398182966a4810$var$LOG_LEVELS[logger_level_name];
        const type_level = $4b398182966a4810$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $4qg9e.LogType).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $4qg9e.LogType).WARN && console.warn) log = console.warn.bind(console);
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $4qg9e.LogType).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $4qg9e.LogType).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $4qg9e.LogType).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $4qg9e.LogType).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $4qg9e.LogType).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $4qg9e.LogType).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $1ZViM.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$4b398182966a4810$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;

});
parcelRegister("4qg9e", function(module, exports) {

$parcel$export(module.exports, "LogType", () => $efbbd0209ea980b7$export$a0472aa3a356446c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $efbbd0209ea980b7$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
})($efbbd0209ea980b7$export$a0472aa3a356446c || ($efbbd0209ea980b7$export$a0472aa3a356446c = {}));

});

parcelRegister("1ZViM", function(module, exports) {

$parcel$export(module.exports, "AWS_CLOUDWATCH_CATEGORY", () => $e362d339f3c21ca2$export$13470c6f1642bbce);
$parcel$export(module.exports, "USER_AGENT_HEADER", () => $e362d339f3c21ca2$export$16032fc466434892);
$parcel$export(module.exports, "NO_HUBCALLBACK_PROVIDED_EXCEPTION", () => $e362d339f3c21ca2$export$86d53207c3c20049);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $e362d339f3c21ca2$export$13470c6f1642bbce = "Logging";
const $e362d339f3c21ca2$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $e362d339f3c21ca2$export$86d53207c3c20049 = "NoHubcallbackProvidedException";

});


parcelRegister("e0exy", function(module, exports) {

$parcel$export(module.exports, "AmplifyError", () => $946cdba1e264a995$export$37321a6dace1881c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $946cdba1e264a995$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $946cdba1e264a995$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $946cdba1e264a995$export$37321a6dace1881c.prototype);
    }
}

});


parcelRegister("FIaO4", function(module, exports) {

$parcel$export(module.exports, "parseAWSExports", () => $12e0f7072a5016a7$export$1ef2e9c2da492d);

var $gJw02 = parcelRequire("gJw02");

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $12e0f7072a5016a7$var$logger = new (0, $gJw02.ConsoleLogger)("parseAWSExports");
const $12e0f7072a5016a7$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $12e0f7072a5016a7$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $e0exy.AmplifyError)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $12e0f7072a5016a7$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $12e0f7072a5016a7$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: loginWithEmailEnabled || loginWithPhoneEnabled ? false : true,
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$12e0f7072a5016a7$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $12e0f7072a5016a7$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = amazon_location_service ? {
            LocationService: {
                ...amazon_location_service,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        } : {
            ...geo
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $12e0f7072a5016a7$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $12e0f7072a5016a7$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $12e0f7072a5016a7$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $12e0f7072a5016a7$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $12e0f7072a5016a7$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};

});

parcelRegister("iceoz", function(module, exports) {

$parcel$export(module.exports, "deepFreeze", () => $35e949d961a4bb54$export$7e32b29e1cb162e1);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $35e949d961a4bb54$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $35e949d961a4bb54$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};

});

parcelRegister("43O8I", function(module, exports) {

$parcel$export(module.exports, "ADD_OAUTH_LISTENER", () => $3ac22caa9341ca12$export$35210b3191d26437);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3ac22caa9341ca12$export$35210b3191d26437 = Symbol("oauth-listener");

});


parcelRegister("lKsZv", function(module, exports) {

$parcel$export(module.exports, "CookieStorage", () => $8a827f16696ff978$export$dae7d845015939d5);

var $8Nbse = parcelRequire("8Nbse");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $8a827f16696ff978$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path ? path : "/";
        this.expires = data.hasOwnProperty("expires") ? expires : 365;
        this.secure = data.hasOwnProperty("secure") ? secure : true;
        if (data.hasOwnProperty("sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

});
parcelRegister("8Nbse", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});


parcelRegister("57Of0", function(module, exports) {

$parcel$export(module.exports, "defaultStorage", () => $c47f21f216a22ace$export$586b30dcaeecb901);

var $ejny4 = parcelRequire("ejny4");

var $g1gqr = parcelRequire("g1gqr");

var $ceLb3 = parcelRequire("ceLb3");

var $4EL3H = parcelRequire("4EL3H");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c47f21f216a22ace$export$586b30dcaeecb901 = new (0, $ejny4.DefaultStorage)();
const $c47f21f216a22ace$export$f119d83aa936d634 = new (0, $4EL3H.SessionStorage)();
const $c47f21f216a22ace$export$41feb988b3a84f03 = new (0, $ceLb3.KeyValueStorage)(new (0, $g1gqr.InMemoryStorage)());

});
parcelRegister("ejny4", function(module, exports) {

$parcel$export(module.exports, "DefaultStorage", () => $9f78cbd356024b7e$export$bec45e7703e93690);

var $ceLb3 = parcelRequire("ceLb3");

var $5Y39P = parcelRequire("5Y39P");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9f78cbd356024b7e$export$bec45e7703e93690 extends (0, $ceLb3.KeyValueStorage) {
    constructor(){
        super((0, $5Y39P.getLocalStorageWithFallback)());
    }
}

});
parcelRegister("ceLb3", function(module, exports) {

$parcel$export(module.exports, "KeyValueStorage", () => $0d6aa7e6d5a3429c$export$8536778e426ddf92);

var $fngA0 = parcelRequire("fngA0");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $0d6aa7e6d5a3429c$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $fngA0.PlatformNotSupportedError)();
        this.storage.clear();
    }
}

});
parcelRegister("fngA0", function(module, exports) {

$parcel$export(module.exports, "PlatformNotSupportedError", () => $a91ea1244b77fef7$export$f5362e8a6666a455);

var $8rSHg = parcelRequire("8rSHg");

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a91ea1244b77fef7$export$f5362e8a6666a455 extends (0, $e0exy.AmplifyError) {
    constructor(){
        super({
            name: (0, $8rSHg.AmplifyErrorCode).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}

});
parcelRegister("8rSHg", function(module, exports) {

$parcel$export(module.exports, "AmplifyErrorCode", () => $032079a569aa4e0d$export$4e712df6b850c8d0);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $032079a569aa4e0d$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
})($032079a569aa4e0d$export$4e712df6b850c8d0 || ($032079a569aa4e0d$export$4e712df6b850c8d0 = {}));

});



parcelRegister("5Y39P", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageWithFallback", () => $a932b92f8e337975$export$5d9abaf8ff62cd65);
$parcel$export(module.exports, "getSessionStorageWithFallback", () => $a932b92f8e337975$export$518dcc1598f87b);

var $g1gqr = parcelRequire("g1gqr");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $a932b92f8e337975$export$5d9abaf8ff62cd65 = ()=>typeof window !== "undefined" && window.localStorage ? window.localStorage : new (0, $g1gqr.InMemoryStorage)();
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $a932b92f8e337975$export$518dcc1598f87b = ()=>typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : new (0, $g1gqr.InMemoryStorage)();

});
parcelRegister("g1gqr", function(module, exports) {

$parcel$export(module.exports, "InMemoryStorage", () => $2875d3cc5c2dfbf0$export$e4315e25b840a0ea);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $2875d3cc5c2dfbf0$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}

});



parcelRegister("4EL3H", function(module, exports) {

$parcel$export(module.exports, "SessionStorage", () => $a3c2eb980ed98e6f$export$2c4b17e1c2e0931);

var $ceLb3 = parcelRequire("ceLb3");

var $5Y39P = parcelRequire("5Y39P");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $a3c2eb980ed98e6f$export$2c4b17e1c2e0931 extends (0, $ceLb3.KeyValueStorage) {
    constructor(){
        super((0, $5Y39P.getSessionStorageWithFallback)());
    }
}

});


parcelRegister("e2NQk", function(module, exports) {

$parcel$export(module.exports, "cognitoCredentialsProvider", () => $58a834a1218aacfd$export$be43b753aec531e2);

var $2vm2m = parcelRequire("2vm2m");

var $5rVdp = parcelRequire("5rVdp");

var $57Of0 = parcelRequire("57Of0");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $58a834a1218aacfd$export$be43b753aec531e2 = new (0, $5rVdp.CognitoAWSCredentialsAndIdentityIdProvider)(new (0, $2vm2m.DefaultIdentityIdStore)((0, $57Of0.defaultStorage)));

});
parcelRegister("2vm2m", function(module, exports) {

$parcel$export(module.exports, "DefaultIdentityIdStore", () => $9f93ccdc5f95c7af$export$3e97b78667a539a0);

var $gJw02 = parcelRequire("gJw02");

var $bfiP6 = parcelRequire("bfiP6");

var $88z72 = parcelRequire("88z72");

var $029ov = parcelRequire("029ov");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9f93ccdc5f95c7af$var$logger = new (0, $gJw02.ConsoleLogger)("DefaultIdentityIdStore");
class $9f93ccdc5f95c7af$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $bfiP6.assertIdentityPoolIdConfig)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $9f93ccdc5f95c7af$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
        return;
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $bfiP6.assertIdentityPoolIdConfig)(this.authConfig?.Cognito);
        try {
            if (!!this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (!!storedIdentityId) return {
                    id: storedIdentityId,
                    type: "guest"
                };
                return null;
            }
        } catch (err) {
            $9f93ccdc5f95c7af$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $bfiP6.assertIdentityPoolIdConfig)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            this.keyValueStorage.removeItem(this._authKeys.identityId);
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $9f93ccdc5f95c7af$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $029ov.getAuthStorageKeys)((0, $88z72.IdentityIdStorageKeys))(`com.amplify.${provider}`, identifier);
};

});
parcelRegister("bfiP6", function(module, exports) {

$parcel$export(module.exports, "assertTokenProviderConfig", () => $47b41f0bc3dcf730$export$80c92581e59ed502);
$parcel$export(module.exports, "assertOAuthConfig", () => $47b41f0bc3dcf730$export$c13e6dbaf90a8e5f);
$parcel$export(module.exports, "assertIdentityPoolIdConfig", () => $47b41f0bc3dcf730$export$8a2f5318ea3215e3);
$parcel$export(module.exports, "decodeJWT", () => $47b41f0bc3dcf730$export$9a62e6c0a30e00bc);

var $cYnY3 = parcelRequire("cYnY3");

var $iLExi = parcelRequire("iLExi");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $47b41f0bc3dcf730$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    return (0, $cYnY3.assert)(assertionValid, (0, $cYnY3.AuthConfigurationErrorCode).AuthUserPoolException);
}
function $47b41f0bc3dcf730$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    return (0, $cYnY3.assert)(validOAuthConfig, (0, $cYnY3.AuthConfigurationErrorCode).OAuthNotConfigureException);
}
function $47b41f0bc3dcf730$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    return (0, $cYnY3.assert)(validConfig, (0, $cYnY3.AuthConfigurationErrorCode).InvalidIdentityPoolIdException);
}
function $47b41f0bc3dcf730$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $iLExi.base64Decoder).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}

});
parcelRegister("cYnY3", function(module, exports) {

$parcel$export(module.exports, "AuthConfigurationErrorCode", () => $c43ab8490e8ade2c$export$7b5c8b570ea8407);
$parcel$export(module.exports, "assert", () => $c43ab8490e8ade2c$export$a7a9523472993e97);

var $bggJy = parcelRequire("bggJy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c43ab8490e8ade2c$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($c43ab8490e8ade2c$export$7b5c8b570ea8407 || ($c43ab8490e8ade2c$export$7b5c8b570ea8407 = {}));
const $c43ab8490e8ade2c$var$authConfigurationErrorMap = {
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$c43ab8490e8ade2c$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $c43ab8490e8ade2c$export$a7a9523472993e97 = (0, $bggJy.createAssertionFunction)($c43ab8490e8ade2c$var$authConfigurationErrorMap);

});
parcelRegister("bggJy", function(module, exports) {

$parcel$export(module.exports, "createAssertionFunction", () => $0d1a22fb669c23b6$export$5cb8fc27ccbe9d40);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0d1a22fb669c23b6$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $e0exy.AmplifyError))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };

});


parcelRegister("iLExi", function(module, exports) {

$parcel$export(module.exports, "base64Decoder", () => $0a6173e3df3e7293$export$1e303d38dab7b376);

var $dfMUF = parcelRequire("dfMUF");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0a6173e3df3e7293$export$1e303d38dab7b376 = {
    convert (input) {
        return (0, $dfMUF.getAtob)()(input);
    }
};

});
parcelRegister("dfMUF", function(module, exports) {

$parcel$export(module.exports, "getCrypto", () => $6f3b4030fc0f3ef5$export$e003cc239f955cb6);
$parcel$export(module.exports, "getBtoa", () => $6f3b4030fc0f3ef5$export$94f295707b435c6d);
$parcel$export(module.exports, "getAtob", () => $6f3b4030fc0f3ef5$export$ea737e7700106b27);

var $e0exy = parcelRequire("e0exy");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6f3b4030fc0f3ef5$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $e0exy.AmplifyError)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $6f3b4030fc0f3ef5$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $e0exy.AmplifyError)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $6f3b4030fc0f3ef5$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $e0exy.AmplifyError)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};

});



parcelRegister("88z72", function(module, exports) {

$parcel$export(module.exports, "IdentityIdStorageKeys", () => $c1ea576318e91128$export$dad1700b96c3a835);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1ea576318e91128$export$dad1700b96c3a835 = {
    identityId: "identityId"
};

});

parcelRegister("029ov", function(module, exports) {

$parcel$export(module.exports, "DefaultTokenStore", () => $bfc286311b85b781$export$a36be852d43d512);
$parcel$export(module.exports, "getAuthStorageKeys", () => $bfc286311b85b781$export$dfb8da757ca62eed);

var $bfiP6 = parcelRequire("bfiP6");

var $3O5pD = parcelRequire("3O5pD");

var $b62N7 = parcelRequire("b62N7");

var $dvCiI = parcelRequire("dvCiI");
class $bfc286311b85b781$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $b62N7.AuthError)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $b62N7.AuthError)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $bfiP6.decodeJWT)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $bfiP6.decodeJWT)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $dvCiI.assert)(tokens !== undefined, (0, $dvCiI.TokenProviderErrorCode).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (!!tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (!!tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (!!tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (!!tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return !!randomPassword ? {
            deviceKey: deviceKey ?? undefined,
            deviceGroupKey: deviceGroupKey ?? undefined,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $bfc286311b85b781$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
}
const $bfc286311b85b781$export$4647c72f6828a74d = (provider, identifier)=>{
    return $bfc286311b85b781$export$dfb8da757ca62eed((0, $3O5pD.AuthTokenStorageKeys))(`${provider}`, identifier);
};
function $bfc286311b85b781$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}

});
parcelRegister("3O5pD", function(module, exports) {

$parcel$export(module.exports, "AuthTokenStorageKeys", () => $338fa29dda4a9a9e$export$b8429d1428aad8ba);
const $338fa29dda4a9a9e$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
};

});

parcelRegister("b62N7", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0bd2271901d3ce8f$export$145273558d58e0ac);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $0bd2271901d3ce8f$export$145273558d58e0ac extends (0, $e0exy.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0bd2271901d3ce8f$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $0bd2271901d3ce8f$export$145273558d58e0ac.prototype);
    }
}

});

parcelRegister("dvCiI", function(module, exports) {

$parcel$export(module.exports, "TokenProviderErrorCode", () => $40486dcb7c4675e2$export$cc5909720f29144);
$parcel$export(module.exports, "assert", () => $40486dcb7c4675e2$export$a7a9523472993e97);

var $bggJy = parcelRequire("bggJy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $40486dcb7c4675e2$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($40486dcb7c4675e2$export$cc5909720f29144 || ($40486dcb7c4675e2$export$cc5909720f29144 = {}));
const $40486dcb7c4675e2$var$tokenValidationErrorMap = {
    [$40486dcb7c4675e2$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $40486dcb7c4675e2$export$a7a9523472993e97 = (0, $bggJy.createAssertionFunction)($40486dcb7c4675e2$var$tokenValidationErrorMap);

});



parcelRegister("5rVdp", function(module, exports) {

$parcel$export(module.exports, "CognitoAWSCredentialsAndIdentityIdProvider", () => $1b1ef4a1e101da96$export$be6550e37264dc26);

var $4a2RL = parcelRequire("4a2RL");

var $gJw02 = parcelRequire("gJw02");
var $avjBi = parcelRequire("avjBi");

var $bfiP6 = parcelRequire("bfiP6");

var $b62N7 = parcelRequire("b62N7");

var $4P578 = parcelRequire("4P578");

var $kOfpC = parcelRequire("kOfpC");

var $inqgD = parcelRequire("inqgD");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1b1ef4a1e101da96$var$logger = new (0, $gJw02.ConsoleLogger)("CognitoCredentialsProvider");
const $1b1ef4a1e101da96$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $1b1ef4a1e101da96$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $1b1ef4a1e101da96$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $1b1ef4a1e101da96$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const tokens = getCredentialsOptions.tokens;
        const authConfig = getCredentialsOptions.authConfig;
        try {
            (0, $bfiP6.assertIdentityPoolIdConfig)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const forceRefresh = getCredentialsOptions.forceRefresh;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $4a2RL.cognitoIdentityIdProvider)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $kOfpC.assertIdTokenInAuthTokens)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $1b1ef4a1e101da96$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $4P578.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $avjBi.getCredentialsForIdentity)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $1b1ef4a1e101da96$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $b62N7.AuthError)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $1b1ef4a1e101da96$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $inqgD.formLoginsMap)(authTokens.idToken.toString()) : {};
        const region = (0, $4P578.getRegionFromIdentityPoolId)(authConfig.identityPoolId);
        const clientResult = await (0, $avjBi.getCredentialsForIdentity)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $1b1ef4a1e101da96$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $b62N7.AuthError)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}

});
parcelRegister("4a2RL", function(module, exports) {

$parcel$export(module.exports, "cognitoIdentityIdProvider", () => $afb7bce2c184eee7$export$7c3e576630d5e301);

var $gJw02 = parcelRequire("gJw02");
var $0D2gL = parcelRequire("0D2gL");

var $b62N7 = parcelRequire("b62N7");

var $4P578 = parcelRequire("4P578");

var $inqgD = parcelRequire("inqgD");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $afb7bce2c184eee7$var$logger = new (0, $gJw02.ConsoleLogger)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration excpetions: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service excpetions: {@link GetIdException }
 */ async function $afb7bce2c184eee7$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $inqgD.formLoginsMap)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $afb7bce2c184eee7$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $afb7bce2c184eee7$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $afb7bce2c184eee7$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $afb7bce2c184eee7$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $4P578.getRegionFromIdentityPoolId)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $0D2gL.getId)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $b62N7.AuthError)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}

});
parcelRegister("0D2gL", function(module, exports) {

$parcel$export(module.exports, "getId", () => $0a5974c6b22efc6b$export$218c8c3169c024d2);

var $lL7zI = parcelRequire("lL7zI");


parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $7ecIZ = parcelRequire("7ecIZ");

var $bM38a = parcelRequire("bM38a");

var $6vbP8 = parcelRequire("6vbP8");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0a5974c6b22efc6b$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $lL7zI.getSharedHeaders)("GetId");
    const body = JSON.stringify(input);
    return (0, $lL7zI.buildHttpRpcRequest)(endpoint, headers, body);
};
const $0a5974c6b22efc6b$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $bM38a.parseJsonError)(response);
        throw error;
    } else {
        const body = await (0, $bM38a.parseJsonBody)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $7ecIZ.parseMetadata)(response)
        };
    }
};
/**
 * @internal
 */ const $0a5974c6b22efc6b$export$218c8c3169c024d2 = (0, $6vbP8.composeServiceApi)((0, $lL7zI.cognitoIdentityTransferHandler), $0a5974c6b22efc6b$var$getIdSerializer, $0a5974c6b22efc6b$var$getIdDeserializer, (0, $lL7zI.defaultConfig));

});
parcelRegister("lL7zI", function(module, exports) {

$parcel$export(module.exports, "cognitoIdentityTransferHandler", () => $875b0abd80166f32$export$8029646671d2c482);
$parcel$export(module.exports, "defaultConfig", () => $875b0abd80166f32$export$f84bd70098573c5c);
$parcel$export(module.exports, "getSharedHeaders", () => $875b0abd80166f32$export$a46bbeaba09f7285);
$parcel$export(module.exports, "buildHttpRpcRequest", () => $875b0abd80166f32$export$a692bdb7eb624f96);

var $fqhqt = parcelRequire("fqhqt");

var $itEnq = parcelRequire("itEnq");

var $5D9nd = parcelRequire("5D9nd");

var $4ZD6k = parcelRequire("4ZD6k");
parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $7Ar4G = parcelRequire("7Ar4G");

var $8e8Xp = parcelRequire("8e8Xp");

var $bM38a = parcelRequire("bM38a");

var $dj9FS = parcelRequire("dj9FS");

var $iHOzP = parcelRequire("iHOzP");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $875b0abd80166f32$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $875b0abd80166f32$var$endpointResolver = ({ region: region })=>({
        url: new (0, $7Ar4G.AmplifyUrl)(`https://cognito-identity.${region}.${(0, $fqhqt.getDnsSuffix)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $875b0abd80166f32$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $875b0abd80166f32$export$8029646671d2c482 = (0, $8e8Xp.composeTransferHandler)((0, $itEnq.unauthenticatedHandler), [
    $875b0abd80166f32$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $875b0abd80166f32$export$f84bd70098573c5c = {
    service: $875b0abd80166f32$var$SERVICE_NAME,
    endpointResolver: $875b0abd80166f32$var$endpointResolver,
    retryDecider: (0, $4ZD6k.getRetryDecider)((0, $bM38a.parseJsonError)),
    computeDelay: (0, $5D9nd.jitteredBackoff),
    userAgentValue: (0, $dj9FS.getAmplifyUserAgent)(),
    cache: "no-store"
};
(0, $iHOzP.observeFrameworkChanges)(()=>{
    $875b0abd80166f32$export$f84bd70098573c5c.userAgentValue = (0, $dj9FS.getAmplifyUserAgent)();
});
/**
 * @internal
 */ const $875b0abd80166f32$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $875b0abd80166f32$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });

});
parcelRegister("fqhqt", function(module, exports) {

$parcel$export(module.exports, "getDnsSuffix", () => $8ce7edd304848afd$export$1c28e37cdcc37f6d);

var $amVal = parcelRequire("amVal");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $8ce7edd304848afd$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $amVal.partitionsInfo);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $amVal.defaultPartition).outputs.dnsSuffix;
};

});
parcelRegister("amVal", function(module, exports) {

$parcel$export(module.exports, "defaultPartition", () => $5c61b283b1e239d9$export$72f3cee421ee8a74);
$parcel$export(module.exports, "partitionsInfo", () => $5c61b283b1e239d9$export$d7c12af0c0f12206);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $5c61b283b1e239d9$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $5c61b283b1e239d9$export$d7c12af0c0f12206 = {
    partitions: [
        $5c61b283b1e239d9$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};

});


parcelRegister("itEnq", function(module, exports) {

$parcel$export(module.exports, "unauthenticatedHandler", () => $156379934f867ed3$export$ed7e1ccf00f39c4a);

var $aWNly = parcelRequire("aWNly");



var $aBoxv = parcelRequire("aBoxv");

var $8e8Xp = parcelRequire("8e8Xp");

var $anVi4 = parcelRequire("anVi4");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $156379934f867ed3$export$ed7e1ccf00f39c4a = (0, $8e8Xp.composeTransferHandler)((0, $anVi4.fetchTransferHandler), [
    (0, $aBoxv.userAgentMiddleware),
    (0, $aWNly.retryMiddleware)
]);

});
parcelRegister("aWNly", function(module, exports) {

$parcel$export(module.exports, "retryMiddleware", () => $60f584ba62481a94$export$a3922aa5f87bae85);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $60f584ba62481a94$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $60f584ba62481a94$export$a3922aa5f87bae85 = ({ maxAttempts: maxAttempts = $60f584ba62481a94$var$DEFAULT_RETRY_ATTEMPTS, retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $60f584ba62481a94$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $60f584ba62481a94$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                if (await retryDecider(response, error)) {
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $60f584ba62481a94$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $60f584ba62481a94$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $60f584ba62481a94$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = {
        ...nextHandlerOutput["$metadata"] ?? {},
        attempts: attempts
    };
};

});

parcelRegister("aBoxv", function(module, exports) {

$parcel$export(module.exports, "userAgentMiddleware", () => $2b3779b84f2cce55$export$62c460923941c0b0);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $2b3779b84f2cce55$export$62c460923941c0b0 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent", userAgentValue: userAgentValue = "" })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };

});

parcelRegister("8e8Xp", function(module, exports) {

$parcel$export(module.exports, "composeTransferHandler", () => $faf95af99f8b5697$export$f074d76e52925468);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $faf95af99f8b5697$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (request)=>coreHandler(request, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };

});

parcelRegister("anVi4", function(module, exports) {

$parcel$export(module.exports, "fetchTransferHandler", () => $c6ff1f678a0bf7c2$export$d2573baf35521e4c);

var $joNXB = parcelRequire("joNXB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c6ff1f678a0bf7c2$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $c6ff1f678a0bf7c2$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $c6ff1f678a0bf7c2$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        // TODO: needs to revise error handling in v6
        // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
        // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
        if (e instanceof TypeError) throw new Error("Network error");
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $joNXB.withMemoization)(()=>resp.text()),
        blob: (0, $joNXB.withMemoization)(()=>resp.blob()),
        json: (0, $joNXB.withMemoization)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};

});
parcelRegister("joNXB", function(module, exports) {

$parcel$export(module.exports, "withMemoization", () => $0cf8b26b324855c8$export$580ad1ce15092b15);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $0cf8b26b324855c8$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

});



parcelRegister("5D9nd", function(module, exports) {

$parcel$export(module.exports, "jitteredBackoff", () => $6b984381f509b0c4$export$caea50bde345f648);


var $h05tY = parcelRequire("h05tY");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $6b984381f509b0c4$var$DEFAULT_MAX_DELAY_MS = 300000;
const $6b984381f509b0c4$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $h05tY.jitteredBackoff)($6b984381f509b0c4$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $6b984381f509b0c4$var$DEFAULT_MAX_DELAY_MS : delay;
};

});
parcelRegister("h05tY", function(module, exports) {

$parcel$export(module.exports, "jitteredBackoff", () => $bb00929d82f30d06$export$caea50bde345f648);

var $1Ns4m = parcelRequire("1Ns4m");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $bb00929d82f30d06$export$caea50bde345f648(maxDelayMs = (0, $1Ns4m.MAX_DELAY_MS)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}

});
parcelRegister("1Ns4m", function(module, exports) {

$parcel$export(module.exports, "MAX_DELAY_MS", () => $2ebb2babc51c1967$export$76041b1400befb8b);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2ebb2babc51c1967$export$76041b1400befb8b = 300000;

});



parcelRegister("4ZD6k", function(module, exports) {

$parcel$export(module.exports, "getRetryDecider", () => $8eda02c680edd0d6$export$b919d98317a7685f);

var $i3rGM = parcelRequire("i3rGM");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $8eda02c680edd0d6$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.["code"];
        const statusCode = response?.statusCode;
        return $8eda02c680edd0d6$var$isConnectionError(error) || $8eda02c680edd0d6$var$isThrottlingError(statusCode, errorCode) || (0, $i3rGM.isClockSkewError)(errorCode) || $8eda02c680edd0d6$var$isServerSideError(statusCode, errorCode);
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $8eda02c680edd0d6$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $8eda02c680edd0d6$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $8eda02c680edd0d6$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $8eda02c680edd0d6$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $8eda02c680edd0d6$var$isConnectionError = (error)=>error?.["name"] === "Network error";
const $8eda02c680edd0d6$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $8eda02c680edd0d6$var$TIMEOUT_ERROR_CODES.includes(errorCode);

});
parcelRegister("i3rGM", function(module, exports) {

$parcel$export(module.exports, "isClockSkewError", () => $25c9c2f444e10e78$export$7b87435661177a94);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $25c9c2f444e10e78$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $25c9c2f444e10e78$export$7b87435661177a94 = (errorCode)=>!!errorCode && $25c9c2f444e10e78$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);

});


parcelRegister("78v1Z", function(module, exports) {
$parcel$export(module.exports, "Sha256", () => (parcelRequire("4xNDb")).Sha256);
parcelRequire("4xNDb");

});
parcelRegister("4xNDb", function(module, exports) {

$parcel$export(module.exports, "Sha256", () => $34f0be31e76b3852$export$3b58ea8124ac5e28);

var $7WQrb = parcelRequire("7WQrb");

var $4saKg = parcelRequire("4saKg");

var $bGlNU = parcelRequire("bGlNU");
parcelRequire("6dvWF");
var $3cPkP = parcelRequire("3cPkP");
var $ZB00P = parcelRequire("ZB00P");
var $34f0be31e76b3852$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $bGlNU.RawSha256)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ZB00P.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $3cPkP.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            return (0, $7WQrb.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $bGlNU.RawSha256)();
        if (this.secret) {
            this.outer = new (0, $bGlNU.RawSha256)();
            var inner = $34f0be31e76b3852$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
            outer.set(inner);
            for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $34f0be31e76b3852$var$bufferFromSecret(secret) {
    var input = (0, $3cPkP.convertToBuffer)(secret);
    if (input.byteLength > (0, $4saKg.BLOCK_SIZE)) {
        var bufferHash = new (0, $bGlNU.RawSha256)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $4saKg.BLOCK_SIZE));
    buffer.set(input);
    return buffer;
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $5c96a02c592fcff1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $5c96a02c592fcff1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $5c96a02c592fcff1$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("4saKg", function(module, exports) {

$parcel$export(module.exports, "BLOCK_SIZE", () => $33e21cb3f745e23a$export$b2e3d6d444266a5c);
$parcel$export(module.exports, "DIGEST_LENGTH", () => $33e21cb3f745e23a$export$d7bd469488748c5f);
$parcel$export(module.exports, "KEY", () => $33e21cb3f745e23a$export$7167c830cefcb6b5);
$parcel$export(module.exports, "INIT", () => $33e21cb3f745e23a$export$d788bc089976c004);
$parcel$export(module.exports, "MAX_HASHABLE_LENGTH", () => $33e21cb3f745e23a$export$856b3d11dc447b50);
/**
 * @internal
 */ var $33e21cb3f745e23a$export$b2e3d6d444266a5c = 64;
var $33e21cb3f745e23a$export$d7bd469488748c5f = 32;
var $33e21cb3f745e23a$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $33e21cb3f745e23a$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $33e21cb3f745e23a$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;

});

parcelRegister("bGlNU", function(module, exports) {

$parcel$export(module.exports, "RawSha256", () => $881487c8a44da5fa$export$aab6bc1ad3c77a42);

var $4saKg = parcelRequire("4saKg");
/**
 * @internal
 */ var $881487c8a44da5fa$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $4saKg.INIT));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $4saKg.MAX_HASHABLE_LENGTH)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $4saKg.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $4saKg.BLOCK_SIZE) >= (0, $4saKg.BLOCK_SIZE) - 8) {
                for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $4saKg.BLOCK_SIZE) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $4saKg.BLOCK_SIZE) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $4saKg.DIGEST_LENGTH));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $4saKg.BLOCK_SIZE); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $4saKg.KEY)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();

});

parcelRegister("6dvWF", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => (parcelRequire("3cPkP")).convertToBuffer);
$parcel$export(module.exports, "isEmptyData", () => (parcelRequire("ZB00P")).isEmptyData);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $3cPkP = parcelRequire("3cPkP");

var $ZB00P = parcelRequire("ZB00P");

var $aecxA = parcelRequire("aecxA");

var $kjfFh = parcelRequire("kjfFh");

});
parcelRegister("3cPkP", function(module, exports) {

$parcel$export(module.exports, "convertToBuffer", () => $255a5028cde3f3bc$export$4f21f20c2f1a9063);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
parcelRequire("geIv0");
var $1uolR = parcelRequire("1uolR");

var $6ZWSX = parcelRequire("6ZWSX");
var $255a5028cde3f3bc$require$Buffer = $6ZWSX.Buffer;
// Quick polyfill
var $255a5028cde3f3bc$var$fromUtf8 = typeof $255a5028cde3f3bc$require$Buffer !== "undefined" && $255a5028cde3f3bc$require$Buffer.from ? function(input) {
    return $255a5028cde3f3bc$require$Buffer.from(input, "utf8");
} : (0, $1uolR.fromUtf8);
function $255a5028cde3f3bc$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $255a5028cde3f3bc$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("geIv0", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("1uolR")).fromUtf8);
parcelRequire("1uolR");
parcelRequire("jGtn4");
parcelRequire("3cIry");

});
parcelRegister("1uolR", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc);
const $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("jGtn4", function(module, exports) {

var $1uolR = parcelRequire("1uolR");
const $e548b91235db5cfc$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $1uolR.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("3cIry", function(module, exports) {
const $2554f7a5fe934436$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);

});


parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("ZB00P", function(module, exports) {

$parcel$export(module.exports, "isEmptyData", () => $0b9265e3f06832e9$export$ea55f474a468804e);
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0b9265e3f06832e9$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}

});

parcelRegister("aecxA", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7724f0827d728d87$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}

});

parcelRegister("kjfFh", function(module, exports) {
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $ec91bbb6f0039d68$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}

});




parcelRegister("lUOK3", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $ff463032e6a14a0a$export$7ea66e3774a60b67);
const $ff463032e6a14a0a$var$SHORT_TO_HEX = {};
const $ff463032e6a14a0a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $ff463032e6a14a0a$var$SHORT_TO_HEX[i] = encodedByte;
    $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $ff463032e6a14a0a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $ff463032e6a14a0a$var$HEX_TO_SHORT) out[i / 2] = $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $ff463032e6a14a0a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $ff463032e6a14a0a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});

parcelRegister("7Ar4G", function(module, exports) {

$parcel$export(module.exports, "AmplifyUrl", () => $69ea4819ac006867$export$beb82d9d9136c16e);
$parcel$export(module.exports, "AmplifyUrlSearchParams", () => $69ea4819ac006867$export$4ea7bbdac595b5fb);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69ea4819ac006867$export$beb82d9d9136c16e = URL;
const $69ea4819ac006867$export$4ea7bbdac595b5fb = URLSearchParams;

});

parcelRegister("bM38a", function(module, exports) {

$parcel$export(module.exports, "parseJsonError", () => $79d947bf5668e8ed$export$be467dfcc0538e25);
$parcel$export(module.exports, "parseJsonBody", () => $79d947bf5668e8ed$export$759bcb35b0d1bf81);

var $7ecIZ = parcelRequire("7ecIZ");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $79d947bf5668e8ed$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $79d947bf5668e8ed$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[\,\:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $79d947bf5668e8ed$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $7ecIZ.parseMetadata)(response)
    });
};

});
parcelRegister("7ecIZ", function(module, exports) {

$parcel$export(module.exports, "parseMetadata", () => $f4d14d043a6280d5$export$978f9418fe0cb26c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f4d14d043a6280d5$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    return {
        ...$f4d14d043a6280d5$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $f4d14d043a6280d5$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";

});


parcelRegister("dj9FS", function(module, exports) {

$parcel$export(module.exports, "getAmplifyUserAgent", () => $a3c63f83cda4eabf$export$ede38edb26c0bfdf);

var $k2DuP = parcelRequire("k2DuP");

var $bJXer = parcelRequire("bJXer");

var $iHOzP = parcelRequire("iHOzP");

var $lA3xE = parcelRequire("lA3xE");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a3c63f83cda4eabf$var$BASE_USER_AGENT = `aws-amplify`;
class $a3c63f83cda4eabf$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$a3c63f83cda4eabf$var$BASE_USER_AGENT}/${0, $bJXer.version}`;
    }
    get framework() {
        return (0, $iHOzP.detectFramework)();
    }
    get isReactNative() {
        return this.framework === (0, $k2DuP.Framework).ReactNative || this.framework === (0, $k2DuP.Framework).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $iHOzP.observeFrameworkChanges)(fcn);
    }
}
const $a3c63f83cda4eabf$export$2dffd0b5373a4389 = new $a3c63f83cda4eabf$var$PlatformBuilder();
const $a3c63f83cda4eabf$export$7d201307d8979e21 = ({ category: category, action: action, framework: framework } = {})=>{
    const userAgent = [
        [
            $a3c63f83cda4eabf$var$BASE_USER_AGENT,
            (0, $bJXer.version)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $iHOzP.detectFramework)()
    ]);
    if (category && action) {
        const customState = (0, $lA3xE.getCustomUserAgent)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $a3c63f83cda4eabf$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $a3c63f83cda4eabf$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};

});
parcelRegister("k2DuP", function(module, exports) {

$parcel$export(module.exports, "Framework", () => $03a78c53205d4e48$export$638889172ebce0c4);
$parcel$export(module.exports, "Category", () => $03a78c53205d4e48$export$3a8840c5b2ecf003);
$parcel$export(module.exports, "ApiAction", () => $03a78c53205d4e48$export$126e20fdc0f0d34b);
$parcel$export(module.exports, "AuthAction", () => $03a78c53205d4e48$export$900b1436d7e65f4);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $03a78c53205d4e48$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($03a78c53205d4e48$export$638889172ebce0c4 || ($03a78c53205d4e48$export$638889172ebce0c4 = {}));
var $03a78c53205d4e48$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($03a78c53205d4e48$export$3a8840c5b2ecf003 || ($03a78c53205d4e48$export$3a8840c5b2ecf003 = {}));
var $03a78c53205d4e48$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($03a78c53205d4e48$export$30c16f5c43437fd7 || ($03a78c53205d4e48$export$30c16f5c43437fd7 = {}));
var $03a78c53205d4e48$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($03a78c53205d4e48$export$126e20fdc0f0d34b || ($03a78c53205d4e48$export$126e20fdc0f0d34b = {}));
var $03a78c53205d4e48$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
})($03a78c53205d4e48$export$900b1436d7e65f4 || ($03a78c53205d4e48$export$900b1436d7e65f4 = {}));
var $03a78c53205d4e48$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($03a78c53205d4e48$export$2f5a715aba4cde93 || ($03a78c53205d4e48$export$2f5a715aba4cde93 = {}));
var $03a78c53205d4e48$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($03a78c53205d4e48$export$afafab3eb8fc6fef || ($03a78c53205d4e48$export$afafab3eb8fc6fef = {}));
var $03a78c53205d4e48$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($03a78c53205d4e48$export$c01a8c16ffda791e || ($03a78c53205d4e48$export$c01a8c16ffda791e = {}));
var $03a78c53205d4e48$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($03a78c53205d4e48$export$68e0695a774ab7fa || ($03a78c53205d4e48$export$68e0695a774ab7fa = {}));
var $03a78c53205d4e48$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($03a78c53205d4e48$export$aa89b4c447a07cee || ($03a78c53205d4e48$export$aa89b4c447a07cee = {}));
var $03a78c53205d4e48$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($03a78c53205d4e48$export$ade48b30f1e78672 || ($03a78c53205d4e48$export$ade48b30f1e78672 = {}));
var $03a78c53205d4e48$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($03a78c53205d4e48$export$2c5ee06ab9fa5040 || ($03a78c53205d4e48$export$2c5ee06ab9fa5040 = {}));
var $03a78c53205d4e48$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
})($03a78c53205d4e48$export$d4f3c54b808b00ce || ($03a78c53205d4e48$export$d4f3c54b808b00ce = {}));

});

parcelRegister("bJXer", function(module, exports) {

$parcel$export(module.exports, "version", () => $f2bdc992a31a3840$export$83d89fbfd8236492);
// generated by genversion
const $f2bdc992a31a3840$export$83d89fbfd8236492 = "6.0.15";

});

parcelRegister("iHOzP", function(module, exports) {

$parcel$export(module.exports, "detectFramework", () => $8e898e8be4dc09ea$export$9ce73e459ec93b6a);
$parcel$export(module.exports, "observeFrameworkChanges", () => $8e898e8be4dc09ea$export$5d5c467ce0b213f);

var $k2DuP = parcelRequire("k2DuP");

var $1XCWz = parcelRequire("1XCWz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $8e898e8be4dc09ea$var$frameworkCache;
const $8e898e8be4dc09ea$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $8e898e8be4dc09ea$var$resetTriggered = false;
const $8e898e8be4dc09ea$var$SSR_RESET_TIMEOUT = 10; // ms
const $8e898e8be4dc09ea$var$WEB_RESET_TIMEOUT = 10; // ms
const $8e898e8be4dc09ea$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $8e898e8be4dc09ea$export$9ce73e459ec93b6a = ()=>{
    if (!$8e898e8be4dc09ea$var$frameworkCache) {
        $8e898e8be4dc09ea$var$frameworkCache = (0, $1XCWz.detect)();
        if ($8e898e8be4dc09ea$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($8e898e8be4dc09ea$export$d56891f33aa26edc.length)$8e898e8be4dc09ea$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $8e898e8be4dc09ea$export$d56891f33aa26edc.forEach((fcn)=>fcn());
        // Retry once for either Unknown type after a delay (explained below)
        $8e898e8be4dc09ea$var$resetTimeout((0, $k2DuP.Framework).ServerSideUnknown, $8e898e8be4dc09ea$var$SSR_RESET_TIMEOUT);
        $8e898e8be4dc09ea$var$resetTimeout((0, $k2DuP.Framework).WebUnknown, $8e898e8be4dc09ea$var$WEB_RESET_TIMEOUT);
    }
    return $8e898e8be4dc09ea$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $8e898e8be4dc09ea$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($8e898e8be4dc09ea$var$resetTriggered) return;
    $8e898e8be4dc09ea$export$d56891f33aa26edc.push(fcn);
};
function $8e898e8be4dc09ea$export$d2adf65b87e47523() {
    $8e898e8be4dc09ea$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $8e898e8be4dc09ea$var$resetTimeout(framework, delay) {
    if ($8e898e8be4dc09ea$var$frameworkCache === framework && !$8e898e8be4dc09ea$var$resetTriggered) setTimeout(()=>{
        $8e898e8be4dc09ea$export$d2adf65b87e47523();
        $8e898e8be4dc09ea$var$resetTriggered = true;
        setTimeout($8e898e8be4dc09ea$export$9ce73e459ec93b6a, $8e898e8be4dc09ea$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}

});
parcelRegister("1XCWz", function(module, exports) {

$parcel$export(module.exports, "detect", () => $4f5e49be6c2f4c6b$export$17b446b869dad473);

var $k2DuP = parcelRequire("k2DuP");

var $5SWUB = parcelRequire("5SWUB");

var $89E5v = parcelRequire("89E5v");

var $dXsZ3 = parcelRequire("dXsZ3");

var $3uPOM = parcelRequire("3uPOM");

var $7wUjf = parcelRequire("7wUjf");

var $cZAgk = parcelRequire("cZAgk");

var $04Bbd = parcelRequire("04Bbd");

var $cN0eS = parcelRequire("cN0eS");

var $SrjZ5 = parcelRequire("SrjZ5");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $4f5e49be6c2f4c6b$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $k2DuP.Framework).Expo,
        detectionMethod: (0, $cN0eS.expoDetect)
    },
    {
        platform: (0, $k2DuP.Framework).ReactNative,
        detectionMethod: (0, $04Bbd.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, $k2DuP.Framework).NextJs,
        detectionMethod: (0, $3uPOM.nextWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Nuxt,
        detectionMethod: (0, $7wUjf.nuxtWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Angular,
        detectionMethod: (0, $cZAgk.angularWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).React,
        detectionMethod: (0, $5SWUB.reactWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).VueJs,
        detectionMethod: (0, $89E5v.vueWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).Svelte,
        detectionMethod: (0, $dXsZ3.svelteWebDetect)
    },
    {
        platform: (0, $k2DuP.Framework).WebUnknown,
        detectionMethod: (0, $SrjZ5.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $k2DuP.Framework).NextJsSSR,
        detectionMethod: (0, $3uPOM.nextSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).NuxtSSR,
        detectionMethod: (0, $7wUjf.nuxtSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).ReactSSR,
        detectionMethod: (0, $5SWUB.reactSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).VueJsSSR,
        detectionMethod: (0, $89E5v.vueSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).AngularSSR,
        detectionMethod: (0, $cZAgk.angularSSRDetect)
    },
    {
        platform: (0, $k2DuP.Framework).SvelteSSR,
        detectionMethod: (0, $dXsZ3.svelteSSRDetect)
    }
];
function $4f5e49be6c2f4c6b$export$17b446b869dad473() {
    return $4f5e49be6c2f4c6b$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $k2DuP.Framework).ServerSideUnknown;
}

});
parcelRegister("5SWUB", function(module, exports) {

$parcel$export(module.exports, "reactWebDetect", () => $627d0a27c40192cb$export$ba3f37c54f0f7805);
$parcel$export(module.exports, "reactSSRDetect", () => $627d0a27c40192cb$export$86269c582305790);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $627d0a27c40192cb$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $i0jHL.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function $627d0a27c40192cb$export$86269c582305790() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env !== "undefined" && !!Object.keys($hPtJY.env).find((key)=>key.includes("react"));
}

});
parcelRegister("i0jHL", function(module, exports) {

$parcel$export(module.exports, "globalExists", () => $143673b599f131f0$export$a15eed0e463030a9);
$parcel$export(module.exports, "windowExists", () => $143673b599f131f0$export$daba2802a1a41c1f);
$parcel$export(module.exports, "documentExists", () => $143673b599f131f0$export$b949ebcb877faa59);
$parcel$export(module.exports, "processExists", () => $143673b599f131f0$export$ba10401363d0f7f6);
$parcel$export(module.exports, "keyPrefixMatch", () => $143673b599f131f0$export$252f88727cff70c7);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $hPtJY = parcelRequire("hPtJY");
const $143673b599f131f0$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $143673b599f131f0$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $143673b599f131f0$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $143673b599f131f0$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $143673b599f131f0$export$ba10401363d0f7f6 = ()=>{
    return typeof $hPtJY !== "undefined";
};
const $143673b599f131f0$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("89E5v", function(module, exports) {

$parcel$export(module.exports, "vueWebDetect", () => $ca4f85d593562053$export$d91d90d62b78936d);
$parcel$export(module.exports, "vueSSRDetect", () => $ca4f85d593562053$export$257a4c0f8294a101);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $ca4f85d593562053$export$d91d90d62b78936d() {
    return (0, $i0jHL.windowExists)() && (0, $i0jHL.keyPrefixMatch)(window, "__VUE");
}
function $ca4f85d593562053$export$257a4c0f8294a101() {
    return (0, $i0jHL.globalExists)() && (0, $i0jHL.keyPrefixMatch)($parcel$global, "__VUE");
}

});

parcelRegister("dXsZ3", function(module, exports) {

$parcel$export(module.exports, "svelteWebDetect", () => $10841416b19b9aca$export$6dafc32a94edaed3);
$parcel$export(module.exports, "svelteSSRDetect", () => $10841416b19b9aca$export$819dcb7fe144d8b0);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $10841416b19b9aca$export$6dafc32a94edaed3() {
    return (0, $i0jHL.windowExists)() && (0, $i0jHL.keyPrefixMatch)(window, "__SVELTE");
}
function $10841416b19b9aca$export$819dcb7fe144d8b0() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env !== "undefined" && !!Object.keys($hPtJY.env).find((key)=>key.includes("svelte"));
}

});

parcelRegister("3uPOM", function(module, exports) {

$parcel$export(module.exports, "nextWebDetect", () => $da3905a0dc1faf56$export$f8462bcf03110eff);
$parcel$export(module.exports, "nextSSRDetect", () => $da3905a0dc1faf56$export$61c08ed144a5d4ca);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $da3905a0dc1faf56$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $i0jHL.windowExists)() && window["next"] && typeof window["next"] === "object";
}
function $da3905a0dc1faf56$export$61c08ed144a5d4ca() {
    return (0, $i0jHL.globalExists)() && ((0, $i0jHL.keyPrefixMatch)($parcel$global, "__next") || (0, $i0jHL.keyPrefixMatch)($parcel$global, "__NEXT"));
}

});

parcelRegister("7wUjf", function(module, exports) {

$parcel$export(module.exports, "nuxtWebDetect", () => $24fea5be4f379b80$export$bed54a4e6d9d25fb);
$parcel$export(module.exports, "nuxtSSRDetect", () => $24fea5be4f379b80$export$fb3ce982948d27e8);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $24fea5be4f379b80$export$bed54a4e6d9d25fb() {
    return (0, $i0jHL.windowExists)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $24fea5be4f379b80$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $i0jHL.globalExists)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}

});

parcelRegister("cZAgk", function(module, exports) {

$parcel$export(module.exports, "angularWebDetect", () => $f97e986d2a7067a7$export$b5a20bd39eb02ba0);
$parcel$export(module.exports, "angularSSRDetect", () => $f97e986d2a7067a7$export$8ab518c8987c870f);

var $i0jHL = parcelRequire("i0jHL");

var $hPtJY = parcelRequire("hPtJY");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $f97e986d2a7067a7$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $i0jHL.documentExists)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $i0jHL.windowExists)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $f97e986d2a7067a7$export$8ab518c8987c870f() {
    return (0, $i0jHL.processExists)() && typeof $hPtJY.env === "object" && undefined?.startsWith("ng ") || false;
}

});

parcelRegister("04Bbd", function(module, exports) {

$parcel$export(module.exports, "reactNativeDetect", () => $ea500a36684bbe73$export$1c8414c1859e3748);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $ea500a36684bbe73$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}

});

parcelRegister("cN0eS", function(module, exports) {

$parcel$export(module.exports, "expoDetect", () => $0b4145bd3be7264c$export$85fd46d5e29a4f7e);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $0b4145bd3be7264c$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $i0jHL.globalExists)() && typeof $parcel$global["expo"] !== "undefined";
}

});

parcelRegister("SrjZ5", function(module, exports) {

$parcel$export(module.exports, "webDetect", () => $86fec584d392e5dc$export$41b1270b988065fb);

var $i0jHL = parcelRequire("i0jHL");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $86fec584d392e5dc$export$41b1270b988065fb() {
    return (0, $i0jHL.windowExists)();
}

});



parcelRegister("lA3xE", function(module, exports) {

$parcel$export(module.exports, "getCustomUserAgent", () => $aeac22076f27cf78$export$e399dbcfd99a2928);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $aeac22076f27cf78$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $aeac22076f27cf78$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $aeac22076f27cf78$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $aeac22076f27cf78$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $aeac22076f27cf78$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $aeac22076f27cf78$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $aeac22076f27cf78$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($aeac22076f27cf78$var$customUserAgentState[input.category]).length) delete $aeac22076f27cf78$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $aeac22076f27cf78$export$e399dbcfd99a2928 = (category, api)=>$aeac22076f27cf78$var$customUserAgentState[category]?.[api]?.additionalDetails;

});



parcelRegister("6vbP8", function(module, exports) {

$parcel$export(module.exports, "composeServiceApi", () => $8099fb84e4081018$export$880429a8ae983d4d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8099fb84e4081018$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We may want to allow different endpoints from given config(other than region) and input.
        // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return await deserializer(response);
    };
};

});


parcelRegister("4P578", function(module, exports) {

$parcel$export(module.exports, "getRegion", () => $a3a3f70b2bd53451$export$d4a625cede2da71b);
$parcel$export(module.exports, "getRegionFromIdentityPoolId", () => $a3a3f70b2bd53451$export$8fb32fba519c460);

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a3a3f70b2bd53451$export$d4a625cede2da71b(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $b62N7.AuthError)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $a3a3f70b2bd53451$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $b62N7.AuthError)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}

});

parcelRegister("inqgD", function(module, exports) {

$parcel$export(module.exports, "formLoginsMap", () => $1f210c15c4cfce94$export$edfb13e85a2c0dc4);

var $bfiP6 = parcelRequire("bfiP6");

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1f210c15c4cfce94$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $bfiP6.decodeJWT)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $b62N7.AuthError)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    let domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}

});


parcelRegister("avjBi", function(module, exports) {

$parcel$export(module.exports, "getCredentialsForIdentity", () => $585cd79baee831be$export$a49c1c173ab96b58);

var $lL7zI = parcelRequire("lL7zI");


parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $7ecIZ = parcelRequire("7ecIZ");

var $bM38a = parcelRequire("bM38a");

var $6vbP8 = parcelRequire("6vbP8");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $585cd79baee831be$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $lL7zI.getSharedHeaders)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $lL7zI.buildHttpRpcRequest)(endpoint, headers, body);
};
const $585cd79baee831be$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $bM38a.parseJsonError)(response);
        throw error;
    } else {
        const body = await (0, $bM38a.parseJsonBody)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $585cd79baee831be$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $7ecIZ.parseMetadata)(response)
        };
    }
};
const $585cd79baee831be$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId, SecretKey: SecretKey, SessionToken: SessionToken, Expiration: Expiration } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $585cd79baee831be$export$a49c1c173ab96b58 = (0, $6vbP8.composeServiceApi)((0, $lL7zI.cognitoIdentityTransferHandler), $585cd79baee831be$var$getCredentialsForIdentitySerializer, $585cd79baee831be$var$getCredentialsForIdentityDeserializer, (0, $lL7zI.defaultConfig));

});

parcelRegister("kOfpC", function(module, exports) {

$parcel$export(module.exports, "assertIdTokenInAuthTokens", () => $611242aba31f7515$export$f4d99632f0717a4b);
$parcel$export(module.exports, "assertAuthTokensWithRefreshToken", () => $611242aba31f7515$export$be38b2d22222d505);

var $b62N7 = parcelRequire("b62N7");

var $cutI2 = parcelRequire("cutI2");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $611242aba31f7515$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $611242aba31f7515$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $611242aba31f7515$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $611242aba31f7515$export$31fce2aaeafa4b60 = new (0, $b62N7.AuthError)({
    name: (0, $cutI2.TOKEN_REFRESH_EXCEPTION),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $611242aba31f7515$export$35cfa8cbd2d5bcdd = new (0, $b62N7.AuthError)({
    name: (0, $cutI2.USER_UNAUTHENTICATED_EXCEPTION),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $611242aba31f7515$export$be38b2d22222d505(tokens) {
    if ($611242aba31f7515$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $611242aba31f7515$export$31fce2aaeafa4b60;
    if (!$611242aba31f7515$var$isAuthenticatedWithRefreshToken(tokens)) throw $611242aba31f7515$export$35cfa8cbd2d5bcdd;
}
function $611242aba31f7515$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $b62N7.AuthError)({
        name: (0, $cutI2.DEVICE_METADATA_NOT_FOUND_EXCEPTION),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $611242aba31f7515$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $611242aba31f7515$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $611242aba31f7515$var$isAuthenticatedWithRefreshToken(tokens) {
    return $611242aba31f7515$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $611242aba31f7515$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $611242aba31f7515$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}

});
parcelRegister("cutI2", function(module, exports) {

$parcel$export(module.exports, "USER_UNAUTHENTICATED_EXCEPTION", () => $5d443480af2ea56c$export$d29d1996d6b6f5e3);
$parcel$export(module.exports, "DEVICE_METADATA_NOT_FOUND_EXCEPTION", () => $5d443480af2ea56c$export$740e7000ac27ebf3);
$parcel$export(module.exports, "TOKEN_REFRESH_EXCEPTION", () => $5d443480af2ea56c$export$a0a904daf48e2c33);

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5d443480af2ea56c$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $5d443480af2ea56c$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $5d443480af2ea56c$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $5d443480af2ea56c$export$fe46a12932d2550a = "AutoSignInException";
const $5d443480af2ea56c$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $5d443480af2ea56c$export$60b68b138a52e5ae = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $5d443480af2ea56c$export$27ddc47447101bcf = "InvalidOriginException";
const $5d443480af2ea56c$export$c01b4acd6291e035 = new (0, $b62N7.AuthError)({
    name: $5d443480af2ea56c$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $5d443480af2ea56c$export$625255707e22459c = "OAuthSignOutException";
const $5d443480af2ea56c$export$a0a904daf48e2c33 = "TokenRefreshException";

});




parcelRegister("54W3M", function(module, exports) {

$parcel$export(module.exports, "cognitoUserPoolsTokenProvider", () => $f908ae8342f11964$export$18e158b80aac31a7);

var $cNsoR = parcelRequire("cNsoR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $f908ae8342f11964$export$18e158b80aac31a7 = new (0, $cNsoR.CognitoUserPoolsTokenProvider)();
const $f908ae8342f11964$export$66561e66d62991d0 = $f908ae8342f11964$export$18e158b80aac31a7.tokenOrchestrator;

});
parcelRegister("cNsoR", function(module, exports) {

$parcel$export(module.exports, "CognitoUserPoolsTokenProvider", () => $50ac27d44f503ae7$export$85b743bbda58cb6c);

var $57Of0 = parcelRequire("57Of0");

var $fNgI2 = parcelRequire("fNgI2");

var $029ov = parcelRequire("029ov");

var $8sJng = parcelRequire("8sJng");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $50ac27d44f503ae7$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $029ov.DefaultTokenStore)();
        this.authTokenStore.setKeyValueStorage((0, $57Of0.defaultStorage));
        this.tokenOrchestrator = new (0, $8sJng.TokenOrchestrator)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $fNgI2.refreshAuthTokens));
    }
    getTokens({ forceRefresh: forceRefresh } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.tokenOrchestrator.setWaitForInflightOAuth(waitForInflightOAuth);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}

});
parcelRegister("fNgI2", function(module, exports) {

$parcel$export(module.exports, "refreshAuthTokens", () => $ec8c93d7f96724a1$export$ab413c2cb4a135d9);

var $bfiP6 = parcelRequire("bfiP6");
var $fEpEV = parcelRequire("fEpEV");

var $7aXYh = parcelRequire("7aXYh");

var $4P578 = parcelRequire("4P578");

var $kOfpC = parcelRequire("kOfpC");

var $b62N7 = parcelRequire("b62N7");

var $7fUr4 = parcelRequire("7fUr4");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ec8c93d7f96724a1$var$refreshAuthTokensFunction = async ({ tokens: tokens, authConfig: authConfig, username: username })=>{
    (0, $bfiP6.assertTokenProviderConfig)(authConfig?.Cognito);
    const region = (0, $4P578.getRegion)(authConfig.Cognito.userPoolId);
    (0, $kOfpC.assertAuthTokensWithRefreshToken)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters["DEVICE_KEY"] = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $7fUr4.getUserContextData)({
        username: username,
        userPoolId: authConfig.Cognito.userPoolId,
        userPoolClientId: authConfig.Cognito.userPoolClientId
    });
    const { AuthenticationResult: AuthenticationResult } = await (0, $7aXYh.initiateAuth)({
        region: region
    }, {
        ClientId: authConfig?.Cognito?.userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $bfiP6.decodeJWT)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $bfiP6.decodeJWT)(AuthenticationResult.IdToken) : undefined;
    const iat = accessToken.payload.iat;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $b62N7.AuthError)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};
const $ec8c93d7f96724a1$export$ab413c2cb4a135d9 = (0, $fEpEV.deDupeAsyncFunction)($ec8c93d7f96724a1$var$refreshAuthTokensFunction);

});
parcelRegister("fEpEV", function(module, exports) {

$parcel$export(module.exports, "deDupeAsyncFunction", () => $f03ecb0e97a4a66d$export$cd8d22e3dc00ae5a);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $f03ecb0e97a4a66d$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise(async (resolve, reject)=>{
            try {
                const result = await asyncFunction(...args);
                resolve(result);
            } catch (error) {
                reject(error);
            } finally{
                inflightPromise = undefined;
            }
        });
        return inflightPromise;
    };
};

});

parcelRegister("7aXYh", function(module, exports) {

$parcel$export(module.exports, "initiateAuth", () => $77410195643a0033$export$567b0d5ec943f827);

var $6vbP8 = parcelRequire("6vbP8");

var $lNhjF = parcelRequire("lNhjF");

var $bM38a = parcelRequire("bM38a");

var $iNzmv = parcelRequire("iNzmv");

var $b62N7 = parcelRequire("b62N7");
const $77410195643a0033$var$buildUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = (0, $lNhjF.getSharedHeaders)(operation);
        const body = JSON.stringify(input);
        return (0, $lNhjF.buildHttpRpcRequest)(endpoint, headers, body);
    };
const $77410195643a0033$var$buildUserPoolDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $bM38a.parseJsonError)(response);
            (0, $iNzmv.assertServiceError)(error);
            throw new (0, $b62N7.AuthError)({
                name: error.name,
                message: error.message
            });
        } else {
            const body = await (0, $bM38a.parseJsonBody)(response);
            return body;
        }
    };
};
const $77410195643a0033$var$handleEmptyResponseDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $bM38a.parseJsonError)(response);
            (0, $iNzmv.assertServiceError)(error);
            throw new (0, $b62N7.AuthError)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };
};
const $77410195643a0033$export$567b0d5ec943f827 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("InitiateAuth"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$2428f6ba65615593 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("RevokeToken"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$cf64224bcd829024 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("SignUp"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$2ce39ab6662e8c24 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ConfirmSignUp"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$66791fb2cfeec3e = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ForgotPassword"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$c7a5d0826ce3a2b2 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ConfirmForgotPassword"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$b196467a22b300ec = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("RespondToAuthChallenge"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$f24137cafeaef1a1 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ResendConfirmationCode"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$72b1124e126ff51c = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("VerifySoftwareToken"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$4531a27964554be8 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("AssociateSoftwareToken"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$b6a1b2cc7e7e6b1e = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("SetUserMFAPreference"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$7cbf767827cd68ba = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("GetUser"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$99d837dc30eb1ef7 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ChangePassword"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$3a7ad63dc35b752f = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ConfirmDevice"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$d0b7632b5e5fb312 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ForgetDevice"), $77410195643a0033$var$handleEmptyResponseDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$7d0f10f273c0438a = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("DeleteUser"), $77410195643a0033$var$handleEmptyResponseDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$3a9721eaccd0e7b3 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("GetUserAttributeVerificationCode"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$a92c2ab9b6303723 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("GlobalSignOut"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$16ff8cb4f547be0 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("UpdateUserAttributes"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$40fc6c986f86e9a5 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("VerifyUserAttribute"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$e1c4af6b7c9755a8 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("UpdateDeviceStatus"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$11154f886a75108 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("ListDevices"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));
const $77410195643a0033$export$a97f0f1c87d00e1 = (0, $6vbP8.composeServiceApi)((0, $lNhjF.cognitoUserPoolTransferHandler), $77410195643a0033$var$buildUserPoolSerializer("DeleteUserAttributes"), $77410195643a0033$var$buildUserPoolDeserializer(), (0, $lNhjF.defaultConfig));

});
parcelRegister("lNhjF", function(module, exports) {

$parcel$export(module.exports, "cognitoUserPoolTransferHandler", () => $fe4e6ba99be63312$export$10f11e95d7a96f7b);
$parcel$export(module.exports, "defaultConfig", () => $fe4e6ba99be63312$export$f84bd70098573c5c);
$parcel$export(module.exports, "getSharedHeaders", () => $fe4e6ba99be63312$export$a46bbeaba09f7285);
$parcel$export(module.exports, "buildHttpRpcRequest", () => $fe4e6ba99be63312$export$a692bdb7eb624f96);

var $1qbEC = parcelRequire("1qbEC");

var $fqhqt = parcelRequire("fqhqt");
var $4ZD6k = parcelRequire("4ZD6k");
var $5D9nd = parcelRequire("5D9nd");
var $bM38a = parcelRequire("bM38a");
var $itEnq = parcelRequire("itEnq");

var $7Ar4G = parcelRequire("7Ar4G");
var $dj9FS = parcelRequire("dj9FS");

var $8e8Xp = parcelRequire("8e8Xp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $fe4e6ba99be63312$var$SERVICE_NAME = "cognito-idp";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $fe4e6ba99be63312$var$endpointResolver = ({ region: region })=>{
    const authConfig = (0, $1qbEC.Amplify).getConfig().Auth?.Cognito;
    const customURL = authConfig?.userPoolEndpoint;
    const defaultURL = new (0, $7Ar4G.AmplifyUrl)(`https://${$fe4e6ba99be63312$var$SERVICE_NAME}.${region}.${(0, $fqhqt.getDnsSuffix)(region)}`);
    return {
        url: customURL ? new (0, $7Ar4G.AmplifyUrl)(customURL) : defaultURL
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $fe4e6ba99be63312$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $fe4e6ba99be63312$export$10f11e95d7a96f7b = (0, $8e8Xp.composeTransferHandler)((0, $itEnq.unauthenticatedHandler), [
    $fe4e6ba99be63312$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $fe4e6ba99be63312$export$f84bd70098573c5c = {
    service: $fe4e6ba99be63312$var$SERVICE_NAME,
    endpointResolver: $fe4e6ba99be63312$var$endpointResolver,
    retryDecider: (0, $4ZD6k.getRetryDecider)((0, $bM38a.parseJsonError)),
    computeDelay: (0, $5D9nd.jitteredBackoff),
    userAgentValue: (0, $dj9FS.getAmplifyUserAgent)(),
    cache: "no-store"
};
/**
 * @internal
 */ const $fe4e6ba99be63312$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
/**
 * @internal
 */ const $fe4e6ba99be63312$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });

});

parcelRegister("iNzmv", function(module, exports) {

$parcel$export(module.exports, "assertServiceError", () => $97dc54107f586751$export$5b3890f50cd4853f);

var $b62N7 = parcelRequire("b62N7");

var $8rSHg = parcelRequire("8rSHg");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $97dc54107f586751$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $b62N7.AuthError)({
        name: (0, $8rSHg.AmplifyErrorCode).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}

});


parcelRegister("7fUr4", function(module, exports) {

$parcel$export(module.exports, "getUserContextData", () => $166ed226583428f1$export$b6e6cdd1f90faa62);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $166ed226583428f1$export$b6e6cdd1f90faa62({ username: username, userPoolId: userPoolId, userPoolClientId: userPoolClientId }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}

});


parcelRegister("8sJng", function(module, exports) {

$parcel$export(module.exports, "TokenOrchestrator", () => $67be88f695aa02a6$export$ba2f3fbc8979d2e6);

var $5RCQ5 = parcelRequire("5RCQ5");

var $5RCQ5 = parcelRequire("5RCQ5");
var $bfiP6 = parcelRequire("bfiP6");
var $hMbLp = parcelRequire("hMbLp");

var $iNzmv = parcelRequire("iNzmv");

var $b62N7 = parcelRequire("b62N7");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $67be88f695aa02a6$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = async ()=>{};
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.waitForInflightOAuth = waitForInflightOAuth;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $b62N7.AuthError)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $b62N7.AuthError)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $bfiP6.assertTokenProviderConfig)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $hMbLp.isTokenExpired)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $hMbLp.isTokenExpired)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username }) {
        try {
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            await this.setTokens({
                tokens: newTokens
            });
            (0, $5RCQ5.Hub).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $5RCQ5.AMPLIFY_SYMBOL));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $iNzmv.assertServiceError)(err);
        if (err.message !== "Network error") // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $5RCQ5.Hub).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $5RCQ5.AMPLIFY_SYMBOL));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
}

});




parcelRegister("l8biK", function(module, exports) {

$parcel$export(module.exports, "generateClient", () => $f4242ff18250f860$export$46dced0a73bfb171);

var $f979g = parcelRequire("f979g");

var $1qbEC = parcelRequire("1qbEC");
/**
 * Generates an API client that can work with models or raw GraphQL
 */ function $f4242ff18250f860$export$46dced0a73bfb171(options = {}) {
    return (0, $f979g.generateClient)({
        ...options,
        amplify: (0, $1qbEC.Amplify)
    });
}

});
parcelRegister("f979g", function(module, exports) {

$parcel$export(module.exports, "generateClient", () => $d8005fae3431ff04$export$46dced0a73bfb171);

var $yL58Q = parcelRequire("yL58Q");

var $8cam8 = parcelRequire("8cam8");

var $lvJDy = parcelRequire("lvJDy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 *
 * Creates a client that can be used to make GraphQL requests, using a provided `AmplifyClassV6`
 * compatible context object for config and auth fetching.
 *
 * @param params
 * @returns
 */ function $d8005fae3431ff04$export$46dced0a73bfb171(params) {
    const client = {
        [(0, $lvJDy.__amplify)]: params.amplify,
        [(0, $lvJDy.__authMode)]: params.authMode,
        [(0, $lvJDy.__authToken)]: params.authToken,
        [(0, $lvJDy.__headers)]: params.headers,
        graphql: $yL58Q.graphql,
        cancel: $yL58Q.cancel,
        isCancelError: $yL58Q.isCancelError,
        models: {}
    };
    client.models = (0, $8cam8.generateModelsProperty)(client, params);
    return client;
}

});
parcelRegister("yL58Q", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $df8eeec06c50fd24$export$1eb4e7c0ed67b035);
$parcel$export(module.exports, "cancel", () => $df8eeec06c50fd24$export$70b61ad426ddbe54);
$parcel$export(module.exports, "isCancelError", () => $df8eeec06c50fd24$export$a88a1555052550c7);

var $jmbrF = parcelRequire("jmbrF");

var $lvJDy = parcelRequire("lvJDy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Invokes graphql operations against a graphql service, providing correct input and
 * output types if Amplify-generated graphql from a recent version of the CLI/codegen
 * are used *or* correct typing is provided via the type argument.
 *
 * Amplify-generated "branded" graphql queries will look similar to this:
 *
 * ```ts
 *                               //
 *                               // |-- branding
 *                               // v
 * export const getModel = `...` as GeneratedQuery<
 * 	GetModelQueryVariables,
 * 	GetModelQuery
 * >;
 * ```
 *
 * If this branding is not in your generated graphql, update to a newer version of
 * CLI/codegen and regenerate your graphql using `amplify codegen`.
 *
 * ## Using Amplify-generated graphql
 *
 * ```ts
 * import * as queries from './graphql/queries';
 *
 * //
 * //    |-- correctly typed graphql response containing a Widget
 * //    v
 * const queryResult = await graphql({
 * 	query: queries.getWidget,
 * 	variables: {
 * 		id: "abc", // <-- type hinted/enforced
 * 	},
 * });
 *
 * //
 * //    |-- a correctly typed Widget
 * //    v
 * const fetchedWidget = queryResult.data?.getWidget!;
 * ```
 *
 * ## Custom input + result types
 *
 * To provide input types (`variables`) and result types:
 *
 * ```ts
 * type GetById_NameOnly = {
 * 	variables: {
 * 		id: string
 * 	},
 * 	result: Promise<{
 * 		data: { getWidget: { name: string } }
 * 	}>
 * }
 *
 * //
 * //    |-- type is GetById_NameOnly["result"]
 * //    v
 * const result = graphql<GetById_NameOnly>({
 * 	query: "...",
 * 	variables: { id: "abc" }  // <-- type of GetById_NameOnly["variables"]
 * });
 * ```
 *
 * ## Custom result type only
 *
 * To specify result types only, use a type that is *not* in the `{variables, result}` shape:
 *
 * ```ts
 * type MyResultType = Promise<{
 * 	data: {
 * 		getWidget: { name: string }
 * 	}
 * }>
 *
 * //
 * //    |-- type is MyResultType
 * //    v
 * const result = graphql<MyResultType>({query: "..."});
 * ```
 *
 * @param options
 * @param additionalHeaders
 */ function $df8eeec06c50fd24$export$1eb4e7c0ed67b035(options, additionalHeaders) {
    // inject client-level auth 
    options.authMode = options.authMode || this[0, $lvJDy.__authMode];
    options.authToken = options.authToken || this[0, $lvJDy.__authToken];
    /**
     * The correctness of these typings depends on correct string branding or overrides.
     * Neither of these can actually be validated at runtime. Hence, we don't perform
     * any validation or type-guarding here.
     */ const result = (0, $jmbrF.GraphQLAPI).graphql(this[0, $lvJDy.__amplify], options, additionalHeaders);
    return result;
}
/**
 * Cancels an inflight request. Only applicable for graphql queries and mutations
 * @param {any} request - request to cancel
 * @returns - A boolean indicating if the request was cancelled
 */ function $df8eeec06c50fd24$export$70b61ad426ddbe54(promise, message) {
    return (0, $jmbrF.GraphQLAPI).cancel(promise, message);
}
/**
 * Checks to see if an error thrown is from an api request cancellation
 * @param {any} error - Any error
 * @returns - A boolean indicating if the error was from an api request cancellation
 */ function $df8eeec06c50fd24$export$a88a1555052550c7(error) {
    return (0, $jmbrF.GraphQLAPI).isCancelError(error);
}

});
parcelRegister("jmbrF", function(module, exports) {

$parcel$export(module.exports, "GraphQLAPI", () => $e0980bc58fdd67fa$export$6572ab1b3fe6697f);

var $k2DuP = parcelRequire("k2DuP");

var $cGZt7 = parcelRequire("cGZt7");
const $e0980bc58fdd67fa$export$78930a3b816845f9 = (query, variables = {}, authToken)=>({
        query: query,
        variables: variables,
        authToken: authToken
    });
/**
 * Export Cloud Logic APIs
 */ class $e0980bc58fdd67fa$export$e32503f9802a56ee extends (0, $cGZt7.InternalGraphQLAPIClass) {
    getModuleName() {
        return "GraphQLAPI";
    }
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ graphql(amplify, options, additionalHeaders) {
        return super.graphql(amplify, options, additionalHeaders, {
            category: (0, $k2DuP.Category).API,
            action: (0, $k2DuP.ApiAction).GraphQl
        });
    }
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @returns A boolean indicating if the error was from an api request cancellation
     */ isCancelError(error) {
        return super.isCancelError(error);
    }
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @returns A boolean indicating if the request was cancelled
     */ cancel(request, message) {
        return super.cancel(request, message);
    }
}
const $e0980bc58fdd67fa$export$6572ab1b3fe6697f = new $e0980bc58fdd67fa$export$e32503f9802a56ee();

});
parcelRegister("cGZt7", function(module, exports) {

$parcel$export(module.exports, "InternalGraphQLAPIClass", () => $417d5886f54fa8b9$export$c3e852ee609522ad);

var $fHcz3 = parcelRequire("fHcz3");
var $8DJ2k = parcelRequire("8DJ2k");
var $3o9dz = parcelRequire("3o9dz");

var $fT695 = parcelRequire("fT695");

var $gJw02 = parcelRequire("gJw02");

var $7Ar4G = parcelRequire("7Ar4G");
var $dj9FS = parcelRequire("dj9FS");

var $lvJDy = parcelRequire("lvJDy");
parcelRequire("LTBY8");
var $3Qiot = parcelRequire("3Qiot");
parcelRequire("dOmJe");
var $cfOsN = parcelRequire("cfOsN");
var $dOmJe = parcelRequire("dOmJe");

var $99ZQ7 = parcelRequire("99ZQ7");

var $4un4F = parcelRequire("4un4F");

var $2bSZt = parcelRequire("2bSZt");

var $027iw = parcelRequire("027iw");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $417d5886f54fa8b9$var$USER_AGENT_HEADER = "x-amz-user-agent";
new (0, $gJw02.ConsoleLogger)("GraphQLAPI");
const $417d5886f54fa8b9$var$isAmplifyInstance = (amplify)=>{
    return typeof amplify !== "function";
};
/**
 * Export Cloud Logic APIs
 */ class $417d5886f54fa8b9$export$c3e852ee609522ad {
    constructor(){
        /**
         * @private
         */ this.appSyncRealTime = new (0, $99ZQ7.AWSAppSyncRealTimeProvider)();
        this._api = {
            post: $dOmJe.post,
            cancelREST: (0, $cfOsN.cancel),
            isCancelErrorREST: (0, $3Qiot.isCancelError),
            updateRequestToBeCancellable: $cfOsN.updateRequestToBeCancellable
        };
    }
    getModuleName() {
        return "InternalGraphQLAPI";
    }
    async _headerBasedAuth(amplify, authMode, additionalHeaders = {}) {
        const { region: region, endpoint: appSyncGraphqlEndpoint, apiKey: apiKey } = (0, $4un4F.resolveConfig)(amplify);
        let headers = {};
        switch(authMode){
            case "apiKey":
                if (!apiKey) throw new Error((0, $lvJDy.GraphQLAuthError).NO_API_KEY);
                headers = {
                    "X-Api-Key": apiKey
                };
                break;
            case "iam":
                const session = await amplify.Auth.fetchAuthSession();
                if (session.credentials === undefined) throw new Error((0, $lvJDy.GraphQLAuthError).NO_CREDENTIALS);
                break;
            case "oidc":
            case "userPool":
                try {
                    let token;
                    token = (await amplify.Auth.fetchAuthSession()).tokens?.accessToken.toString();
                    if (!token) throw new Error((0, $lvJDy.GraphQLAuthError).NO_FEDERATED_JWT);
                    headers = {
                        Authorization: token
                    };
                } catch (e) {
                    throw new Error((0, $lvJDy.GraphQLAuthError).NO_CURRENT_USER);
                }
                break;
            case "lambda":
                if (typeof additionalHeaders === "object" && !additionalHeaders.Authorization) throw new Error((0, $lvJDy.GraphQLAuthError).NO_AUTH_TOKEN);
                headers = {
                    Authorization: additionalHeaders.Authorization
                };
                break;
        }
        return headers;
    }
    /**
     * to get the operation type
     * @param operation
     */ getGraphqlOperationType(operation) {
        const doc = (0, $8DJ2k.parse)(operation);
        const definitions = doc.definitions;
        const [{ operation: operationType }] = definitions;
        return operationType;
    }
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `libraryConfigHeaders` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ graphql(amplify, { query: paramQuery, variables: variables = {}, authMode: authMode, authToken: authToken }, additionalHeaders, customUserAgentDetails) {
        const query = typeof paramQuery === "string" ? (0, $8DJ2k.parse)(paramQuery) : (0, $8DJ2k.parse)((0, $3o9dz.print)(paramQuery));
        const [operationDef = {}] = query.definitions.filter((def)=>def.kind === "OperationDefinition");
        const { operation: operationType } = operationDef;
        const headers = additionalHeaders || {};
        switch(operationType){
            case "query":
            case "mutation":
                const abortController = new AbortController();
                let responsePromise;
                if ($417d5886f54fa8b9$var$isAmplifyInstance(amplify)) responsePromise = this._graphql(amplify, {
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, abortController, customUserAgentDetails, authToken);
                else {
                    const wrapper = (amplifyInstance)=>this._graphql(amplifyInstance, {
                            query: query,
                            variables: variables,
                            authMode: authMode
                        }, headers, abortController, customUserAgentDetails, authToken);
                    responsePromise = amplify(wrapper);
                }
                this._api.updateRequestToBeCancellable(responsePromise, abortController);
                return responsePromise;
            case "subscription":
                return this._graphqlSubscribe(amplify, {
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, customUserAgentDetails, authToken);
            default:
                throw new Error(`invalid operation type: ${operationType}`);
        }
    }
    async _graphql(amplify, { query: query, variables: variables, authMode: explicitAuthMode }, additionalHeaders = {}, abortController, customUserAgentDetails, authToken) {
        const { region: region, endpoint: appSyncGraphqlEndpoint, customEndpoint: customEndpoint, customEndpointRegion: customEndpointRegion, defaultAuthMode: defaultAuthMode } = (0, $4un4F.resolveConfig)(amplify);
        const authMode = explicitAuthMode || defaultAuthMode || "iam";
        /**
         * Retrieve library options from Amplify configuration.
         * `customHeaders` here are from the Amplify configuration options,
         * and are for non-AppSync endpoints only. These are *not* the same as
         * `additionalHeaders`, which are custom headers that are either 1)
         * included when configuring the API client or 2) passed along with
         * individual requests.
         */ const { headers: customHeaders, withCredentials: withCredentials } = (0, $2bSZt.resolveLibraryOptions)(amplify);
        /**
         * Client or request-specific custom headers that may or may not be
         * returned by a function:
         */ let additionalCustomHeaders;
        if (typeof additionalHeaders === "function") {
            const requestOptions = {
                method: "POST",
                url: new (0, $7Ar4G.AmplifyUrl)(customEndpoint || appSyncGraphqlEndpoint || "").toString(),
                queryString: (0, $3o9dz.print)(query)
            };
            additionalCustomHeaders = await additionalHeaders(requestOptions);
        } else additionalCustomHeaders = additionalHeaders;
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) additionalCustomHeaders = {
            ...additionalCustomHeaders,
            Authorization: authToken
        };
        // TODO: Figure what we need to do to remove `!`'s.
        const headers = {
            ...!customEndpoint && await this._headerBasedAuth(amplify, authMode, additionalCustomHeaders),
            /**
             * Custom endpoint headers.
             * If there is both a custom endpoint and custom region present, we get the headers.
             * If there is a custom endpoint but no region, we return an empty object.
             * If neither are present, we return an empty object.
             */ ...customEndpoint && (customEndpointRegion ? await this._headerBasedAuth(amplify, authMode, additionalCustomHeaders) : {}) || {},
            // Custom headers included in Amplify configuration options:
            ...customHeaders && await customHeaders({
                query: (0, $3o9dz.print)(query),
                variables: variables
            }),
            // Custom headers from individual requests or API client configuration:
            ...additionalCustomHeaders,
            // User agent headers:
            ...!customEndpoint && {
                [$417d5886f54fa8b9$var$USER_AGENT_HEADER]: (0, $dj9FS.getAmplifyUserAgent)(customUserAgentDetails)
            }
        };
        const body = {
            query: (0, $3o9dz.print)(query),
            variables: variables || null
        };
        let signingServiceInfo;
        /**
         * We do not send the signing service info to the REST API under the
         * following conditions (i.e. it will not sign the request):
         *   - there is a custom endpoint but no region
         *   - the auth mode is `none`, or `apiKey`
         *   - the auth mode is a type other than the types listed below
         */ if (customEndpoint && !customEndpointRegion || authMode !== "oidc" && authMode !== "userPool" && authMode !== "iam" && authMode !== "lambda") signingServiceInfo = undefined;
        else signingServiceInfo = {
            service: !customEndpointRegion ? "appsync" : "execute-api",
            region: !customEndpointRegion ? region : customEndpointRegion
        };
        const endpoint = customEndpoint || appSyncGraphqlEndpoint;
        if (!endpoint) {
            const error = new (0, $fHcz3.GraphQLError)("No graphql endpoint provided.");
            throw {
                data: {},
                errors: [
                    error
                ]
            };
        }
        let response;
        try {
            const { body: responseBody } = await this._api.post({
                url: new (0, $7Ar4G.AmplifyUrl)(endpoint),
                options: {
                    headers: headers,
                    body: body,
                    signingServiceInfo: signingServiceInfo,
                    withCredentials: withCredentials
                },
                abortController: abortController
            });
            const result = await responseBody.json();
            response = result;
        } catch (err) {
            // If the exception is because user intentionally
            // cancelled the request, do not modify the exception
            // so that clients can identify the exception correctly.
            if (this.isCancelError(err)) throw err;
            response = {
                data: {},
                errors: [
                    new (0, $fHcz3.GraphQLError)(err.message, null, null, null, null, err)
                ]
            };
        }
        const { errors: errors } = response;
        if (errors && errors.length) throw (0, $027iw.repackageUnauthError)(response);
        return response;
    }
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ isCancelError(error) {
        return this._api.isCancelErrorREST(error);
    }
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @returns - A boolean indicating if the request was cancelled
     */ cancel(request, message) {
        return this._api.cancelREST(request, message);
    }
    _graphqlSubscribe(amplify, { query: query, variables: variables, authMode: authMode }, additionalHeaders = {}, customUserAgentDetails, authToken) {
        const config = (0, $4un4F.resolveConfig)(amplify);
        /**
         * Retrieve library options from Amplify configuration.
         * `libraryConfigHeaders` are from the Amplify configuration options,
         * and will not be overwritten by other custom headers. These are *not*
         * the same as `additionalHeaders`, which are custom headers that are
         * either 1)included when configuring the API client or 2) passed along
         * with individual requests.
         */ const { headers: libraryConfigHeaders } = (0, $2bSZt.resolveLibraryOptions)(amplify);
        return this.appSyncRealTime.subscribe({
            query: (0, $3o9dz.print)(query),
            variables: variables,
            appSyncGraphqlEndpoint: config?.endpoint,
            region: config?.region,
            authenticationType: authMode || config?.defaultAuthMode,
            apiKey: config?.apiKey,
            additionalHeaders: additionalHeaders,
            authToken: authToken,
            libraryConfigHeaders: libraryConfigHeaders
        }, customUserAgentDetails).pipe((0, $fT695.catchError)((e)=>{
            if (e.errors) throw (0, $027iw.repackageUnauthError)(e);
            throw e;
        }));
    }
}
const $417d5886f54fa8b9$export$ed344e8d198d4142 = new $417d5886f54fa8b9$export$c3e852ee609522ad();

});
parcelRegister("fHcz3", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $52f13d37c0305dc6$export$92d6ed0888e7cb7f);

var $cryJ5 = parcelRequire("cryJ5");

var $6Kxrr = parcelRequire("6Kxrr");

var $8hTIi = parcelRequire("8hTIi");

var $2snEf = parcelRequire("2snEf");
function $52f13d37c0305dc6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $52f13d37c0305dc6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $52f13d37c0305dc6$var$_typeof(obj);
}
function $52f13d37c0305dc6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52f13d37c0305dc6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $52f13d37c0305dc6$var$ownKeys(Object(source), true).forEach(function(key) {
            $52f13d37c0305dc6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $52f13d37c0305dc6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52f13d37c0305dc6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $52f13d37c0305dc6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52f13d37c0305dc6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $52f13d37c0305dc6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $52f13d37c0305dc6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $52f13d37c0305dc6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $52f13d37c0305dc6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $52f13d37c0305dc6$var$_setPrototypeOf(subClass, superClass);
}
function $52f13d37c0305dc6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $52f13d37c0305dc6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $52f13d37c0305dc6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $52f13d37c0305dc6$var$_possibleConstructorReturn(this, result);
    };
}
function $52f13d37c0305dc6$var$_possibleConstructorReturn(self, call) {
    if (call && ($52f13d37c0305dc6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $52f13d37c0305dc6$var$_assertThisInitialized(self);
}
function $52f13d37c0305dc6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $52f13d37c0305dc6$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $52f13d37c0305dc6$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$52f13d37c0305dc6$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $52f13d37c0305dc6$var$_construct(Class, arguments, $52f13d37c0305dc6$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $52f13d37c0305dc6$var$_setPrototypeOf(Wrapper, Class);
    };
    return $52f13d37c0305dc6$var$_wrapNativeSuper(Class);
}
function $52f13d37c0305dc6$var$_construct(Parent, args, Class) {
    if ($52f13d37c0305dc6$var$_isNativeReflectConstruct()) $52f13d37c0305dc6$var$_construct = Reflect.construct;
    else $52f13d37c0305dc6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $52f13d37c0305dc6$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $52f13d37c0305dc6$var$_construct.apply(null, arguments);
}
function $52f13d37c0305dc6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $52f13d37c0305dc6$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $52f13d37c0305dc6$var$_setPrototypeOf(o, p) {
    $52f13d37c0305dc6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $52f13d37c0305dc6$var$_setPrototypeOf(o, p);
}
function $52f13d37c0305dc6$var$_getPrototypeOf(o) {
    $52f13d37c0305dc6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $52f13d37c0305dc6$var$_getPrototypeOf(o);
}
var $52f13d37c0305dc6$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $52f13d37c0305dc6$var$_inherits(GraphQLError, _Error);
    var _super = $52f13d37c0305dc6$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $52f13d37c0305dc6$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $8hTIi.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $8hTIi.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cryJ5.default)(originalExtensions)) _this.extensions = $52f13d37c0305dc6$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($52f13d37c0305dc6$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $52f13d37c0305dc6$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($52f13d37c0305dc6$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($52f13d37c0305dc6$var$_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $52f13d37c0305dc6$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $52f13d37c0305dc6$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6Kxrr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $52f13d37c0305dc6$var$_wrapNativeSuper(Error));
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, $2snEf.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, $2snEf.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("cryJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f419306d4be7fb23$export$2e2bcd8739ae039);
function $f419306d4be7fb23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f419306d4be7fb23$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f419306d4be7fb23$var$_typeof(obj);
}
function $f419306d4be7fb23$export$2e2bcd8739ae039(value) {
    return $f419306d4be7fb23$var$_typeof(value) == "object" && value !== null;
}

});

parcelRegister("6Kxrr", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $38898675a98013dc$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$f6cdee3c26d6da57 = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $38898675a98013dc$export$8d0083df0471478e = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $38898675a98013dc$export$5deadc579ccc7c9c = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

});

parcelRegister("8hTIi", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $151337c9f32f7005$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("2snEf", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $a45c53fbf464b798$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $a45c53fbf464b798$export$867940333fd9f869);

var $8hTIi = parcelRequire("8hTIi");
function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $8hTIi.getLocation)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $a45c53fbf464b798$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                $a45c53fbf464b798$var$whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $a45c53fbf464b798$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $a45c53fbf464b798$var$leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $a45c53fbf464b798$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $a45c53fbf464b798$var$leftPad(len, str) {
    return $a45c53fbf464b798$var$whitespace(len - str.length) + str;
}

});


parcelRegister("8DJ2k", function(module, exports) {

$parcel$export(module.exports, "parse", () => $0013c7ab45cf197d$export$98e6a39c04603d36);

var $egTVJ = parcelRequire("egTVJ");

var $hu3w4 = parcelRequire("hu3w4");

var $8r1qs = parcelRequire("8r1qs");

var $bQgNI = parcelRequire("bQgNI");

var $1i7FZ = parcelRequire("1i7FZ");

var $5zW8K = parcelRequire("5zW8K");

var $dtMcr = parcelRequire("dtMcr");
function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    var parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return type;
}
var $0013c7ab45cf197d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $1i7FZ.isSource)(source) ? source : new (0, $1i7FZ.Source)(source);
        this._lexer = new (0, $dtMcr.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $bQgNI.TokenKind).NAME);
        return {
            kind: (0, $hu3w4.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).DOCUMENT,
            definitions: this.many((0, $bQgNI.TokenKind).SOF, this.parseDefinition, (0, $bQgNI.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $bQgNI.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $bQgNI.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $bQgNI.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $bQgNI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).DOLLAR);
        return {
            kind: (0, $hu3w4.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).SELECTION_SET,
            selections: this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseSelection, (0, $bQgNI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $bQgNI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $hu3w4.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $bQgNI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, item, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return {
            kind: (0, $hu3w4.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $bQgNI.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $bQgNI.TokenKind).NAME)) return {
            kind: (0, $hu3w4.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $hu3w4.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $bQgNI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $bQgNI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $bQgNI.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $hu3w4.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $bQgNI.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $hu3w4.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $bQgNI.TokenKind).STRING:
            case (0, $bQgNI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $bQgNI.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, $hu3w4.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $hu3w4.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $bQgNI.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $hu3w4.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $bQgNI.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $hu3w4.Kind).LIST,
            values: this.any((0, $bQgNI.TokenKind).BRACKET_L, item, (0, $bQgNI.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $hu3w4.Kind).OBJECT,
            fields: this.any((0, $bQgNI.TokenKind).BRACE_L, item, (0, $bQgNI.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return {
            kind: (0, $hu3w4.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $bQgNI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).AT);
        return {
            kind: (0, $hu3w4.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $bQgNI.TokenKind).BRACKET_R);
            type = {
                kind: (0, $hu3w4.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BANG)) return {
            kind: (0, $hu3w4.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $hu3w4.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $bQgNI.TokenKind).STRING) || this.peek((0, $bQgNI.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        return {
            kind: (0, $hu3w4.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $hu3w4.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $bQgNI.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $bQgNI.TokenKind).AMP) || this.peek((0, $bQgNI.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $bQgNI.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $bQgNI.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $bQgNI.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $hu3w4.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $hu3w4.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $bQgNI.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $hu3w4.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5zW8K.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $8r1qs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, "Expected ".concat($0013c7ab45cf197d$var$getTokenKindDesc(kind), ", found ").concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $egTVJ.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($0013c7ab45cf197d$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    var value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $dtMcr.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

});
parcelRegister("egTVJ", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $ddf6b9f696b0d6b2$export$bbee0c6176c019d4);

var $fHcz3 = parcelRequire("fHcz3");
function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $fHcz3.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});

parcelRegister("hu3w4", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $b7b8db97a7d116fe$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("8r1qs", function(module, exports) {

$parcel$export(module.exports, "Location", () => $11b06753ce50693f$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $11b06753ce50693f$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $11b06753ce50693f$export$8ee0fc9ee280b4ee);

var $hnUO7 = parcelRequire("hnUO7");
var $11b06753ce50693f$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $hnUO7.default)($11b06753ce50693f$export$18a2be9195644f38);
var $11b06753ce50693f$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $hnUO7.default)($11b06753ce50693f$export$50792b0e93539fde);
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("hnUO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a8edb1a7f74fed$export$2e2bcd8739ae039);

var $l3zHt = parcelRequire("l3zHt");

var $7qP7Z = parcelRequire("7qP7Z");
function $79a8edb1a7f74fed$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $l3zHt.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7qP7Z.default) classObject.prototype[0, $7qP7Z.default] = fn;
}

});
parcelRegister("l3zHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0989dd6156f69013$export$2e2bcd8739ae039);
function $0989dd6156f69013$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});

parcelRegister("7qP7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a3e222a9fb30c4$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $d7a3e222a9fb30c4$export$2e2bcd8739ae039 = $d7a3e222a9fb30c4$var$nodejsCustomInspectSymbol;

});



parcelRegister("bQgNI", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $ac240aaa94caf15d$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("1i7FZ", function(module, exports) {

$parcel$export(module.exports, "Source", () => $1ff584847d3a412c$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $1ff584847d3a412c$export$75135ee9ed6e435b);

var $6Kxrr = parcelRequire("6Kxrr");

var $gHwk7 = parcelRequire("gHwk7");

var $lDltR = parcelRequire("lDltR");

var $7NKAi = parcelRequire("7NKAi");
function $1ff584847d3a412c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1ff584847d3a412c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1ff584847d3a412c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1ff584847d3a412c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $1ff584847d3a412c$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, $lDltR.default)(0, "Body must be a string. Received: ".concat((0, $gHwk7.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $lDltR.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $lDltR.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $1ff584847d3a412c$var$_createClass(Source, [
        {
            key: (0, $6Kxrr.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $7NKAi.default)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}

});
parcelRegister("gHwk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9541a54af6a37409$export$2e2bcd8739ae039);

var $7qP7Z = parcelRequire("7qP7Z");
function $9541a54af6a37409$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9541a54af6a37409$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9541a54af6a37409$var$_typeof(obj);
}
var $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
var $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$2e2bcd8739ae039(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch($9541a54af6a37409$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $9541a54af6a37409$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $9541a54af6a37409$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[" + $9541a54af6a37409$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $9541a54af6a37409$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $9541a54af6a37409$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7qP7Z.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $9541a54af6a37409$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("lDltR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8beb5260c793fc92$export$2e2bcd8739ae039);
function $8beb5260c793fc92$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("7NKAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44107310810d751$export$2e2bcd8739ae039);

function $c44107310810d751$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c44107310810d751$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c44107310810d751$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c44107310810d751$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$c44107310810d751$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5zW8K", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $289bf729a82494c6$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("dtMcr", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $971bc50063303b32$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $971bc50063303b32$export$59ac0f4da287406a);

var $egTVJ = parcelRequire("egTVJ");

var $8r1qs = parcelRequire("8r1qs");

var $bQgNI = parcelRequire("bQgNI");

var $7tbLu = parcelRequire("7tbLu");
var $971bc50063303b32$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $bQgNI.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $971bc50063303b32$var$readToken(this, token);
        }while (token.kind === (0, $bQgNI.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $bQgNI.TokenKind).BANG || kind === (0, $bQgNI.TokenKind).DOLLAR || kind === (0, $bQgNI.TokenKind).AMP || kind === (0, $bQgNI.TokenKind).PAREN_L || kind === (0, $bQgNI.TokenKind).PAREN_R || kind === (0, $bQgNI.TokenKind).SPREAD || kind === (0, $bQgNI.TokenKind).COLON || kind === (0, $bQgNI.TokenKind).EQUALS || kind === (0, $bQgNI.TokenKind).AT || kind === (0, $bQgNI.TokenKind).BRACKET_L || kind === (0, $bQgNI.TokenKind).BRACKET_R || kind === (0, $bQgNI.TokenKind).BRACE_L || kind === (0, $bQgNI.TokenKind).PIPE || kind === (0, $bQgNI.TokenKind).BRACE_R;
}
function $971bc50063303b32$var$printCharCode(code) {
    return isNaN(code) ? (0, $bQgNI.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $971bc50063303b32$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $971bc50063303b32$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $971bc50063303b32$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $971bc50063303b32$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $971bc50063303b32$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $egTVJ.syntaxError)(source, pos, $971bc50063303b32$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $971bc50063303b32$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($971bc50063303b32$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($971bc50063303b32$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $971bc50063303b32$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $971bc50063303b32$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    } else {
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $971bc50063303b32$var$isNameStart(code)) throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
    return new (0, $8r1qs.Token)(isFloat ? (0, $bQgNI.TokenKind).FLOAT : (0, $bQgNI.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $971bc50063303b32$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($971bc50063303b32$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $971bc50063303b32$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $egTVJ.syntaxError)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $971bc50063303b32$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $egTVJ.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $egTVJ.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $971bc50063303b32$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $7tbLu.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $egTVJ.syntaxError)(source, position, "Invalid character within String: ".concat($971bc50063303b32$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $egTVJ.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $971bc50063303b32$var$uniCharCode(a, b, c, d) {
    return $971bc50063303b32$var$char2hex(a) << 12 | $971bc50063303b32$var$char2hex(b) << 8 | $971bc50063303b32$var$char2hex(c) << 4 | $971bc50063303b32$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $971bc50063303b32$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $971bc50063303b32$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $971bc50063303b32$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("7tbLu", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $a51b3e37e1f6e888$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $a51b3e37e1f6e888$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $a51b3e37e1f6e888$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $a51b3e37e1f6e888$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $a51b3e37e1f6e888$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $a51b3e37e1f6e888$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function $a51b3e37e1f6e888$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function $a51b3e37e1f6e888$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});



parcelRegister("3o9dz", function(module, exports) {

$parcel$export(module.exports, "print", () => $e6602c9cee6df4a2$export$c2d084dc44961371);

var $9m7aI = parcelRequire("9m7aI");

var $7tbLu = parcelRequire("7tbLu");
function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $9m7aI.visit)(ast, {
        leave: $e6602c9cee6df4a2$var$printDocASTReducer
    });
}
var $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $e6602c9cee6df4a2$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(node.variableDefinitions, ", "), ")");
        var directives = $e6602c9cee6df4a2$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $e6602c9cee6df4a2$var$join([
            op,
            $e6602c9cee6df4a2$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $e6602c9cee6df4a2$var$wrap(" = ", defaultValue) + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $e6602c9cee6df4a2$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $e6602c9cee6df4a2$var$wrap("", alias, ": ") + name;
        var argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
        if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)");
        return $e6602c9cee6df4a2$var$join([
            argsLine,
            $e6602c9cee6df4a2$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $e6602c9cee6df4a2$var$join([
            "...",
            $e6602c9cee6df4a2$var$wrap("on ", typeCondition),
            $e6602c9cee6df4a2$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($e6602c9cee6df4a2$var$wrap("", $e6602c9cee6df4a2$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $7tbLu.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $e6602c9cee6df4a2$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $e6602c9cee6df4a2$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $e6602c9cee6df4a2$var$join([
            "schema",
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $e6602c9cee6df4a2$var$join([
            "scalar",
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $e6602c9cee6df4a2$var$join([
            "type",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + ": " + type + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "));
    }),
    InputValueDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $e6602c9cee6df4a2$var$join([
            name + ": " + type,
            $e6602c9cee6df4a2$var$wrap("= ", defaultValue),
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $e6602c9cee6df4a2$var$join([
            "interface",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $e6602c9cee6df4a2$var$join([
            "union",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $e6602c9cee6df4a2$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $e6602c9cee6df4a2$var$join([
            "enum",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $e6602c9cee6df4a2$var$join([
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $e6602c9cee6df4a2$var$join([
            "input",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $e6602c9cee6df4a2$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e6602c9cee6df4a2$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $e6602c9cee6df4a2$var$join([
            "extend schema",
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $e6602c9cee6df4a2$var$join([
            "extend scalar",
            name,
            $e6602c9cee6df4a2$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend type",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend interface",
            name,
            $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $e6602c9cee6df4a2$var$join([
            "extend union",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $e6602c9cee6df4a2$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $e6602c9cee6df4a2$var$join([
            "extend enum",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $e6602c9cee6df4a2$var$join([
            "extend input",
            name,
            $e6602c9cee6df4a2$var$join(directives, " "),
            $e6602c9cee6df4a2$var$block(fields)
        ], " ");
    }
};
function $e6602c9cee6df4a2$var$addDescription(cb) {
    return function(node) {
        return $e6602c9cee6df4a2$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap("{\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e6602c9cee6df4a2$var$isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($e6602c9cee6df4a2$var$isMultiline);
}

});
parcelRegister("9m7aI", function(module, exports) {

$parcel$export(module.exports, "visit", () => $78b48476e314521e$export$bf638b60ea8b89b7);

var $gHwk7 = parcelRequire("gHwk7");

var $8r1qs = parcelRequire("8r1qs");
var $78b48476e314521e$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $78b48476e314521e$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $8r1qs.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $gHwk7.default)(node), "."));
            var visitFn = $78b48476e314521e$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $8r1qs.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $78b48476e314521e$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $78b48476e314521e$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRegister("fT695", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $b910c27483c6e6a0$export$3dede90624df3ba9);

var $2ypWW = parcelRequire("2ypWW");

var $4QgEI = parcelRequire("4QgEI");

var $d9kQQ = parcelRequire("d9kQQ");
function $b910c27483c6e6a0$export$3dede90624df3ba9(selector) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $2ypWW.innerFrom)(selector(err, $b910c27483c6e6a0$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

});
parcelRegister("2ypWW", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910);

var $7WQrb = parcelRequire("7WQrb");

var $bGCU7 = parcelRequire("bGCU7");

var $dy1jD = parcelRequire("dy1jD");

var $6OiYn = parcelRequire("6OiYn");

var $rOw2q = parcelRequire("rOw2q");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $fQMll = parcelRequire("fQMll");

var $7gZl2 = parcelRequire("7gZl2");

var $gCSeg = parcelRequire("gCSeg");

var $28DKm = parcelRequire("28DKm");

var $kaCww = parcelRequire("kaCww");
function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $6OiYn.Observable)) return input;
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $bGCU7.isArrayLike)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $dy1jD.isPromise)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $aGtFl.isAsyncIterable)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $fQMll.isIterable)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var obs = obj[0, $kaCww.observable]();
        if ((0, $gCSeg.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $28DKm.reportUnhandledError));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $7WQrb.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $7gZl2.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $7WQrb.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("bGCU7", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $8821cb8787de9fb5$export$1e2f57719e155213);
var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("dy1jD", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $9dcf7896928e75dd$export$4369c812aac99591);

var $gCSeg = parcelRequire("gCSeg");
function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $gCSeg.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});
parcelRegister("gCSeg", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $c1aa42b0603892d6$export$f6e2535fb5126e54);
function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});


parcelRegister("6OiYn", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $4f562137a990678a$export$77cea355fa80b5f4);

var $hOMJ7 = parcelRequire("hOMJ7");

var $bgI6x = parcelRequire("bgI6x");

var $kaCww = parcelRequire("kaCww");

var $1itL3 = parcelRequire("1itL3");

var $hmjgn = parcelRequire("hmjgn");

var $gCSeg = parcelRequire("gCSeg");

var $cxQqV = parcelRequire("cxQqV");
var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $hOMJ7.SafeSubscriber)(observerOrNext, error, complete);
        (0, $cxQqV.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $hOMJ7.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $kaCww.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $1itL3.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $hmjgn.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $gCSeg.isFunction)(value.next) && (0, $gCSeg.isFunction)(value.error) && (0, $gCSeg.isFunction)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $hOMJ7.Subscriber) || $4f562137a990678a$var$isObserver(value) && (0, $bgI6x.isSubscription)(value);
}

});
parcelRegister("hOMJ7", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $cf8ce74b80455e9f$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $cf8ce74b80455e9f$export$94eeb6a328cab6c7);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $bgI6x = parcelRequire("bgI6x");

var $hmjgn = parcelRequire("hmjgn");

var $28DKm = parcelRequire("28DKm");

var $75rFk = parcelRequire("75rFk");

var $ZT8xQ = parcelRequire("ZT8xQ");

var $gwzK1 = parcelRequire("gwzK1");

var $cxQqV = parcelRequire("cxQqV");
var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $7WQrb.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $bgI6x.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $bgI6x.Subscription));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $7WQrb.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $gCSeg.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $hmjgn.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) (0, $cxQqV.captureError)(error);
    else (0, $28DKm.reportUnhandledError)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $hmjgn.config).onStoppedNotification;
    onStoppedNotification && (0, $gwzK1.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $75rFk.noop),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $75rFk.noop)
};

});
parcelRegister("bgI6x", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $8343668acd7c4a9b$export$f55210826850c514);
$parcel$export(module.exports, "isSubscription", () => $8343668acd7c4a9b$export$4f9221cbada3c4fc);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $l4W4q = parcelRequire("l4W4q");

var $3JYOM = parcelRequire("3JYOM");
var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $7WQrb.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $gCSeg.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $l4W4q.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $7WQrb.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $l4W4q.UnsubscriptionError)) errors = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(errors)), (0, $7WQrb.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $l4W4q.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $3JYOM.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $3JYOM.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $gCSeg.isFunction)(value.remove) && (0, $gCSeg.isFunction)(value.add) && (0, $gCSeg.isFunction)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $gCSeg.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("l4W4q", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $f587043ffd615a90$export$c9648b76fd580c34);

var $kfFvr = parcelRequire("kfFvr");
var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

});
parcelRegister("kfFvr", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $ebe567a061bc80f6$export$128a15b65d1b6041);
function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("3JYOM", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $2b94c03d07e501cc$export$dae3f38077fc36c0);
function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("hmjgn", function(module, exports) {

$parcel$export(module.exports, "config", () => $ca336efb1b4fb564$export$e506a1d27d1eaa20);
var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("28DKm", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $18eb28ff53cc4943$export$ebf645db02d3e99f);

var $hmjgn = parcelRequire("hmjgn");

var $gwzK1 = parcelRequire("gwzK1");
function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $gwzK1.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $hmjgn.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("gwzK1", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $c07b5bfa3b9d4401$export$365aa6bd3c788e3d);

var $7WQrb = parcelRequire("7WQrb");
var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
        return setTimeout.apply(void 0, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("75rFk", function(module, exports) {

$parcel$export(module.exports, "noop", () => $528e75db69787807$export$8793edee2d425525);
function $528e75db69787807$export$8793edee2d425525() {}

});

parcelRegister("ZT8xQ", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $0ba077a4cdfd9739$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $0ba077a4cdfd9739$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $0ba077a4cdfd9739$export$ff9346b0d1d30313);
var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("cxQqV", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $92213d3dd6a83b5d$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $92213d3dd6a83b5d$export$3e205fbb5df021e0);

var $hmjgn = parcelRequire("hmjgn");
var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}

});


parcelRegister("kaCww", function(module, exports) {

$parcel$export(module.exports, "observable", () => $eaf29fccbded6ed3$export$5ab46cbf6120b33a);
var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("1itL3", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $0f1e8e2d1fe93adf$export$71f88a61afaa14d7);

var $a4Ze1 = parcelRequire("a4Ze1");
function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $a4Ze1.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("a4Ze1", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7569c528cdd9d182$export$f0954fd7d5368655);
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("rOw2q", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $0539b51af1903d0a$export$48c0cddbc99c45c2);

var $kaCww = parcelRequire("kaCww");

var $gCSeg = parcelRequire("gCSeg");
function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $gCSeg.isFunction)(input[0, $kaCww.observable]);
}

});

parcelRegister("aGtFl", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $7c74d6a5e2273447$export$edb10ab8dd75a915);

var $gCSeg = parcelRequire("gCSeg");
function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("iolDb", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $d63b3f5b704e6de4$export$7cbe71b9fa263484);
function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("fQMll", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $b8a13650b96f19ab$export$9652023d9040757);

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");
function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $gCSeg.isFunction)(input === null || input === void 0 ? void 0 : input[0, $ZpNjd.iterator]);
}

});
parcelRegister("ZpNjd", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d);
function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();

});


parcelRegister("7gZl2", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $54b99b9095e84ce4$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $54b99b9095e84ce4$export$c088ffafdba7405f);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");
function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $7WQrb.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $7WQrb.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $7WQrb.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $7WQrb.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("4QgEI", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $3868f035248205c1$export$b9e075132cc6937f);

var $7WQrb = parcelRequire("7WQrb");

var $hOMJ7 = parcelRequire("hOMJ7");
function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $7WQrb.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $hOMJ7.Subscriber));

});

parcelRegister("d9kQQ", function(module, exports) {

$parcel$export(module.exports, "operate", () => $992c4a42843eb1d0$export$871731df685d7753);

var $gCSeg = parcelRequire("gCSeg");
function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $gCSeg.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

});


parcelRegister("lvJDy", function(module, exports) {

$parcel$export(module.exports, "GraphQLAuthError", () => $5d69ad309249365b$export$b77ee9d1a91b5bd);
$parcel$export(module.exports, "__amplify", () => $5d69ad309249365b$export$87dc5468d5b26aba);
$parcel$export(module.exports, "__authMode", () => $5d69ad309249365b$export$593785724ae3fc20);
$parcel$export(module.exports, "__authToken", () => $5d69ad309249365b$export$8a1470dae10dd715);
$parcel$export(module.exports, "__headers", () => $5d69ad309249365b$export$2625404bf7c4f53c);

var $5d69ad309249365b$export$b77ee9d1a91b5bd;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})($5d69ad309249365b$export$b77ee9d1a91b5bd || ($5d69ad309249365b$export$b77ee9d1a91b5bd = {}));
const $5d69ad309249365b$export$87dc5468d5b26aba = Symbol("amplify");
const $5d69ad309249365b$export$593785724ae3fc20 = Symbol("authMode");
const $5d69ad309249365b$export$8a1470dae10dd715 = Symbol("authToken");
const $5d69ad309249365b$export$2625404bf7c4f53c = Symbol("headers");

});

parcelRegister("LTBY8", function(module, exports) {

$parcel$export(module.exports, "isCancelError", () => (parcelRequire("3Qiot")).isCancelError);

var $3Qiot = parcelRequire("3Qiot");

var $4gdZ0 = parcelRequire("4gdZ0");

});
parcelRegister("3Qiot", function(module, exports) {

$parcel$export(module.exports, "CanceledError", () => $afc3a2575e3b5a06$export$1ab0c6b20d94fa14);
$parcel$export(module.exports, "isCancelError", () => $afc3a2575e3b5a06$export$a88a1555052550c7);

var $elLC1 = parcelRequire("elLC1");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Internal-only class for CanceledError.
 *
 * @internal
 */ class $afc3a2575e3b5a06$export$1ab0c6b20d94fa14 extends (0, $elLC1.RestApiError) {
    constructor(params = {}){
        super({
            name: "CanceledError",
            message: "Request is canceled by user",
            ...params
        });
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $afc3a2575e3b5a06$export$1ab0c6b20d94fa14;
        Object.setPrototypeOf(this, $afc3a2575e3b5a06$export$1ab0c6b20d94fa14.prototype);
    }
}
/**
 * Check if an error is caused by user calling `cancel()` in REST API.
 *
 * @note This function works **ONLY** for errors thrown by REST API. For GraphQL APIs, use `client.isCancelError(error)`
 *   instead. `client` is generated from  `generateClient()` API from `aws-amplify/api`.
 */ const $afc3a2575e3b5a06$export$a88a1555052550c7 = (error)=>!!error && error instanceof $afc3a2575e3b5a06$export$1ab0c6b20d94fa14;

});
parcelRegister("elLC1", function(module, exports) {

$parcel$export(module.exports, "RestApiError", () => $0c25662755c5b83d$export$18e4f8e37ec3871f);

var $N4Cyz = parcelRequire("N4Cyz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $0c25662755c5b83d$export$18e4f8e37ec3871f extends (0, $N4Cyz.ApiError) {
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $0c25662755c5b83d$export$18e4f8e37ec3871f;
        Object.setPrototypeOf(this, $0c25662755c5b83d$export$18e4f8e37ec3871f.prototype);
    }
}

});
parcelRegister("N4Cyz", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $886306d2222aa47d$export$f2e832acab1bdd79);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Error class for errors that associated with unsuccessful HTTP responses.
 * It's throw by API category REST API handlers and GraphQL query handlers for now.
 */ class $886306d2222aa47d$export$f2e832acab1bdd79 extends (0, $e0exy.AmplifyError) {
    /**
     * The unwrapped HTTP response causing the given API error.
     */ get response() {
        return this._response ? $886306d2222aa47d$var$replicateApiErrorResponse(this._response) : undefined;
    }
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $886306d2222aa47d$export$f2e832acab1bdd79;
        Object.setPrototypeOf(this, $886306d2222aa47d$export$f2e832acab1bdd79.prototype);
        if (params.response) this._response = params.response;
    }
}
const $886306d2222aa47d$var$replicateApiErrorResponse = (response)=>({
        ...response,
        headers: {
            ...response.headers
        }
    });

});



parcelRegister("4gdZ0", function(module, exports) {

var $1qbEC = parcelRequire("1qbEC");

var $g5tdz = parcelRequire("g5tdz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * GET HTTP request
 * @param {GetInput} input - Input for GET operation
 * @returns {GetOperation} Operation for GET request
 * @throws - {@link RestApiError}
 * @example
 * Send a GET request
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await get({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a GET request
 *
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = get({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } cache (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$3988ae62b71be9a3 = (input)=>(0, $g5tdz.get)((0, $1qbEC.Amplify), input);
/**
 * POST HTTP request
 * @param {PostInput} input - Input for POST operation
 * @returns {PostOperation} Operation for POST request
 * @throws - {@link RestApiError}
 * @example
 * Send a POST request
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await post({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a POST request
 *
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = post({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } cache (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$299ba2dee77727e9 = (input)=>(0, $g5tdz.post)((0, $1qbEC.Amplify), input);
/**
 * PUT HTTP request
 * @param {PutInput} input - Input for PUT operation
 * @returns {PutOperation} Operation for PUT request
 * @throws - {@link RestApiError}
 * @example
 * Send a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await put({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = put({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } cache (e) {
 *   if (isCancelError(e)) {
 *     // handle request cancellation
 *   }
 * //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$327f7b26ebf455db = (input)=>(0, $g5tdz.put)((0, $1qbEC.Amplify), input);
/**
 * DELETE HTTP request
 * @param {DeleteInput} input - Input for DELETE operation
 * @returns {DeleteOperation} Operation for DELETE request
 * @throws - {@link RestApiError}
 * @example
 * Send a DELETE request
 * ```js
 * import { del } from '@aws-amplify/api';
 *
 * const { statusCode } = await del({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * ```
 */ const $3326d8896d8e99ec$export$1d2f21e549771e67 = (input)=>(0, $g5tdz.del)((0, $1qbEC.Amplify), input);
/**
 * HEAD HTTP request
 * @param {HeadInput} input - Input for HEAD operation
 * @returns {HeadOperation} Operation for HEAD request
 * @throws - {@link RestApiError}
 * @example
 * Send a HEAD request
 * ```js
 * import { head, isCancelError } from '@aws-amplify/api';
 *
 * const { headers, statusCode } = await head({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }),response;
 * ```
 *
 */ const $3326d8896d8e99ec$export$5fd5031fecdacec3 = (input)=>(0, $g5tdz.head)((0, $1qbEC.Amplify), input);
/**
 * PATCH HTTP request
 * @param {PatchInput} input - Input for PATCH operation
 * @returns {PatchOperation} Operation for PATCH request
 * @throws - {@link RestApiError}
 * @example
 * Send a PATCH request
 * ```js
 * import { patch } from '@aws-amplify/api';
 *
 * const { body } = await patch({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 *
 * @example
 * Cancel a PATCH request
 * ```js
 * import { patch, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = patch({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } cache (e) {
 *  if (isCancelError(e)) {
 *   // handle request cancellation
 *  }
 * //...
 * }
 * ```
 */ const $3326d8896d8e99ec$export$b76953f99ab2be78 = (input)=>(0, $g5tdz.patch)((0, $1qbEC.Amplify), input);

});
parcelRegister("g5tdz", function(module, exports) {

$parcel$export(module.exports, "get", () => $739a77b68798142b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $739a77b68798142b$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $739a77b68798142b$export$327f7b26ebf455db);
$parcel$export(module.exports, "del", () => $739a77b68798142b$export$1d2f21e549771e67);
$parcel$export(module.exports, "head", () => $739a77b68798142b$export$5fd5031fecdacec3);
$parcel$export(module.exports, "patch", () => $739a77b68798142b$export$b76953f99ab2be78);

var $hj5OQ = parcelRequire("hj5OQ");

var $a5hgs = parcelRequire("a5hgs");


parcelRequire("jaclz");

var $269lJ = parcelRequire("269lJ");

var $jDIGB = parcelRequire("jDIGB");

var $hoxjv = parcelRequire("hoxjv");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $739a77b68798142b$var$publicHandler = (amplify, options, method)=>(0, $hj5OQ.createCancellableOperation)(async (abortSignal)=>{
        const { apiName: apiName, options: apiOptions = {}, path: apiPath } = options;
        const url = (0, $269lJ.resolveApiUrl)(amplify, apiName, apiPath, apiOptions?.queryParams);
        const libraryConfigHeaders = await amplify.libraryOptions?.API?.REST?.headers?.({
            apiName: apiName
        });
        const { headers: invocationHeaders = {} } = apiOptions;
        const headers = {
            // custom headers from invocation options should precede library options
            ...libraryConfigHeaders,
            ...invocationHeaders
        };
        const signingServiceInfo = (0, $a5hgs.parseSigningInfo)(url, {
            amplify: amplify,
            apiName: apiName
        });
        (0, $jDIGB.logger).debug(method, url, headers, `IAM signing options: ${JSON.stringify(signingServiceInfo)}`);
        return (0, $hoxjv.transferHandler)(amplify, {
            ...apiOptions,
            url: url,
            method: method,
            headers: headers,
            abortSignal: abortSignal
        }, signingServiceInfo);
    });
const $739a77b68798142b$export$3988ae62b71be9a3 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "GET");
const $739a77b68798142b$export$299ba2dee77727e9 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "POST");
const $739a77b68798142b$export$327f7b26ebf455db = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "PUT");
const $739a77b68798142b$export$1d2f21e549771e67 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "DELETE");
const $739a77b68798142b$export$5fd5031fecdacec3 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "HEAD");
const $739a77b68798142b$export$b76953f99ab2be78 = (amplify, input)=>$739a77b68798142b$var$publicHandler(amplify, input, "PATCH");

});
parcelRegister("hj5OQ", function(module, exports) {

$parcel$export(module.exports, "createCancellableOperation", () => $ba05af205170c6e9$export$52e72f0a376807e8);

var $3Qiot = parcelRequire("3Qiot");

parcelRequire("jaclz");

var $fFah5 = parcelRequire("fFah5");

var $jDIGB = parcelRequire("jDIGB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $ba05af205170c6e9$export$52e72f0a376807e8(handler, abortController) {
    const isInternalPost = (handler)=>!!abortController;
    // For creating a cancellable operation for public REST APIs, we need to create an AbortController
    // internally. Whereas for internal POST APIs, we need to accept in the AbortController from the
    // callers.
    const publicApisAbortController = new AbortController();
    const publicApisAbortSignal = publicApisAbortController.signal;
    const internalPostAbortSignal = abortController?.signal;
    let abortReason;
    const job = async ()=>{
        try {
            const response = await (isInternalPost(handler) ? handler() : handler(publicApisAbortSignal));
            if (response.statusCode >= 300) throw await (0, $fFah5.parseRestApiServiceError)(response);
            return response;
        } catch (error) {
            const abortSignal = internalPostAbortSignal ?? publicApisAbortSignal;
            const message = abortReason ?? abortSignal.reason;
            if (error.name === "AbortError" || abortSignal?.aborted === true) {
                const canceledError = new (0, $3Qiot.CanceledError)({
                    ...message && {
                        message: message
                    },
                    underlyingError: error
                });
                (0, $jDIGB.logger).debug(error);
                throw canceledError;
            }
            (0, $jDIGB.logger).debug(error);
            throw error;
        }
    };
    if (isInternalPost()) return job();
    else {
        const cancel = (abortMessage)=>{
            if (publicApisAbortSignal.aborted === true) return;
            publicApisAbortController.abort(abortMessage);
            // If abort reason is not supported, set a scoped reasons instead. The reason property inside an
            // AbortSignal is a readonly property and trying to set it would throw an error.
            if (abortMessage && publicApisAbortSignal.reason !== abortMessage) abortReason = abortMessage;
        };
        return {
            response: job(),
            cancel: cancel
        };
    }
}

});
parcelRegister("jaclz", function(module, exports) {

$parcel$export(module.exports, "RestApiValidationErrorCode", () => $aa90e1be24f1eaa0$export$8684d9f0176ec7fd);
$parcel$export(module.exports, "validationErrorMap", () => $aa90e1be24f1eaa0$export$195137955146d376);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $aa90e1be24f1eaa0$export$8684d9f0176ec7fd;
(function(RestApiValidationErrorCode) {
    RestApiValidationErrorCode["InvalidApiName"] = "InvalidApiName";
})($aa90e1be24f1eaa0$export$8684d9f0176ec7fd || ($aa90e1be24f1eaa0$export$8684d9f0176ec7fd = {}));
const $aa90e1be24f1eaa0$export$195137955146d376 = {
    [$aa90e1be24f1eaa0$export$8684d9f0176ec7fd.InvalidApiName]: {
        message: "API name is invalid.",
        recoverySuggestion: "Check if the API name matches the one in your configuration or `aws-exports.js`"
    }
};

});

parcelRegister("fFah5", function(module, exports) {

$parcel$export(module.exports, "parseRestApiServiceError", () => $eed1162a5b8f7824$export$cdf23200529f687c);

var $bM38a = parcelRequire("bM38a");

var $elLC1 = parcelRequire("elLC1");
parcelRequire("jaclz");
/**
 * Parses both AWS and non-AWS error responses coming from the users' backend code.
 * * AWS errors generated by the AWS services(e.g. API Gateway, Bedrock). They can be Signature errors,
 *   ClockSkew errors, etc. These responses will be parsed to errors with proper name and message from the AWS
 *   services.
 * * non-AWS errors thrown by the user code. They can contain any headers or body. Users need to access the
 *   error.response to get the headers and body and parse them accordingly. The JS error name and message will
 *   be `UnknownError` and `Unknown error` respectively.
 */ const $eed1162a5b8f7824$export$cdf23200529f687c = async (response)=>{
    if (!response) // Response is not considered an error.
    return;
    const parsedAwsError = await (0, $bM38a.parseJsonError)($eed1162a5b8f7824$var$stubErrorResponse(response));
    if (!parsedAwsError) // Response is not considered an error.
    return;
    else {
        const bodyText = await response.body?.text();
        return $eed1162a5b8f7824$var$buildRestApiError(parsedAwsError, {
            statusCode: response.statusCode,
            headers: response.headers,
            body: bodyText
        });
    }
};
/**
 * The response object needs to be stub here because the parseAwsJsonError assumes the response body to be valid JSON.
 * Although this is true for AWS services, it is not true for responses from user's code. Once the response body is
 * unwrapped as JSON(and fail), it cannot be read as text again. Therefore, we need to stub the response body here to
 * make sure we can read the error response body as a JSON, and may fall back to read as text if it is not a valid JSON.
 */ const $eed1162a5b8f7824$var$stubErrorResponse = (response)=>{
    let bodyTextPromise = undefined;
    const bodyProxy = new Proxy(response.body, {
        get (target, prop, receiver) {
            if (prop === "json") // For potential AWS errors, error parser will try to parse the body as JSON first.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                try {
                    return JSON.parse(await bodyTextPromise);
                } catch (error) {
                    // If response body is not a valid JSON, we stub it to be an empty object and eventually parsed
                    // as an unknown error
                    return {};
                }
            };
            else if (prop === "text") // For non-AWS errors, users can access the body as a string as a fallback.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                return bodyTextPromise;
            };
            else return Reflect.get(target, prop, receiver);
        }
    });
    const responseProxy = new Proxy(response, {
        get (target, prop, receiver) {
            if (prop === "body") return bodyProxy;
            else return Reflect.get(target, prop, receiver);
        }
    });
    return responseProxy;
};
/**
 * Utility to create a new RestApiError from a service error.
 */ const $eed1162a5b8f7824$var$buildRestApiError = (error, response)=>{
    const restApiError = new (0, $elLC1.RestApiError)({
        name: error?.name,
        message: error.message,
        underlyingError: error,
        response: response
    });
    // $metadata is only required for backwards compatibility.
    return Object.assign(restApiError, {
        $metadata: error.$metadata
    });
};

});

parcelRegister("jDIGB", function(module, exports) {

$parcel$export(module.exports, "logger", () => $11b826f7e5531aec$export$af88d00dbe7f521);

var $gJw02 = parcelRequire("gJw02");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $11b826f7e5531aec$export$af88d00dbe7f521 = new (0, $gJw02.ConsoleLogger)("RestApis");

});


parcelRegister("a5hgs", function(module, exports) {

$parcel$export(module.exports, "parseSigningInfo", () => $e4af76b08febfda7$export$654dd12592b26445);

var $2d61L = parcelRequire("2d61L");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Infer the signing service and region from the given URL, and for REST API only, from the Amplify configuration.
 * It supports raw API Gateway endpoint and AppSync endpoint.
 *
 * @internal
 */ const $e4af76b08febfda7$export$654dd12592b26445 = (url, restApiOptions)=>{
    const { service: signingService = (0, $2d61L.DEFAULT_REST_IAM_SIGNING_SERVICE), region: signingRegion = (0, $2d61L.DEFAULT_IAM_SIGNING_REGION) } = restApiOptions?.amplify.getConfig()?.API?.REST?.[restApiOptions?.apiName] ?? {};
    const { hostname: hostname } = url;
    const [, service, region] = (0, $2d61L.APIG_HOSTNAME_PATTERN).exec(hostname) ?? [];
    if (service === (0, $2d61L.DEFAULT_REST_IAM_SIGNING_SERVICE)) // The configured endpoint is an API Gateway endpoint
    // @see: https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-call-api.html
    return {
        service: service,
        region: region ?? signingRegion
    };
    else if (service === "appsync-api") // AppSync endpoint is internally supported because GraphQL operation will send request using POST handler.
    // example: https://xxxx.appsync-api.us-east-1.amazonaws.com/graphql
    return {
        service: "appsync",
        region: region ?? signingRegion
    };
    else return {
        service: signingService,
        region: signingRegion
    };
};

});
parcelRegister("2d61L", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REST_IAM_SIGNING_SERVICE", () => $f628e48ffad78896$export$f8920556a4a329aa);
$parcel$export(module.exports, "DEFAULT_IAM_SIGNING_REGION", () => $f628e48ffad78896$export$c5a0e6a7389a299);
$parcel$export(module.exports, "APIG_HOSTNAME_PATTERN", () => $f628e48ffad78896$export$df1c07b38ace96c2);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f628e48ffad78896$export$f8920556a4a329aa = "execute-api";
const $f628e48ffad78896$export$30f5dbb18c8d33cd = "appsync-api";
const $f628e48ffad78896$export$c5a0e6a7389a299 = "us-east-1";
/**
 * The REST endpoints generated by API Gateway
 * @see {@link https://docs.aws.amazon.com/general/latest/gr/apigateway.html#apigateway_region_data_plane}
 */ const $f628e48ffad78896$export$df1c07b38ace96c2 = /^.+\.([a-z0-9-]+)\.([a-z0-9-]+)\.amazonaws\.com/;

});


parcelRegister("269lJ", function(module, exports) {

$parcel$export(module.exports, "resolveApiUrl", () => $650f468c821576c6$export$74befe2cc96b2f5);

var $7Ar4G = parcelRequire("7Ar4G");

var $elLC1 = parcelRequire("elLC1");

var $8sR3l = parcelRequire("8sR3l");

var $jaclz = parcelRequire("jaclz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resolve the REST API request URL by:
 * 1. Loading the REST API endpoint from the Amplify configuration with corresponding API name.
 * 2. Appending the path to the endpoint.
 * 3. Merge the query parameters from path and the queryParameter argument which is taken from the public REST API
 *   options.
 * 4. Validating the resulting URL string.
 *
 * @internal
 */ const $650f468c821576c6$export$74befe2cc96b2f5 = (amplify, apiName, path, queryParams)=>{
    const urlStr = amplify.getConfig()?.API?.REST?.[apiName]?.endpoint;
    (0, $8sR3l.assertValidationError)(!!urlStr, (0, $jaclz.RestApiValidationErrorCode).InvalidApiName);
    try {
        const url = new (0, $7Ar4G.AmplifyUrl)(urlStr + path);
        if (queryParams) {
            const mergedQueryParams = new (0, $7Ar4G.AmplifyUrlSearchParams)(url.searchParams);
            Object.entries(queryParams).forEach(([key, value])=>{
                mergedQueryParams.set(key, value);
            });
            url.search = new (0, $7Ar4G.AmplifyUrlSearchParams)(mergedQueryParams).toString();
        }
        return url;
    } catch (error) {
        throw new (0, $elLC1.RestApiError)({
            name: (0, $jaclz.RestApiValidationErrorCode).InvalidApiName,
            ...(0, $jaclz.validationErrorMap)[(0, $jaclz.RestApiValidationErrorCode).InvalidApiName],
            recoverySuggestion: `Please make sure the REST endpoint URL is a valid URL string. Got ${urlStr}`
        });
    }
};

});
parcelRegister("8sR3l", function(module, exports) {

$parcel$export(module.exports, "assertValidationError", () => $e66dc82f182fbc3a$export$45936001d12f9b53);

var $elLC1 = parcelRequire("elLC1");

var $jaclz = parcelRequire("jaclz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $e66dc82f182fbc3a$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $jaclz.validationErrorMap)[name];
    if (!assertion) throw new (0, $elLC1.RestApiError)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}

});


parcelRegister("hoxjv", function(module, exports) {

$parcel$export(module.exports, "transferHandler", () => $e88aec0e8d8b5a65$export$28f1d6139f3d8c0a);

var $14EVL = parcelRequire("14EVL");
var $4ZD6k = parcelRequire("4ZD6k");
var $5D9nd = parcelRequire("5D9nd");
var $itEnq = parcelRequire("itEnq");

parcelRequire("jaclz");

var $fFah5 = parcelRequire("fFah5");

var $jDIGB = parcelRequire("jDIGB");

var $a5hgs = parcelRequire("a5hgs");

var $iURDH = parcelRequire("iURDH");
/**
 * Make REST API call with best-effort IAM auth.
 * @param amplify Amplify instance to to resolve credentials and tokens. Should use different instance in client-side
 *   and SSR
 * @param options Options accepted from public API options when calling the handlers.
 * @param signingServiceInfo Internal-only options enable IAM auth as well as to to overwrite the IAM signing service
 *   and region. If specified, and NONE of API Key header or Auth header is present, IAM auth will be used.
 *
 * @internal
 */ const $e88aec0e8d8b5a65$export$28f1d6139f3d8c0a = async (amplify, options, signingServiceInfo)=>{
    const { url: url, method: method, headers: headers, body: body, withCredentials: withCredentials, abortSignal: abortSignal } = options;
    const resolvedBody = body ? body instanceof FormData ? body : JSON.stringify(body ?? "") : undefined;
    const resolvedHeaders = (0, $iURDH.resolveHeaders)(headers, body);
    const request = {
        url: url,
        headers: resolvedHeaders,
        method: method,
        body: resolvedBody
    };
    const baseOptions = {
        retryDecider: (0, $4ZD6k.getRetryDecider)((0, $fFah5.parseRestApiServiceError)),
        computeDelay: (0, $5D9nd.jitteredBackoff),
        withCrossDomainCredentials: withCredentials,
        abortSignal: abortSignal
    };
    const isIamAuthApplicable = $e88aec0e8d8b5a65$var$iamAuthApplicable(request, signingServiceInfo);
    let response;
    const credentials = await $e88aec0e8d8b5a65$var$resolveCredentials(amplify);
    if (isIamAuthApplicable && credentials) {
        const signingInfoFromUrl = (0, $a5hgs.parseSigningInfo)(url);
        const signingService = signingServiceInfo?.service ?? signingInfoFromUrl.service;
        const signingRegion = signingServiceInfo?.region ?? signingInfoFromUrl.region;
        response = await (0, $14EVL.authenticatedHandler)(request, {
            ...baseOptions,
            credentials: credentials,
            region: signingRegion,
            service: signingService
        });
    } else response = await (0, $itEnq.unauthenticatedHandler)(request, {
        ...baseOptions
    });
    // Clean-up un-modeled properties from response.
    return {
        statusCode: response.statusCode,
        headers: response.headers,
        body: response.body
    };
};
const $e88aec0e8d8b5a65$var$iamAuthApplicable = ({ headers: headers }, signingServiceInfo)=>!headers.authorization && !headers["x-api-key"] && !!signingServiceInfo;
const $e88aec0e8d8b5a65$var$resolveCredentials = async (amplify)=>{
    try {
        const { credentials: credentials } = await amplify.Auth.fetchAuthSession();
        if (credentials) return credentials;
    } catch (e) {
        (0, $jDIGB.logger).debug("No credentials available, the request will be unsigned.");
    }
    return null;
};

});
parcelRegister("14EVL", function(module, exports) {

$parcel$export(module.exports, "authenticatedHandler", () => $a783817ff6aa47e2$export$caa14993632515f8);

var $aWNly = parcelRequire("aWNly");



var $3k9Yx = parcelRequire("3k9Yx");

var $aBoxv = parcelRequire("aBoxv");

var $8e8Xp = parcelRequire("8e8Xp");

var $anVi4 = parcelRequire("anVi4");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a783817ff6aa47e2$export$caa14993632515f8 = (0, $8e8Xp.composeTransferHandler)((0, $anVi4.fetchTransferHandler), [
    (0, $aBoxv.userAgentMiddleware),
    (0, $aWNly.retryMiddleware),
    (0, $3k9Yx.signingMiddleware)
]);

});
parcelRegister("3k9Yx", function(module, exports) {

$parcel$export(module.exports, "signingMiddleware", () => $5e05a21ab6358ec7$export$31cfc6b101983bdf);

var $hVfGq = parcelRequire("hVfGq");
parcelRequire("78v1Z");
parcelRequire("lUOK3");

var $dsAqn = parcelRequire("dsAqn");

var $apgva = parcelRequire("apgva");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware that SigV4 signs request with AWS credentials, and correct system clock offset.
 * This middleware is expected to be placed after retry middleware.
 */ const $5e05a21ab6358ec7$export$31cfc6b101983bdf = ({ credentials: credentials, region: region, service: service, uriEscapePath: uriEscapePath = true })=>{
    let currentSystemClockOffset;
    return (next)=>async function signingMiddleware(request) {
            currentSystemClockOffset = currentSystemClockOffset ?? 0;
            const signRequestOptions = {
                credentials: typeof credentials === "function" ? await credentials() : credentials,
                signingDate: (0, $dsAqn.getSkewCorrectedDate)(currentSystemClockOffset),
                signingRegion: region,
                signingService: service,
                uriEscapePath: uriEscapePath
            };
            const signedRequest = await (0, $hVfGq.signRequest)(request, signRequestOptions);
            const response = await next(signedRequest);
            // Update system clock offset if response contains date header, regardless of the status code.
            // non-2xx response will still be returned from next handler instead of thrown, because it's
            // only thrown by the retry middleware.
            const dateString = $5e05a21ab6358ec7$var$getDateHeader(response);
            if (dateString) currentSystemClockOffset = (0, $apgva.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
            return response;
        };
};
const $5e05a21ab6358ec7$var$getDateHeader = ({ headers: headers } = {})=>headers?.date ?? headers?.Date ?? headers?.["x-amz-date"];

});
parcelRegister("hVfGq", function(module, exports) {

$parcel$export(module.exports, "signRequest", () => $3b8b0a35c7d2f42e$export$aa7d25cddbad24ed);

var $k9Bfc = parcelRequire("k9Bfc");

var $9a7M8 = parcelRequire("9a7M8");

var $5lANR = parcelRequire("5lANR");

var $cmsYW = parcelRequire("cmsYW");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Given a `HttpRequest`, returns a Signature Version 4 signed `HttpRequest`.
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns A `HttpRequest` with authentication headers which can grant temporary access to AWS resources.
 */ const $3b8b0a35c7d2f42e$export$aa7d25cddbad24ed = (request, options)=>{
    const signingValues = (0, $9a7M8.getSigningValues)(options);
    const { accessKeyId: accessKeyId, credentialScope: credentialScope, longDate: longDate, sessionToken: sessionToken } = signingValues;
    // create the request to sign
    const headers = {
        ...request.headers
    };
    headers[0, $5lANR.HOST_HEADER] = request.url.host;
    headers[0, $5lANR.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, $5lANR.TOKEN_HEADER] = sessionToken;
    const requestToSign = {
        ...request,
        headers: headers
    };
    // calculate and add the signature to the request
    const signature = (0, $cmsYW.getSignature)(requestToSign, signingValues);
    const credentialEntry = `Credential=${accessKeyId}/${credentialScope}`;
    const signedHeadersEntry = `SignedHeaders=${(0, $k9Bfc.getSignedHeaders)(headers)}`;
    const signatureEntry = `Signature=${signature}`;
    headers[0, $5lANR.AUTH_HEADER] = `${0, $5lANR.SHA256_ALGORITHM_IDENTIFIER} ${credentialEntry}, ${signedHeadersEntry}, ${signatureEntry}`;
    return requestToSign;
};

});
parcelRegister("k9Bfc", function(module, exports) {

$parcel$export(module.exports, "getSignedHeaders", () => $801e30203e6ee81f$export$812d6f56efda9cfa);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ const $801e30203e6ee81f$export$812d6f56efda9cfa = (headers)=>Object.keys(headers).map((key)=>key.toLowerCase()).sort().join(";");

});

parcelRegister("9a7M8", function(module, exports) {

$parcel$export(module.exports, "getSigningValues", () => $7c254d6715dfe620$export$188c70d4d3596d39);

var $ixXuO = parcelRequire("ixXuO");

var $9h49C = parcelRequire("9h49C");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Extracts common values used for signing both requests and urls.
 *
 * @param options `SignRequestOptions` object containing values used to construct the signature.
 * @returns Common `SigningValues` used for signing.
 *
 * @internal
 */ const $7c254d6715dfe620$export$188c70d4d3596d39 = ({ credentials: credentials, signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath = true })=>{
    // get properties from credentials
    const { accessKeyId: accessKeyId, secretAccessKey: secretAccessKey, sessionToken: sessionToken } = credentials;
    // get formatted dates for signing
    const { longDate: longDate, shortDate: shortDate } = (0, $9h49C.getFormattedDates)(signingDate);
    // copy header and set signing properties
    const credentialScope = (0, $ixXuO.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};

});
parcelRegister("ixXuO", function(module, exports) {

$parcel$export(module.exports, "getCredentialScope", () => $cf06eb9d7fea015f$export$a720a7c8dd7ab696);

var $5lANR = parcelRequire("5lANR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the credential scope which restricts the resulting signature to the specified region and service.
 *
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns  A string representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 *
 * @internal
 */ const $cf06eb9d7fea015f$export$a720a7c8dd7ab696 = (date, region, service)=>`${date}/${region}/${service}/${0, $5lANR.KEY_TYPE_IDENTIFIER}`;

});
parcelRegister("5lANR", function(module, exports) {

$parcel$export(module.exports, "AUTH_HEADER", () => $63c567658c1dc4ca$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "HOST_HEADER", () => $63c567658c1dc4ca$export$96307741595055fc);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $63c567658c1dc4ca$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "TOKEN_HEADER", () => $63c567658c1dc4ca$export$fdc81b663012a8d2);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $63c567658c1dc4ca$export$c4bf0942098f6bb);
$parcel$export(module.exports, "SHA256_ALGORITHM_IDENTIFIER", () => $63c567658c1dc4ca$export$aba583fcf2c2a4e9);
$parcel$export(module.exports, "SIGNATURE_IDENTIFIER", () => $63c567658c1dc4ca$export$c295e35583a9d67a);
$parcel$export(module.exports, "EMPTY_HASH", () => $63c567658c1dc4ca$export$b445dbfd1d7f2d42);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $63c567658c1dc4ca$export$91f7321b40d9fd07);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
const $63c567658c1dc4ca$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $63c567658c1dc4ca$export$6e114beec37430d7 = "X-Amz-Date";
const $63c567658c1dc4ca$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $63c567658c1dc4ca$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $63c567658c1dc4ca$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $63c567658c1dc4ca$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $63c567658c1dc4ca$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $63c567658c1dc4ca$export$8e1383b7eea7bee = "X-Amz-Security-Token";
// headers
const $63c567658c1dc4ca$export$9924a64a4b8b0d58 = "authorization";
const $63c567658c1dc4ca$export$96307741595055fc = "host";
const $63c567658c1dc4ca$export$acf4b8bdf24aab34 = $63c567658c1dc4ca$export$6e114beec37430d7.toLowerCase();
const $63c567658c1dc4ca$export$fdc81b663012a8d2 = $63c567658c1dc4ca$export$8e1383b7eea7bee.toLowerCase();
// identifiers
const $63c567658c1dc4ca$export$c4bf0942098f6bb = "aws4_request";
const $63c567658c1dc4ca$export$aba583fcf2c2a4e9 = "AWS4-HMAC-SHA256";
const $63c567658c1dc4ca$export$c295e35583a9d67a = "AWS4";
// preset values
const $63c567658c1dc4ca$export$b445dbfd1d7f2d42 = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
const $63c567658c1dc4ca$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";

});


parcelRegister("9h49C", function(module, exports) {

$parcel$export(module.exports, "getFormattedDates", () => $3e1220c52013c4f4$export$79cc774850e3b1b);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ const $3e1220c52013c4f4$export$79cc774850e3b1b = (date)=>{
    const longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};

});


parcelRegister("cmsYW", function(module, exports) {

$parcel$export(module.exports, "getSignature", () => $68a3178cad332cbe$export$2f768fec5d73d91a);

var $9DDIC = parcelRequire("9DDIC");

var $1JAiq = parcelRequire("1JAiq");

var $9qHih = parcelRequire("9qHih");

var $4NKll = parcelRequire("4NKll");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculates and returns an AWS API Signature.
 * https://docs.aws.amazon.com/IAM/latest/UserGuide/create-signed-request.html
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns AWS API Signature to sign a request or url with.
 *
 * @internal
 */ const $68a3178cad332cbe$export$2f768fec5d73d91a = (request, { credentialScope: credentialScope, longDate: longDate, secretAccessKey: secretAccessKey, shortDate: shortDate, signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath })=>{
    // step 1: create a canonical request
    const canonicalRequest = (0, $1JAiq.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    const hashedRequest = (0, $9DDIC.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    const stringToSign = (0, $4NKll.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    const signature = (0, $9DDIC.getHashedDataAsHex)((0, $9qHih.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

});
parcelRegister("9DDIC", function(module, exports) {

$parcel$export(module.exports, "getHashedData", () => $e878efb7fb845f8e$export$1a568184069ac3c8);
$parcel$export(module.exports, "getHashedDataAsHex", () => $e878efb7fb845f8e$export$45d3ccefb0f0c6da);
parcelRequire("78v1Z");
var $4xNDb = parcelRequire("4xNDb");

var $lUOK3 = parcelRequire("lUOK3");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
/**
 * Returns the hashed data a `Uint8Array`.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns `Uint8Array` created from the data as input to a hash function.
 */ const $e878efb7fb845f8e$export$1a568184069ac3c8 = (key, data)=>{
    const sha256 = new (0, $4xNDb.Sha256)(key ?? undefined);
    sha256.update(data);
    // TODO: V6 flip to async digest
    const hashedData = sha256.digestSync();
    return hashedData;
};
/**
 * Returns the hashed data as a hex string.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns String using lowercase hexadecimal characters created from the data as input to a hash function.
 *
 * @internal
 */ const $e878efb7fb845f8e$export$45d3ccefb0f0c6da = (key, data)=>{
    const hashedData = $e878efb7fb845f8e$export$1a568184069ac3c8(key, data);
    return (0, $lUOK3.toHex)(hashedData);
};

});

parcelRegister("1JAiq", function(module, exports) {

$parcel$export(module.exports, "getCanonicalRequest", () => $1cff5c5577c43db0$export$78136353678f36ec);

var $1peWS = parcelRequire("1peWS");

var $lbuB1 = parcelRequire("lbuB1");

var $m3vdz = parcelRequire("m3vdz");

var $3YqIC = parcelRequire("3YqIC");

var $k9Bfc = parcelRequire("k9Bfc");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical request.
 *
 * @param request `HttpRequest` from which to create the canonical request from.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns String created by by concatenating the following strings, separated by newline characters:
 * - HTTPMethod
 * - CanonicalUri
 * - CanonicalQueryString
 * - CanonicalHeaders
 * - SignedHeaders
 * - HashedPayload
 *
 * @internal
 */ const $1cff5c5577c43db0$export$78136353678f36ec = ({ body: body, headers: headers, method: method, url: url }, uriEscapePath = true)=>[
        method,
        (0, $m3vdz.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, $lbuB1.getCanonicalQueryString)(url.searchParams),
        (0, $1peWS.getCanonicalHeaders)(headers),
        (0, $k9Bfc.getSignedHeaders)(headers),
        (0, $3YqIC.getHashedPayload)(body)
    ].join("\n");

});
parcelRegister("1peWS", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $802403cd603e7e8b$export$859d7f1bb55e2914);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns canonical headers.
 *
 * @param headers Headers from the request.
 * @returns Request headers that will be signed, and their values, separated by newline characters. Header names must
 * use lowercase characters, must appear in alphabetical order, and must be followed by a colon (:). For the values,
 * trim any leading or trailing spaces, convert sequential spaces to a single space, and separate the values
 * for a multi-value header using commas.
 *
 * @internal
 */ const $802403cd603e7e8b$export$859d7f1bb55e2914 = (headers)=>Object.entries(headers).map(([key, value])=>({
            key: key.toLowerCase(),
            value: value?.trim().replace(/\s+/g, " ") ?? ""
        })).sort((a, b)=>a.key < b.key ? -1 : 1).map((entry)=>`${entry.key}:${entry.value}\n`).join("");

});

parcelRegister("lbuB1", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQueryString", () => $836086e14a5fbbdd$export$87a9cc45e3be0a17);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical query string.
 *
 * @param searchParams `searchParams` from the request url.
 * @returns URL-encoded query string parameters, separated by ampersands (&). Percent-encode reserved characters,
 * including the space character. Encode names and values separately. If there are empty parameters, append the equals
 * sign to the parameter name before encoding. After encoding, sort the parameters alphabetically by key name. If there
 * is no query string, use an empty string ("").
 *
 * @internal
 */ const $836086e14a5fbbdd$export$87a9cc45e3be0a17 = (searchParams)=>Array.from(searchParams).sort(([keyA, valA], [keyB, valB])=>{
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(([key, val])=>`${$836086e14a5fbbdd$var$escapeUri(key)}=${$836086e14a5fbbdd$var$escapeUri(val)}`).join("&");
const $836086e14a5fbbdd$var$escapeUri = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $836086e14a5fbbdd$var$hexEncode);
const $836086e14a5fbbdd$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

});

parcelRegister("m3vdz", function(module, exports) {

$parcel$export(module.exports, "getCanonicalUri", () => $c23651d03b87ad66$export$4bbb144438cceb59);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ const $c23651d03b87ad66$export$4bbb144438cceb59 = (pathname, uriEscapePath = true)=>pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";

});

parcelRegister("3YqIC", function(module, exports) {

$parcel$export(module.exports, "getHashedPayload", () => $d9f6bc20607e1fa8$export$b671a27d01dfc160);

var $5lANR = parcelRequire("5lANR");

var $9DDIC = parcelRequire("9DDIC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the hashed payload.
 *
 * @param body `body` (payload) from the request.
 * @returns String created using the payload in the body of the HTTP request as input to a hash function. This string
 * uses lowercase hexadecimal characters. If the payload is empty, return precalculated result of an empty hash.
 *
 * @internal
 */ const $d9f6bc20607e1fa8$export$b671a27d01dfc160 = (body)=>{
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, $5lANR.EMPTY_HASH;
    if ($d9f6bc20607e1fa8$var$isSourceData(body)) {
        const hashedData = (0, $9DDIC.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, $5lANR.UNSIGNED_PAYLOAD;
};
const $d9f6bc20607e1fa8$var$isSourceData = (body)=>typeof body === "string" || ArrayBuffer.isView(body) || $d9f6bc20607e1fa8$var$isArrayBuffer(body);
const $d9f6bc20607e1fa8$var$isArrayBuffer = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

});


parcelRegister("9qHih", function(module, exports) {

$parcel$export(module.exports, "getSigningKey", () => $20544ff12369282e$export$8b95a069d16dd783);

var $5lANR = parcelRequire("5lANR");

var $9DDIC = parcelRequire("9DDIC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a signing key to be used for signing requests.
 *
 * @param secretAccessKey AWS secret access key from credentials.
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns `Uint8Array` calculated from its composite parts.
 *
 * @internal
 */ const $20544ff12369282e$export$8b95a069d16dd783 = (secretAccessKey, date, region, service)=>{
    const key = `${(0, $5lANR.SIGNATURE_IDENTIFIER)}${secretAccessKey}`;
    const dateKey = (0, $9DDIC.getHashedData)(key, date);
    const regionKey = (0, $9DDIC.getHashedData)(dateKey, region);
    const serviceKey = (0, $9DDIC.getHashedData)(regionKey, service);
    const signingKey = (0, $9DDIC.getHashedData)(serviceKey, (0, $5lANR.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

});

parcelRegister("4NKll", function(module, exports) {

$parcel$export(module.exports, "getStringToSign", () => $2e89d4e84567a0b9$export$ff872c70ad45fed1);

var $5lANR = parcelRequire("5lANR");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a string to be signed.
 *
 * @param date Current date in the format 'YYYYMMDDThhmmssZ'.
 * @param credentialScope String representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 * @param hashedRequest Hashed canonical request.
 *
 * @returns A string created by by concatenating the following strings, separated by newline characters:
 * - Algorithm
 * - RequestDateTime
 * - CredentialScope
 * - HashedCanonicalRequest
 *
 * @internal
 */ const $2e89d4e84567a0b9$export$ff872c70ad45fed1 = (date, credentialScope, hashedRequest)=>[
        (0, $5lANR.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");

});



parcelRegister("dsAqn", function(module, exports) {

$parcel$export(module.exports, "getSkewCorrectedDate", () => $0336c7502048c65b$export$86d5c90340985ada);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ const $0336c7502048c65b$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

});

parcelRegister("apgva", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSystemClockOffset", () => $e5b4b6cb4653f17c$export$1ed4d48b860b1348);

var $bQnWW = parcelRequire("bQnWW");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the difference between clock time and the current system time if clock is skewed.
 *
 * @param clockTimeInMilliseconds Clock time in milliseconds.
 * @param currentSystemClockOffset Current system clock offset in milliseconds.
 *
 * @internal
 */ const $e5b4b6cb4653f17c$export$1ed4d48b860b1348 = (clockTimeInMilliseconds, currentSystemClockOffset)=>{
    if ((0, $bQnWW.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

});
parcelRegister("bQnWW", function(module, exports) {

$parcel$export(module.exports, "isClockSkewed", () => $b350468427cf28cf$export$c162a01d4a03ea6f);

var $dsAqn = parcelRequire("dsAqn");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
const $b350468427cf28cf$var$SKEW_WINDOW = 300000;
/**
 * Checks if the provided date is within the skew window of 5 minutes.
 *
 * @param clockTimeInMilliseconds Time to check for skew in milliseconds.
 * @param clockOffsetInMilliseconds Offset to check clock against in milliseconds.
 *
 * @returns True if skewed. False otherwise.
 *
 * @internal
 */ const $b350468427cf28cf$export$c162a01d4a03ea6f = (clockTimeInMilliseconds, clockOffsetInMilliseconds)=>Math.abs((0, $dsAqn.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= $b350468427cf28cf$var$SKEW_WINDOW;

});




parcelRegister("iURDH", function(module, exports) {

$parcel$export(module.exports, "resolveHeaders", () => $981c4e8ab4e5d02a$export$7dd43af7d8d48b8f);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $981c4e8ab4e5d02a$export$7dd43af7d8d48b8f = (headers, body)=>{
    const normalizedHeaders = {};
    for(const key in headers)normalizedHeaders[key.toLowerCase()] = headers[key];
    if (body) {
        normalizedHeaders["content-type"] = "application/json; charset=UTF-8";
        if (body instanceof FormData) /**
             * If body is a FormData we should not allow setting content-type.
             * It's because runtime HTTP handlers(xhr, fetch, undici, node-fetch,
             * etc.) will modify the content-type value when setting multipart
             * boundary.
             */ delete normalizedHeaders["content-type"];
    }
    return normalizedHeaders;
};

});





parcelRegister("dOmJe", function(module, exports) {

$parcel$export(module.exports, "post", () => $b170273bda26d274$export$299ba2dee77727e9);
$parcel$export(module.exports, "cancel", () => (parcelRequire("cfOsN")).cancel);
$parcel$export(module.exports, "updateRequestToBeCancellable", () => (parcelRequire("cfOsN")).updateRequestToBeCancellable);

var $1qbEC = parcelRequire("1qbEC");

var $cfOsN = parcelRequire("cfOsN");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Internal-only REST POST handler to send GraphQL request to given endpoint. By default, it will use IAM to authorize
 * the request. In some auth modes, the IAM auth has to be disabled. Here's how to set up the request auth correctly:
 * * If auth mode is 'iam', you MUST NOT set 'authorization' header and 'x-api-key' header, since it would disable IAM
 *   auth. You MUST also set 'input.options.signingServiceInfo' option.
 *   * The including 'input.options.signingServiceInfo.service' and 'input.options.signingServiceInfo.region' are
 *     optional. If omitted, the signing service and region will be inferred from url.
 * * If auth mode is 'none', you MUST NOT set 'options.signingServiceInfo' option.
 * * If auth mode is 'apiKey', you MUST set 'x-api-key' custom header.
 * * If auth mode is 'oidc' or 'lambda' or 'userPool', you MUST set 'authorization' header.
 *
 * To make the internal post cancellable, you must also call `updateRequestToBeCancellable()` with the promise from
 * internal post call and the abort controller supplied to the internal post call.
 *
 * @internal
 */ const $b170273bda26d274$export$299ba2dee77727e9 = (input)=>{
    return (0, $cfOsN.post)((0, $1qbEC.Amplify), input);
};

});
parcelRegister("cfOsN", function(module, exports) {

$parcel$export(module.exports, "post", () => $da10f03454fb4394$export$299ba2dee77727e9);
$parcel$export(module.exports, "cancel", () => $da10f03454fb4394$export$70b61ad426ddbe54);
$parcel$export(module.exports, "updateRequestToBeCancellable", () => $da10f03454fb4394$export$6224e208c7f72b42);

var $hoxjv = parcelRequire("hoxjv");

var $hj5OQ = parcelRequire("hj5OQ");


parcelRequire("jaclz");
parcelRequire("jDIGB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This weak map provides functionality to cancel a request given the promise containing the `post` request.
 *
 * 1. For every GraphQL POST request, an abort controller is created and supplied to the request.
 * 2. The promise fulfilled by GraphGL POST request is then mapped to that abort controller.
 * 3. The promise is returned to the external caller.
 * 4. The caller can either wait for the promise to fulfill or call `cancel(promise)` to cancel the request.
 * 5. If `cancel(promise)` is called, then the corresponding abort controller is retrieved from the map below.
 * 6. GraphQL POST request will be rejected with the error message provided during cancel.
 * 7. Caller can check if the error is because of cancelling by calling `isCancelError(error)`.
 */ const $da10f03454fb4394$var$cancelTokenMap = new WeakMap();
/**
 * @internal
 */ const $da10f03454fb4394$export$299ba2dee77727e9 = (amplify, { url: url, options: options, abortController: abortController })=>{
    const controller = abortController ?? new AbortController();
    const responsePromise = (0, $hj5OQ.createCancellableOperation)(async ()=>{
        const response = (0, $hoxjv.transferHandler)(amplify, {
            url: url,
            method: "POST",
            ...options,
            abortSignal: controller.signal
        }, options?.signingServiceInfo);
        return response;
    }, controller);
    const responseWithCleanUp = responsePromise.finally(()=>{
        $da10f03454fb4394$var$cancelTokenMap.delete(responseWithCleanUp);
    });
    return responseWithCleanUp;
};
/**
 * Cancels a request given the promise returned by `post`.
 * If the request is already completed, this function does nothing.
 * It MUST be used after `updateRequestToBeCancellable` is called.
 */ const $da10f03454fb4394$export$70b61ad426ddbe54 = (promise, message)=>{
    const controller = $da10f03454fb4394$var$cancelTokenMap.get(promise);
    if (controller) {
        controller.abort(message);
        if (message && controller.signal.reason !== message) // In runtimes where `AbortSignal.reason` is not supported, we track the reason ourselves.
        // @ts-expect-error reason is read-only property.
        controller.signal["reason"] = message;
        return true;
    }
    return false;
};
/**
 * MUST be used to make a promise including internal `post` API call cancellable.
 */ const $da10f03454fb4394$export$6224e208c7f72b42 = (promise, controller)=>{
    $da10f03454fb4394$var$cancelTokenMap.set(promise, controller);
};

});


parcelRegister("99ZQ7", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncRealTimeProvider", () => $86064b38d58ca2f6$export$b7b5e6371992068d);

var $6OiYn = parcelRequire("6OiYn");

var $fHcz3 = parcelRequire("fHcz3");

var $gJw02 = parcelRequire("gJw02");
var $kwYKv = parcelRequire("kwYKv");
var $5RCQ5 = parcelRequire("5RCQ5");

var $hVfGq = parcelRequire("hVfGq");

var $5RCQ5 = parcelRequire("5RCQ5");
var $7Ar4G = parcelRequire("7Ar4G");
var $3jt4M = parcelRequire("3jt4M");
var $ijwDq = parcelRequire("ijwDq");
var $dj9FS = parcelRequire("dj9FS");
var $g2b7y = parcelRequire("g2b7y");
var $01Ziv = parcelRequire("01Ziv");
var $i62vd = parcelRequire("i62vd");
var $1ZViM = parcelRequire("1ZViM");

var $OwgYH = parcelRequire("OwgYH");

var $fuDKT = parcelRequire("fuDKT");

var $7LQNq = parcelRequire("7LQNq");

var $bDWoz = parcelRequire("bDWoz");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $86064b38d58ca2f6$var$logger = new (0, $gJw02.ConsoleLogger)("AWSAppSyncRealTimeProvider");
const $86064b38d58ca2f6$var$dispatchApiEvent = (payload)=>{
    (0, $5RCQ5.Hub).dispatch("api", payload, "PubSub", (0, $5RCQ5.AMPLIFY_SYMBOL));
};
const $86064b38d58ca2f6$var$standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
const $86064b38d58ca2f6$var$customDomainPath = "/realtime";
class $86064b38d58ca2f6$export$b7b5e6371992068d {
    constructor(options = {}){
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
        this.keepAliveTimeout = (0, $fuDKT.DEFAULT_KEEP_ALIVE_TIMEOUT);
        this.subscriptionObserverMap = new Map();
        this.promiseArray = [];
        this.connectionStateMonitor = new (0, $7LQNq.ConnectionStateMonitor)();
        this.reconnectionMonitor = new (0, $bDWoz.ReconnectionMonitor)();
        // Monitor the connection state and pass changes along to Hub
        this.connectionStateMonitorSubscription = this.connectionStateMonitor.connectionStateObservable.subscribe((connectionState)=>{
            $86064b38d58ca2f6$var$dispatchApiEvent({
                event: (0, $fuDKT.CONNECTION_STATE_CHANGE),
                data: {
                    provider: this,
                    connectionState: connectionState
                },
                message: `Connection state is ${connectionState}`
            });
            this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, $OwgYH.ConnectionState).ConnectionDisrupted) this.reconnectionMonitor.record((0, $bDWoz.ReconnectEvent).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            //   ConnectionDisrupted or Connecting
            if ([
                (0, $OwgYH.ConnectionState).Connected,
                (0, $OwgYH.ConnectionState).ConnectedPendingDisconnect,
                (0, $OwgYH.ConnectionState).ConnectedPendingKeepAlive,
                (0, $OwgYH.ConnectionState).ConnectedPendingNetwork,
                (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork,
                (0, $OwgYH.ConnectionState).Disconnected
            ].includes(connectionState)) this.reconnectionMonitor.record((0, $bDWoz.ReconnectEvent).HALT_RECONNECT);
        });
    }
    /**
     * Mark the socket closed and release all active listeners
     */ close() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
    }
    getNewWebSocket(url, protocol) {
        return new WebSocket(url, protocol);
    }
    getProviderName() {
        return "AWSAppSyncRealTimeProvider";
    }
    // Check if url matches standard domain pattern
    isCustomDomain(url) {
        return url.match($86064b38d58ca2f6$var$standardDomainPattern) === null;
    }
    subscribe(options, customUserAgentDetails) {
        const { appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, region: region, query: query, variables: variables, authenticationType: authenticationType, additionalHeaders: additionalHeaders, apiKey: apiKey, authToken: authToken, libraryConfigHeaders: libraryConfigHeaders } = options || {};
        return new (0, $6OiYn.Observable)((observer)=>{
            if (!options || !appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        {
                            ...new (0, $fHcz3.GraphQLError)(`Subscribe only available for AWS AppSync endpoint`)
                        }
                    ]
                });
                observer.complete();
            } else {
                let subscriptionStartActive = false;
                const subscriptionId = (0, $3jt4M.amplifyUuid)();
                const startSubscription = ()=>{
                    if (!subscriptionStartActive) {
                        subscriptionStartActive = true;
                        const startSubscriptionPromise = this._startSubscriptionWithAWSAppSyncRealTime({
                            options: {
                                query: query,
                                variables: variables,
                                region: region,
                                authenticationType: authenticationType,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                additionalHeaders: additionalHeaders,
                                apiKey: apiKey,
                                authToken: authToken,
                                libraryConfigHeaders: libraryConfigHeaders
                            },
                            observer: observer,
                            subscriptionId: subscriptionId,
                            customUserAgentDetails: customUserAgentDetails
                        }).catch((err)=>{
                            $86064b38d58ca2f6$var$logger.debug(`${(0, $OwgYH.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR}: ${err}`);
                            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED);
                        });
                        startSubscriptionPromise.finally(()=>{
                            subscriptionStartActive = false;
                        });
                    }
                };
                let reconnectSubscription;
                // Add an observable to the reconnection list to manage reconnection for this subscription
                reconnectSubscription = new (0, $6OiYn.Observable)((observer)=>{
                    this.reconnectionMonitor.addObserver(observer);
                }).subscribe(()=>{
                    startSubscription();
                });
                startSubscription();
                return async ()=>{
                    // Cleanup reconnection subscription
                    reconnectSubscription?.unsubscribe();
                    // Cleanup after unsubscribing or observer.complete was called after _startSubscriptionWithAWSAppSyncRealTime
                    try {
                        // Waiting that subscription has been connected before trying to unsubscribe
                        await this._waitForSubscriptionToBeConnected(subscriptionId);
                        const { subscriptionState: subscriptionState } = this.subscriptionObserverMap.get(subscriptionId) || {};
                        if (!subscriptionState) // subscription already unsubscribed
                        return;
                        if (subscriptionState === (0, $fuDKT.SUBSCRIPTION_STATUS).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId);
                        else throw new Error("Subscription never connected");
                    } catch (err) {
                        $86064b38d58ca2f6$var$logger.debug(`Error while unsubscribing ${err}`);
                    } finally{
                        this._removeSubscriptionObserver(subscriptionId);
                    }
                };
            }
        });
    }
    async _startSubscriptionWithAWSAppSyncRealTime({ options: options, observer: observer, subscriptionId: subscriptionId, customUserAgentDetails: customUserAgentDetails }) {
        const { appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, authenticationType: authenticationType, query: query, variables: variables, apiKey: apiKey, region: region, libraryConfigHeaders: libraryConfigHeaders = ()=>({}), additionalHeaders: additionalHeaders = {}, authToken: authToken } = options;
        let additionalCustomHeaders = {};
        if (typeof additionalHeaders === "function") {
            const requestOptions = {
                url: appSyncGraphqlEndpoint || "",
                queryString: query || ""
            };
            additionalCustomHeaders = await additionalHeaders(requestOptions);
        } else additionalCustomHeaders = additionalHeaders;
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) additionalCustomHeaders = {
            ...additionalCustomHeaders,
            Authorization: authToken
        };
        const subscriptionState = (0, $fuDKT.SUBSCRIPTION_STATUS).PENDING;
        const data = {
            query: query,
            variables: variables
        };
        // Having a subscription id map will make it simple to forward messages received
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query ?? "",
            variables: variables ?? {},
            subscriptionState: subscriptionState,
            startAckTimeoutId: undefined
        });
        // Preparing payload for subscription message
        const dataString = JSON.stringify(data);
        const headerObj = {
            ...await this._awsRealTimeHeaderBasedAuth({
                apiKey: apiKey,
                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                authenticationType: authenticationType,
                payload: dataString,
                canonicalUri: "",
                region: region,
                additionalCustomHeaders: additionalCustomHeaders
            }),
            ...await libraryConfigHeaders(),
            ...additionalCustomHeaders,
            [(0, $1ZViM.USER_AGENT_HEADER)]: (0, $dj9FS.getAmplifyUserAgent)(customUserAgentDetails)
        };
        const subscriptionMessage = {
            id: subscriptionId,
            payload: {
                data: dataString,
                extensions: {
                    authorization: {
                        ...headerObj
                    }
                }
            },
            type: (0, $fuDKT.MESSAGE_TYPES).GQL_START
        };
        const stringToAWSRealTime = JSON.stringify(subscriptionMessage);
        try {
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).OPENING_CONNECTION);
            await this._initializeWebSocketConnection({
                apiKey: apiKey,
                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                authenticationType: authenticationType,
                region: region,
                additionalCustomHeaders: additionalCustomHeaders
            });
        } catch (err) {
            this._logStartSubscriptionError(subscriptionId, observer, err);
            return;
        }
        // Potential race condition can occur when unsubscribe is called during _initializeWebSocketConnection.
        // E.g.unsubscribe gets invoked prior to finishing WebSocket handshake or START_ACK.
        // Both subscriptionFailedCallback and subscriptionReadyCallback are used to synchronized this.
        const { subscriptionFailedCallback: subscriptionFailedCallback, subscriptionReadyCallback: subscriptionReadyCallback } = this.subscriptionObserverMap.get(subscriptionId) ?? {};
        // This must be done before sending the message in order to be listening immediately
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            subscriptionState: subscriptionState,
            query: query ?? "",
            variables: variables ?? {},
            subscriptionReadyCallback: subscriptionReadyCallback,
            subscriptionFailedCallback: subscriptionFailedCallback,
            startAckTimeoutId: setTimeout(()=>{
                this._timeoutStartSubscriptionAck.call(this, subscriptionId);
            }, (0, $fuDKT.START_ACK_TIMEOUT))
        });
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
    }
    // Log logic for start subscription failures
    _logStartSubscriptionError(subscriptionId, observer, err) {
        $86064b38d58ca2f6$var$logger.debug({
            err: err
        });
        const message = String(err.message ?? "");
        // Resolving to give the state observer time to propogate the update
        Promise.resolve(this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED));
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, $g2b7y.isNonRetryableError)(err)) observer.error({
                errors: [
                    {
                        ...new (0, $fHcz3.GraphQLError)(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${message}`)
                    }
                ]
            });
            else $86064b38d58ca2f6$var$logger.debug(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${message}`);
            const { subscriptionFailedCallback: subscriptionFailedCallback } = this.subscriptionObserverMap.get(subscriptionId) || {};
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    }
    // Waiting that subscription has been connected before trying to unsubscribe
    async _waitForSubscriptionToBeConnected(subscriptionId) {
        const subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            const { subscriptionState: subscriptionState } = subscriptionObserver;
            // This in case unsubscribe is invoked before sending start subscription message
            if (subscriptionState === (0, $fuDKT.SUBSCRIPTION_STATUS).PENDING) return new Promise((res, rej)=>{
                const { observer: observer, subscriptionState: subscriptionState, variables: variables, query: query } = subscriptionObserver;
                this.subscriptionObserverMap.set(subscriptionId, {
                    observer: observer,
                    subscriptionState: subscriptionState,
                    variables: variables,
                    query: query,
                    subscriptionReadyCallback: res,
                    subscriptionFailedCallback: rej
                });
            });
        }
    }
    _sendUnsubscriptionMessage(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, $fuDKT.SOCKET_STATUS).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                const unsubscribeMessage = {
                    id: subscriptionId,
                    type: (0, $fuDKT.MESSAGE_TYPES).GQL_STOP
                };
                const stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $86064b38d58ca2f6$var$logger.debug({
                err: err
            });
        }
    }
    _removeSubscriptionObserver(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    }
    _closeSocketIfRequired() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $86064b38d58ca2f6$var$logger.debug("closing WebSocket...");
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            const tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED);
        }
    }
    _handleIncomingSubscriptionMessage(message) {
        if (typeof message.data !== "string") return;
        $86064b38d58ca2f6$var$logger.debug(`subscription message from AWS AppSync RealTime: ${message.data}`);
        const { id: id = "", payload: payload, type: type } = JSON.parse(String(message.data));
        const { observer: observer = null, query: query = "", variables: variables = {}, startAckTimeoutId: startAckTimeoutId, subscriptionReadyCallback: subscriptionReadyCallback, subscriptionFailedCallback: subscriptionFailedCallback } = this.subscriptionObserverMap.get(id) || {};
        $86064b38d58ca2f6$var$logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $86064b38d58ca2f6$var$logger.debug(`observer not found for id: ${id}`);
            return;
        }
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_START_ACK) {
            $86064b38d58ca2f6$var$logger.debug(`subscription ready for ${JSON.stringify({
                query: query,
                variables: variables
            })}`);
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            $86064b38d58ca2f6$var$dispatchApiEvent({
                event: (0, $OwgYH.CONTROL_MSG).SUBSCRIPTION_ACK,
                data: {
                    query: query,
                    variables: variables
                },
                message: "Connection established for subscription"
            });
            const subscriptionState = (0, $fuDKT.SUBSCRIPTION_STATUS).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_KEEP_ALIVE) {
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            this.keepAliveTimeoutId = setTimeout(()=>this._errorDisconnect((0, $OwgYH.CONTROL_MSG).TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            this.keepAliveAlertTimeoutId = setTimeout(()=>{
                this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).KEEP_ALIVE_MISSED);
            }, (0, $fuDKT.DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT));
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).KEEP_ALIVE);
            return;
        }
        if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_ERROR) {
            const subscriptionState = (0, $fuDKT.SUBSCRIPTION_STATUS).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                $86064b38d58ca2f6$var$logger.debug(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${JSON.stringify(payload)}`);
                observer.error({
                    errors: [
                        {
                            ...new (0, $fHcz3.GraphQLError)(`${(0, $OwgYH.CONTROL_MSG).CONNECTION_FAILED}: ${JSON.stringify(payload)}`)
                        }
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
            }
        }
    }
    _errorDisconnect(msg) {
        $86064b38d58ca2f6$var$logger.debug(`Disconnect error: ${msg}`);
        if (this.awsRealTimeSocket) {
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED);
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
    }
    _timeoutStartSubscriptionAck(subscriptionId) {
        const subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            const { observer: observer, query: query, variables: variables } = subscriptionObserver;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, $fuDKT.SUBSCRIPTION_STATUS).FAILED
            });
            this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CLOSED);
            $86064b38d58ca2f6$var$logger.debug("timeoutStartSubscription", JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    }
    _initializeWebSocketConnection({ appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, authenticationType: authenticationType, apiKey: apiKey, region: region, additionalCustomHeaders: additionalCustomHeaders }) {
        if (this.socketStatus === (0, $fuDKT.SOCKET_STATUS).READY) return;
        return new Promise(async (res, rej)=>{
            this.promiseArray.push({
                res: res,
                rej: rej
            });
            if (this.socketStatus === (0, $fuDKT.SOCKET_STATUS).CLOSED) try {
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CONNECTING;
                const payloadString = "{}";
                const authHeader = await this._awsRealTimeHeaderBasedAuth({
                    authenticationType: authenticationType,
                    payload: payloadString,
                    canonicalUri: "/connect",
                    apiKey: apiKey,
                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                    region: region,
                    additionalCustomHeaders: additionalCustomHeaders
                });
                const headerString = authHeader ? JSON.stringify(authHeader) : "";
                const headerQs = (0, $ijwDq.base64Encoder).convert(headerString);
                const payloadQs = (0, $ijwDq.base64Encoder).convert(payloadString);
                let discoverableEndpoint = appSyncGraphqlEndpoint ?? "";
                if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat($86064b38d58ca2f6$var$customDomainPath);
                else discoverableEndpoint = discoverableEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                // Creating websocket url with required query strings
                const protocol = "wss://";
                discoverableEndpoint = discoverableEndpoint.replace("https://", protocol).replace("http://", protocol);
                const awsRealTimeUrl = `${discoverableEndpoint}?header=${headerQs}&payload=${payloadQs}`;
                await this._initializeRetryableHandshake(awsRealTimeUrl);
                this.promiseArray.forEach(({ res: res })=>{
                    $86064b38d58ca2f6$var$logger.debug("Notifying connection successful");
                    res();
                });
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).READY;
                this.promiseArray = [];
            } catch (err) {
                $86064b38d58ca2f6$var$logger.debug("Connection exited with", err);
                this.promiseArray.forEach(({ rej: rej })=>rej(err));
                this.promiseArray = [];
                if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                this.awsRealTimeSocket = undefined;
                this.socketStatus = (0, $fuDKT.SOCKET_STATUS).CLOSED;
            }
        });
    }
    async _initializeRetryableHandshake(awsRealTimeUrl) {
        $86064b38d58ca2f6$var$logger.debug(`Initializaling retryable Handshake`);
        await (0, $01Ziv.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
            awsRealTimeUrl
        ], (0, $fuDKT.MAX_DELAY_MS));
    }
    async _initializeHandshake(awsRealTimeUrl) {
        $86064b38d58ca2f6$var$logger.debug(`Initializing handshake ${awsRealTimeUrl}`);
        // Because connecting the socket is async, is waiting until connection is open
        // Step 1: connect websocket
        try {
            await (()=>{
                return new Promise((res, rej)=>{
                    const newSocket = this.getNewWebSocket(awsRealTimeUrl, "graphql-ws");
                    newSocket.onerror = ()=>{
                        $86064b38d58ca2f6$var$logger.debug(`WebSocket connection error`);
                    };
                    newSocket.onclose = ()=>{
                        rej(new Error("Connection handshake error"));
                    };
                    newSocket.onopen = ()=>{
                        this.awsRealTimeSocket = newSocket;
                        return res();
                    };
                });
            })();
            // Step 2: wait for ack from AWS AppSyncReaTime after sending init
            await (()=>{
                return new Promise((res, rej)=>{
                    if (this.awsRealTimeSocket) {
                        let ackOk = false;
                        this.awsRealTimeSocket.onerror = (error)=>{
                            $86064b38d58ca2f6$var$logger.debug(`WebSocket error ${JSON.stringify(error)}`);
                        };
                        this.awsRealTimeSocket.onclose = (event)=>{
                            $86064b38d58ca2f6$var$logger.debug(`WebSocket closed ${event.reason}`);
                            rej(new Error(JSON.stringify(event)));
                        };
                        this.awsRealTimeSocket.onmessage = (message)=>{
                            if (typeof message.data !== "string") return;
                            $86064b38d58ca2f6$var$logger.debug(`subscription message from AWS AppSyncRealTime: ${message.data} `);
                            const data = JSON.parse(message.data);
                            const { type: type, payload: { connectionTimeoutMs: connectionTimeoutMs = (0, $fuDKT.DEFAULT_KEEP_ALIVE_TIMEOUT) } = {} } = data;
                            if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_ACK) {
                                ackOk = true;
                                if (this.awsRealTimeSocket) {
                                    this.keepAliveTimeout = connectionTimeoutMs;
                                    this.awsRealTimeSocket.onmessage = this._handleIncomingSubscriptionMessage.bind(this);
                                    this.awsRealTimeSocket.onerror = (err)=>{
                                        $86064b38d58ca2f6$var$logger.debug(err);
                                        this._errorDisconnect((0, $OwgYH.CONTROL_MSG).CONNECTION_CLOSED);
                                    };
                                    this.awsRealTimeSocket.onclose = (event)=>{
                                        $86064b38d58ca2f6$var$logger.debug(`WebSocket closed ${event.reason}`);
                                        this._errorDisconnect((0, $OwgYH.CONTROL_MSG).CONNECTION_CLOSED);
                                    };
                                }
                                res("Cool, connected to AWS AppSyncRealTime");
                                return;
                            }
                            if (type === (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_ERROR) {
                                const { payload: { errors: [{ errorType: errorType = "", errorCode: errorCode = 0 } = {}] = [] } = {} } = data;
                                rej({
                                    errorType: errorType,
                                    errorCode: errorCode
                                });
                            }
                        };
                        const gqlInit = {
                            type: (0, $fuDKT.MESSAGE_TYPES).GQL_CONNECTION_INIT
                        };
                        this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                        const checkAckOk = (ackOk)=>{
                            if (!ackOk) {
                                this.connectionStateMonitor.record((0, $7LQNq.CONNECTION_CHANGE).CONNECTION_FAILED);
                                rej(new Error(`Connection timeout: ack from AWSAppSyncRealTime was not received after ${(0, $fuDKT.CONNECTION_INIT_TIMEOUT)} ms`));
                            }
                        };
                        setTimeout(()=>checkAckOk(ackOk), (0, $fuDKT.CONNECTION_INIT_TIMEOUT));
                    }
                });
            })();
        } catch (err) {
            const { errorType: errorType, errorCode: errorCode } = err;
            if ((0, $fuDKT.NON_RETRYABLE_CODES).includes(errorCode)) throw new (0, $i62vd.NonRetryableError)(errorType);
            else if (errorType) throw new Error(errorType);
            else throw err;
        }
    }
    async _awsRealTimeHeaderBasedAuth({ apiKey: apiKey, authenticationType: authenticationType, payload: payload, canonicalUri: canonicalUri, appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, region: region, additionalCustomHeaders: additionalCustomHeaders }) {
        const headerHandler = {
            apiKey: this._awsRealTimeApiKeyHeader.bind(this),
            iam: this._awsRealTimeIAMHeader.bind(this),
            oidc: this._awsAuthTokenHeader.bind(this),
            userPool: this._awsAuthTokenHeader.bind(this),
            lambda: this._customAuthHeader,
            none: this._customAuthHeader
        };
        if (!authenticationType || !headerHandler[authenticationType]) {
            $86064b38d58ca2f6$var$logger.debug(`Authentication type ${authenticationType} not supported`);
            return undefined;
        } else {
            const handler = headerHandler[authenticationType];
            const host = appSyncGraphqlEndpoint ? new (0, $7Ar4G.AmplifyUrl)(appSyncGraphqlEndpoint).host : undefined;
            $86064b38d58ca2f6$var$logger.debug(`Authenticating with ${JSON.stringify(authenticationType)}`);
            let resolvedApiKey;
            if (authenticationType === "apiKey") resolvedApiKey = apiKey;
            const result = await handler({
                payload: payload,
                canonicalUri: canonicalUri,
                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                apiKey: resolvedApiKey,
                region: region,
                host: host,
                additionalCustomHeaders: additionalCustomHeaders
            });
            return result;
        }
    }
    async _awsAuthTokenHeader({ host: host }) {
        const session = await (0, $kwYKv.fetchAuthSession)();
        return {
            Authorization: session?.tokens?.accessToken?.toString(),
            host: host
        };
    }
    async _awsRealTimeApiKeyHeader({ apiKey: apiKey, host: host }) {
        const dt = new Date();
        const dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
        return {
            host: host,
            "x-amz-date": dtStr,
            "x-api-key": apiKey
        };
    }
    async _awsRealTimeIAMHeader({ payload: payload, canonicalUri: canonicalUri, appSyncGraphqlEndpoint: appSyncGraphqlEndpoint, region: region }) {
        const endpointInfo = {
            region: region,
            service: "appsync"
        };
        const creds = (await (0, $kwYKv.fetchAuthSession)()).credentials;
        const request = {
            url: `${appSyncGraphqlEndpoint}${canonicalUri}`,
            data: payload,
            method: "POST",
            headers: {
                ...(0, $fuDKT.AWS_APPSYNC_REALTIME_HEADERS)
            }
        };
        const signed_params = (0, $hVfGq.signRequest)({
            headers: request.headers,
            method: request.method,
            url: new (0, $7Ar4G.AmplifyUrl)(request.url),
            body: request.data
        }, {
            // TODO: What do we need to do to remove these !'s?
            credentials: creds,
            signingRegion: endpointInfo.region,
            signingService: endpointInfo.service
        });
        return signed_params.headers;
    }
    _customAuthHeader({ host: host, additionalCustomHeaders: additionalCustomHeaders }) {
        /**
         * If `additionalHeaders` was provided to the subscription as a function,
         * the headers that are returned by that function will already have been
         * provided before this function is called.
         */ if (!additionalCustomHeaders?.["Authorization"]) throw new Error("No auth token specified");
        return {
            Authorization: additionalCustomHeaders.Authorization,
            host: host
        };
    }
}

});
parcelRegister("kwYKv", function(module, exports) {

$parcel$export(module.exports, "fetchAuthSession", () => $83614fd30266723c$export$39430dfe49142ae);

var $eL2i9 = parcelRequire("eL2i9");

var $1qbEC = parcelRequire("1qbEC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $83614fd30266723c$export$39430dfe49142ae = (options)=>{
    return (0, $eL2i9.fetchAuthSession)((0, $1qbEC.Amplify), options);
};

});
parcelRegister("eL2i9", function(module, exports) {

$parcel$export(module.exports, "fetchAuthSession", () => $bb56c3c3b8aca32b$export$39430dfe49142ae);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bb56c3c3b8aca32b$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};

});


parcelRegister("3jt4M", function(module, exports) {

$parcel$export(module.exports, "amplifyUuid", () => $1e1861aa821bc2be$export$80bbb53510529a00);

var $5sKyw = parcelRequire("5sKyw");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1e1861aa821bc2be$export$80bbb53510529a00 = (0, $5sKyw.default);

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRegister("ijwDq", function(module, exports) {

$parcel$export(module.exports, "base64Encoder", () => $a67be9353d05d3e6$export$695b149896bd3e2a);

var $dfMUF = parcelRequire("dfMUF");

var $1AT8d = parcelRequire("1AT8d");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a67be9353d05d3e6$export$695b149896bd3e2a = {
    convert (input, { urlSafe: urlSafe } = {
        urlSafe: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $1AT8d.bytesToString)(input);
        const encodedStr = (0, $dfMUF.getBtoa)()(inputStr);
        // see details about the char replacing at https://datatracker.ietf.org/doc/html/rfc4648#section-5
        return urlSafe ? encodedStr.replace(/\+/g, "-").replace(/\//g, "_") : encodedStr;
    }
};

});
parcelRegister("1AT8d", function(module, exports) {

$parcel$export(module.exports, "bytesToString", () => $2388b4cedba94ebc$export$7c746b75f47c9c7d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $2388b4cedba94ebc$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}

});


parcelRegister("g2b7y", function(module, exports) {

$parcel$export(module.exports, "isNonRetryableError", () => $e8dbabe11e4625cd$export$490cab1f6f83794d);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e8dbabe11e4625cd$export$490cab1f6f83794d = (obj)=>{
    const key = "nonRetryable";
    return obj && obj[key];
};

});

parcelRegister("01Ziv", function(module, exports) {

$parcel$export(module.exports, "jitteredExponentialRetry", () => $dc95ff395620ab33$export$a24aa7705df9cf44);

var $1Ns4m = parcelRequire("1Ns4m");

var $h05tY = parcelRequire("h05tY");

var $1jQno = parcelRequire("1jQno");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ const $dc95ff395620ab33$export$a24aa7705df9cf44 = (functionToRetry, args, maxDelayMs = (0, $1Ns4m.MAX_DELAY_MS), onTerminate)=>(0, $1jQno.retry)(functionToRetry, args, (0, $h05tY.jitteredBackoff)(maxDelayMs), onTerminate);

});
parcelRegister("1jQno", function(module, exports) {

$parcel$export(module.exports, "retry", () => $3640de013fea6a9b$export$9369b12211e1fce4);

var $gJw02 = parcelRequire("gJw02");

var $g2b7y = parcelRequire("g2b7y");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3640de013fea6a9b$var$logger = new (0, $gJw02.ConsoleLogger)("retryUtil");
/**
 * @private
 * Internal use of Amplify only
 */ async function $3640de013fea6a9b$export$9369b12211e1fce4(functionToRetry, args, delayFn, onTerminate) {
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    return new Promise(async (resolve, reject)=>{
        let attempt = 0;
        let terminated = false;
        let timeout;
        let wakeUp = ()=>{}; // will be replaced with a resolver()
        // used after the loop if terminated while waiting for a timer.
        let lastError;
        onTerminate && onTerminate.then(()=>{
            // signal not to try anymore.
            terminated = true;
            // stop sleeping if we're sleeping.
            clearTimeout(timeout);
            wakeUp();
        });
        while(!terminated){
            attempt++;
            $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} attempt #${attempt} with this vars: ${JSON.stringify(args)}`);
            try {
                return resolve(await functionToRetry(...args));
            } catch (err) {
                lastError = err;
                $3640de013fea6a9b$var$logger.debug(`error on ${functionToRetry.name}`, err);
                if ((0, $g2b7y.isNonRetryableError)(err)) {
                    $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} non retryable error`, err);
                    return reject(err);
                }
                const retryIn = delayFn(attempt, args, err);
                $3640de013fea6a9b$var$logger.debug(`${functionToRetry.name} retrying in ${retryIn} ms`);
                // we check `terminated` again here because it could have flipped
                // in the time it took `functionToRetry` to return.
                if (retryIn === false || terminated) return reject(err);
                else await new Promise((r)=>{
                    wakeUp = r; // export wakeUp for onTerminate handling
                    timeout = setTimeout(wakeUp, retryIn);
                });
            }
        }
        // reached if terminated while waiting for a timer.
        reject(lastError);
    });
}

});


parcelRegister("i62vd", function(module, exports) {

$parcel$export(module.exports, "NonRetryableError", () => $4a5528a46d771b76$export$1e38badc838ad384);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $4a5528a46d771b76$export$1e38badc838ad384 extends Error {
    constructor(message){
        super(message);
        this.nonRetryable = true;
    }
}

});

parcelRegister("OwgYH", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", () => $e94925d7f6d2ab83$export$f96baa4bc836aea4);
$parcel$export(module.exports, "ConnectionState", () => $e94925d7f6d2ab83$export$cd9c3c6bf535afc9);
var $e94925d7f6d2ab83$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($e94925d7f6d2ab83$export$f96baa4bc836aea4 || ($e94925d7f6d2ab83$export$f96baa4bc836aea4 = {}));
/** @enum {string} */ var $e94925d7f6d2ab83$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})($e94925d7f6d2ab83$export$cd9c3c6bf535afc9 || ($e94925d7f6d2ab83$export$cd9c3c6bf535afc9 = {}));

});

parcelRegister("fuDKT", function(module, exports) {

$parcel$export(module.exports, "MAX_DELAY_MS", () => $cc2a59cca225035e$export$76041b1400befb8b);
$parcel$export(module.exports, "NON_RETRYABLE_CODES", () => $cc2a59cca225035e$export$d0eacfe8369b1f8e);
$parcel$export(module.exports, "CONNECTION_STATE_CHANGE", () => $cc2a59cca225035e$export$a222eb271a4ce46b);
$parcel$export(module.exports, "MESSAGE_TYPES", () => $cc2a59cca225035e$export$e5fcfdba4a8ae715);
$parcel$export(module.exports, "SUBSCRIPTION_STATUS", () => $cc2a59cca225035e$export$50fc1b1dccfe0f97);
$parcel$export(module.exports, "SOCKET_STATUS", () => $cc2a59cca225035e$export$453843f36861c0a2);
$parcel$export(module.exports, "AWS_APPSYNC_REALTIME_HEADERS", () => $cc2a59cca225035e$export$7a236fa930e45f72);
$parcel$export(module.exports, "CONNECTION_INIT_TIMEOUT", () => $cc2a59cca225035e$export$c36bbd48cffe7fa4);
$parcel$export(module.exports, "START_ACK_TIMEOUT", () => $cc2a59cca225035e$export$c6bc4b7cffb2ca8);
$parcel$export(module.exports, "DEFAULT_KEEP_ALIVE_TIMEOUT", () => $cc2a59cca225035e$export$71a299b29e2098f0);
$parcel$export(module.exports, "DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT", () => $cc2a59cca225035e$export$2cb64c85846dde7d);
$parcel$export(module.exports, "RECONNECT_DELAY", () => $cc2a59cca225035e$export$6040e6f953ecf619);
$parcel$export(module.exports, "RECONNECT_INTERVAL", () => $cc2a59cca225035e$export$6229bdb3fed88d41);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cc2a59cca225035e$export$76041b1400befb8b = 5000;
const $cc2a59cca225035e$export$d0eacfe8369b1f8e = [
    400,
    401,
    403
];
const $cc2a59cca225035e$export$a222eb271a4ce46b = "ConnectionStateChange";
var $cc2a59cca225035e$export$e5fcfdba4a8ae715;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})($cc2a59cca225035e$export$e5fcfdba4a8ae715 || ($cc2a59cca225035e$export$e5fcfdba4a8ae715 = {}));
var $cc2a59cca225035e$export$50fc1b1dccfe0f97;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($cc2a59cca225035e$export$50fc1b1dccfe0f97 || ($cc2a59cca225035e$export$50fc1b1dccfe0f97 = {}));
var $cc2a59cca225035e$export$453843f36861c0a2;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($cc2a59cca225035e$export$453843f36861c0a2 || ($cc2a59cca225035e$export$453843f36861c0a2 = {}));
const $cc2a59cca225035e$export$7a236fa930e45f72 = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */ const $cc2a59cca225035e$export$c36bbd48cffe7fa4 = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */ const $cc2a59cca225035e$export$c6bc4b7cffb2ca8 = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ const $cc2a59cca225035e$export$71a299b29e2098f0 = 300000;
/**
 * Default Time in milleseconds to alert for missed GQL_CONNECTION_KEEP_ALIVE message
 */ const $cc2a59cca225035e$export$2cb64c85846dde7d = 65000;
/**
 * Default delay time in milleseconds between when reconnect is triggered vs when it is attempted
 */ const $cc2a59cca225035e$export$6040e6f953ecf619 = 5000;
/**
 * Default interval time in milleseconds between when reconnect is re-attempted
 */ const $cc2a59cca225035e$export$6229bdb3fed88d41 = 60000;

});

parcelRegister("7LQNq", function(module, exports) {

$parcel$export(module.exports, "CONNECTION_CHANGE", () => $69f8b000bf003237$export$77ad93647ea34124);
$parcel$export(module.exports, "ConnectionStateMonitor", () => $69f8b000bf003237$export$d8916ed266c478dd);

var $d6DLj = parcelRequire("d6DLj");
var $d4PzE = parcelRequire("d4PzE");
var $6OiYn = parcelRequire("6OiYn");

var $OwgYH = parcelRequire("OwgYH");

var $3cx2X = parcelRequire("3cx2X");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69f8b000bf003237$export$77ad93647ea34124 = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: "unhealthy"
    },
    KEEP_ALIVE: {
        keepAliveState: "healthy"
    },
    CONNECTION_ESTABLISHED: {
        connectionState: "connected"
    },
    CONNECTION_FAILED: {
        intendedConnectionState: "disconnected",
        connectionState: "disconnected"
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: "disconnected"
    },
    OPENING_CONNECTION: {
        intendedConnectionState: "connected",
        connectionState: "connecting"
    },
    CLOSED: {
        connectionState: "disconnected"
    },
    ONLINE: {
        networkState: "connected"
    },
    OFFLINE: {
        networkState: "disconnected"
    }
};
class $69f8b000bf003237$export$d8916ed266c478dd {
    constructor(){
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: "connected",
            connectionState: "disconnected",
            intendedConnectionState: "disconnected",
            keepAliveState: "healthy"
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, $3cx2X.ReachabilityMonitor)().subscribe(({ online: online })=>{
            this.record(online ? $69f8b000bf003237$export$77ad93647ea34124.ONLINE : $69f8b000bf003237$export$77ad93647ea34124.OFFLINE);
            this._initialNetworkStateSubscription?.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, $6OiYn.Observable)((connectionStateObserver)=>{
            connectionStateObserver.next(this._linkedConnectionState);
            this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ enableNetworkMonitoring() {
        // If no initial network state was discovered, stop trying
        this._initialNetworkStateSubscription?.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, $3cx2X.ReachabilityMonitor)().subscribe(({ online: online })=>{
            this.record(online ? $69f8b000bf003237$export$77ad93647ea34124.ONLINE : $69f8b000bf003237$export$77ad93647ea34124.OFFLINE);
        });
    }
    /**
     * Turn network state monitoring off if it isn't off already
     */ disableNetworkMonitoring() {
        this._networkMonitoringSubscription?.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    }
    /**
     * Get the observable that allows us to monitor the connection state
     *
     * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
     */ get connectionStateObservable() {
        let previous;
        // The linked state aggregates state changes to any of the network, connection,
        // intendedConnection and keepAliveHealth. Some states will change these independent
        // states without changing the overall connection state.
        // After translating from linked states to ConnectionState, then remove any duplicates
        return this._linkedConnectionStateObservable.pipe((0, $d4PzE.map)((value)=>{
            return this.connectionStatesTranslator(value);
        })).pipe((0, $d6DLj.filter)((current)=>{
            const toInclude = current !== previous;
            previous = current;
            return toInclude;
        }));
    }
    /*
     * Updates local connection state and emits the full state to the observer.
     */ record(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === "connected") this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === "disconnected") this.disableNetworkMonitoring();
        // Maintain the socket state
        const newSocketStatus = {
            ...this._linkedConnectionState,
            ...statusUpdates
        };
        this._linkedConnectionState = {
            ...newSocketStatus
        };
        this._linkedConnectionStateObserver?.next(this._linkedConnectionState);
    }
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ connectionStatesTranslator({ connectionState: connectionState, networkState: networkState, intendedConnectionState: intendedConnectionState, keepAliveState: keepAliveState }) {
        if (connectionState === "connected" && networkState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectedPendingNetwork;
        if (connectionState === "connected" && intendedConnectionState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectedPendingDisconnect;
        if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected") return (0, $OwgYH.ConnectionState).ConnectionDisruptedPendingNetwork;
        if (connectionState === "disconnected" && intendedConnectionState === "connected") return (0, $OwgYH.ConnectionState).ConnectionDisrupted;
        if (connectionState === "connected" && keepAliveState === "unhealthy") return (0, $OwgYH.ConnectionState).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === "connecting") return (0, $OwgYH.ConnectionState).Connecting;
        if (connectionState === "disconnected") return (0, $OwgYH.ConnectionState).Disconnected;
        return (0, $OwgYH.ConnectionState).Connected;
    }
}

});
parcelRegister("d6DLj", function(module, exports) {

$parcel$export(module.exports, "filter", () => $98aaadcfa91e6727$export$3dea766d36a8935f);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("d4PzE", function(module, exports) {

$parcel$export(module.exports, "map", () => $9853a79d111e4e33$export$871de8747c9eaa88);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("3cx2X", function(module, exports) {

$parcel$export(module.exports, "ReachabilityMonitor", () => $e84318ed5419b5d0$export$2636160e319be4f9);

var $apURp = parcelRequire("apURp");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e84318ed5419b5d0$export$2636160e319be4f9 = ()=>new (0, $apURp.Reachability)().networkMonitor();

});
parcelRegister("apURp", function(module, exports) {

$parcel$export(module.exports, "Reachability", () => $c2db73d795074c30$export$ccee288f4c11aa98);

var $46Tqd = parcelRequire("46Tqd");
var $6OiYn = parcelRequire("6OiYn");


var $lt7Sl = parcelRequire("lt7Sl");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $c2db73d795074c30$export$ccee288f4c11aa98 {
    networkMonitor(_) {
        const globalObj = (0, $lt7Sl.isWebWorker)() ? self : typeof window !== "undefined" && window;
        if (!globalObj) return (0, $46Tqd.from)([
            {
                online: true
            }
        ]);
        return new (0, $6OiYn.Observable)((observer)=>{
            observer.next({
                online: globalObj.navigator.onLine
            });
            const notifyOnline = ()=>observer.next({
                    online: true
                });
            const notifyOffline = ()=>observer.next({
                    online: false
                });
            globalObj.addEventListener("online", notifyOnline);
            globalObj.addEventListener("offline", notifyOffline);
            $c2db73d795074c30$export$ccee288f4c11aa98._observers.push(observer);
            return ()=>{
                globalObj.removeEventListener("online", notifyOnline);
                globalObj.removeEventListener("offline", notifyOffline);
                $c2db73d795074c30$export$ccee288f4c11aa98._observers = $c2db73d795074c30$export$ccee288f4c11aa98._observers.filter((_observer)=>_observer !== observer);
            };
        });
    }
    // expose observers to simulate offline mode for integration testing
    static _observerOverride(status) {
        for (const observer of this._observers){
            if (observer.closed) {
                this._observers = this._observers.filter((_observer)=>_observer !== observer);
                continue;
            }
            observer?.next && observer.next(status);
        }
    }
}
$c2db73d795074c30$export$ccee288f4c11aa98._observers = [];

});
parcelRegister("46Tqd", function(module, exports) {

$parcel$export(module.exports, "from", () => $2fe2b696577919a5$export$6788812c4e6611e6);

var $ci5Ul = parcelRequire("ci5Ul");

var $2ypWW = parcelRequire("2ypWW");
function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $ci5Ul.scheduled)(input, scheduler) : (0, $2ypWW.innerFrom)(input);
}

});
parcelRegister("ci5Ul", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $8f2bbfa9b5105688$export$49c44dfc2bb21d70);

var $jxGcZ = parcelRequire("jxGcZ");

var $aS4Ip = parcelRequire("aS4Ip");

var $16Erw = parcelRequire("16Erw");

var $4ZsdA = parcelRequire("4ZsdA");

var $i3S70 = parcelRequire("i3S70");

var $rOw2q = parcelRequire("rOw2q");

var $dy1jD = parcelRequire("dy1jD");

var $bGCU7 = parcelRequire("bGCU7");

var $fQMll = parcelRequire("fQMll");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $7gZl2 = parcelRequire("7gZl2");

var $arhob = parcelRequire("arhob");
function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return (0, $jxGcZ.scheduleObservable)(input, scheduler);
        if ((0, $bGCU7.isArrayLike)(input)) return (0, $16Erw.scheduleArray)(input, scheduler);
        if ((0, $dy1jD.isPromise)(input)) return (0, $aS4Ip.schedulePromise)(input, scheduler);
        if ((0, $aGtFl.isAsyncIterable)(input)) return (0, $i3S70.scheduleAsyncIterable)(input, scheduler);
        if ((0, $fQMll.isIterable)(input)) return (0, $4ZsdA.scheduleIterable)(input, scheduler);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return (0, $arhob.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}

});
parcelRegister("jxGcZ", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $e3a1d71c442b5de9$export$ed8bd553a12b6a30);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});
parcelRegister("3blUb", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $25136415cad576bc$export$9007f49c319d1ac7);

var $4yU8l = parcelRequire("4yU8l");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});
parcelRegister("4yU8l", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $3525e15e439f8b93$export$a2b7447487315232);
function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});


parcelRegister("iNvbf", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $daf4fd612cb884aa$export$1eb44d8f5f64733b);

var $d9kQQ = parcelRequire("d9kQQ");
function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("aS4Ip", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $7ea29ae5d684fb04$export$fc9afd948577f0a8);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});

parcelRegister("16Erw", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $0ce5b91768be0a6d$export$b34673931371729a);

var $6OiYn = parcelRequire("6OiYn");
function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("4ZsdA", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $3a22bf76b9b6de63$export$2b75c58ab9b5b766);

var $6OiYn = parcelRequire("6OiYn");

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");

var $4yU8l = parcelRequire("4yU8l");
function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var iterator;
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $ZpNjd.iterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $gCSeg.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("i3S70", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $d2627b52a3f1ff1b$export$7c7f0979b56a32f3);

var $6OiYn = parcelRequire("6OiYn");

var $4yU8l = parcelRequire("4yU8l");
function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $6OiYn.Observable)(function(subscriber) {
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("arhob", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $7999ea1c5b71ad25$export$3385251aeecad28a);

var $i3S70 = parcelRequire("i3S70");

var $7gZl2 = parcelRequire("7gZl2");
function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $i3S70.scheduleAsyncIterable)((0, $7gZl2.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});



parcelRegister("lt7Sl", function(module, exports) {

$parcel$export(module.exports, "isWebWorker", () => $1f1375287e0673d4$export$97b87b8868ff7a3c);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1f1375287e0673d4$export$97b87b8868ff7a3c = ()=>{
    if (typeof self === "undefined") return false;
    const selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};

});




parcelRegister("bDWoz", function(module, exports) {

$parcel$export(module.exports, "ReconnectEvent", () => $4197e818e967ca46$export$ce528341f93f43f1);
$parcel$export(module.exports, "ReconnectionMonitor", () => $4197e818e967ca46$export$6d01b279c51a2afb);

var $fuDKT = parcelRequire("fuDKT");
var $4197e818e967ca46$export$ce528341f93f43f1;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})($4197e818e967ca46$export$ce528341f93f43f1 || ($4197e818e967ca46$export$ce528341f93f43f1 = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ class $4197e818e967ca46$export$6d01b279c51a2afb {
    constructor(){
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ addObserver(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    }
    /**
     * Given a reconnect event, start the appropriate behavior
     */ record(event) {
        if (event === $4197e818e967ca46$export$ce528341f93f43f1.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(()=>{
                // Reconnect now
                this._triggerReconnect();
                // Retry reconnect every periodically until it works
                this.reconnectIntervalId = setInterval(()=>{
                    this._triggerReconnect();
                }, (0, $fuDKT.RECONNECT_INTERVAL));
            }, (0, $fuDKT.RECONNECT_DELAY));
        }
        if (event === $4197e818e967ca46$export$ce528341f93f43f1.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    }
    /**
     * Complete all reconnect observers
     */ close() {
        this.reconnectObservers.forEach((reconnectObserver)=>{
            reconnectObserver.complete?.();
        });
    }
    _triggerReconnect() {
        this.reconnectObservers.forEach((reconnectObserver)=>{
            reconnectObserver.next?.();
        });
    }
}

});


parcelRegister("4un4F", function(module, exports) {

$parcel$export(module.exports, "resolveConfig", () => $195ef80a28056421$export$7eca4ea16d4c8343);

var $gJw02 = parcelRequire("gJw02");


var $iGqn8 = parcelRequire("iGqn8");

var $025mJ = parcelRequire("025mJ");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $195ef80a28056421$var$logger = new (0, $gJw02.ConsoleLogger)("GraphQLAPI resolveConfig");
/**
 * @internal
 */ const $195ef80a28056421$export$7eca4ea16d4c8343 = (amplify)=>{
    const config = amplify.getConfig();
    if (!config.API?.GraphQL) $195ef80a28056421$var$logger.warn("The API configuration is missing. This is likely due to Amplify.configure() not being called prior to generateClient().");
    const { apiKey: apiKey, customEndpoint: customEndpoint, customEndpointRegion: customEndpointRegion, defaultAuthMode: defaultAuthMode, endpoint: endpoint, region: region } = config.API?.GraphQL ?? {};
    // TODO: re-enable when working in all test environments:
    // assertValidationError(!!endpoint, APIValidationErrorCode.NoEndpoint);
    (0, $iGqn8.assertValidationError)(!(!customEndpoint && customEndpointRegion), (0, $025mJ.APIValidationErrorCode).NoCustomEndpoint);
    return {
        apiKey: apiKey,
        customEndpoint: customEndpoint,
        customEndpointRegion: customEndpointRegion,
        defaultAuthMode: defaultAuthMode,
        endpoint: endpoint,
        region: region
    };
};

});
parcelRegister("iGqn8", function(module, exports) {

$parcel$export(module.exports, "assertValidationError", () => $838eb75e47a73edc$export$45936001d12f9b53);

var $aPZn6 = parcelRequire("aPZn6");

var $025mJ = parcelRequire("025mJ");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $838eb75e47a73edc$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $025mJ.validationErrorMap)[name];
    if (!assertion) throw new (0, $aPZn6.GraphQLApiError)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}

});
parcelRegister("aPZn6", function(module, exports) {

$parcel$export(module.exports, "GraphQLApiError", () => $e75a423e9aaaec77$export$1d95cbddd5b6dc7f);

var $e0exy = parcelRequire("e0exy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $e75a423e9aaaec77$export$1d95cbddd5b6dc7f extends (0, $e0exy.AmplifyError) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $e75a423e9aaaec77$export$1d95cbddd5b6dc7f;
        Object.setPrototypeOf(this, $e75a423e9aaaec77$export$1d95cbddd5b6dc7f.prototype);
    }
}

});

parcelRegister("025mJ", function(module, exports) {

$parcel$export(module.exports, "APIValidationErrorCode", () => $e1e0ad0aeee1ab28$export$f60466a0651ec80d);
$parcel$export(module.exports, "validationErrorMap", () => $e1e0ad0aeee1ab28$export$195137955146d376);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e1e0ad0aeee1ab28$export$f60466a0651ec80d;
(function(APIValidationErrorCode) {
    APIValidationErrorCode["NoAuthSession"] = "NoAuthSession";
    APIValidationErrorCode["NoRegion"] = "NoRegion";
    APIValidationErrorCode["NoCustomEndpoint"] = "NoCustomEndpoint";
})($e1e0ad0aeee1ab28$export$f60466a0651ec80d || ($e1e0ad0aeee1ab28$export$f60466a0651ec80d = {}));
const $e1e0ad0aeee1ab28$export$195137955146d376 = {
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoAuthSession]: {
        message: "Auth session should not be empty."
    },
    // TODO: re-enable when working in all test environments:
    // [APIValidationErrorCode.NoEndpoint]: {
    // 	message: 'Missing endpoint',
    // },
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoRegion]: {
        message: "Missing region."
    },
    [$e1e0ad0aeee1ab28$export$f60466a0651ec80d.NoCustomEndpoint]: {
        message: "Custom endpoint region is present without custom endpoint."
    }
};

});



parcelRegister("2bSZt", function(module, exports) {

$parcel$export(module.exports, "resolveLibraryOptions", () => $5ba9283f5eedfa02$export$101b589a61b1975e);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $5ba9283f5eedfa02$export$101b589a61b1975e = (amplify)=>{
    const headers = amplify.libraryOptions?.API?.GraphQL?.headers;
    const withCredentials = amplify.libraryOptions?.API?.GraphQL?.withCredentials;
    return {
        headers: headers,
        withCredentials: withCredentials
    };
};

});

parcelRegister("027iw", function(module, exports) {

$parcel$export(module.exports, "repackageUnauthError", () => $5bc2672d5026b0ee$export$132294d0bd987c58);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Checks to see if the given response or subscription message contains an
 * unauth error. If it does, it changes the error message to include instructions
 * for the app developer.
 */ function $5bc2672d5026b0ee$export$132294d0bd987c58(content) {
    if (content.errors && Array.isArray(content.errors)) content.errors.forEach((e)=>{
        if ($5bc2672d5026b0ee$var$isUnauthError(e)) {
            e.message = "Unauthorized";
            e.recoverySuggestion = `If you're calling an Amplify-generated API, make sure ` + `to set the "authMode" in generateClient({ authMode: '...' }) to the backend authorization ` + `rule's auth provider ('apiKey', 'userPool', 'iam', 'oidc', 'lambda')`;
        }
    });
    return content;
}
function $5bc2672d5026b0ee$var$isUnauthError(error) {
    // Error pattern corresponding to appsync calls
    if (error?.["originalError"]?.["name"]?.startsWith("UnauthorizedException")) return true;
    // Error pattern corresponding to appsync subscriptions
    if (error.message?.startsWith("Connection failed:") && error.message?.includes("Permission denied")) return true;
    return false;
}

});




parcelRegister("8cam8", function(module, exports) {

$parcel$export(module.exports, "generateModelsProperty", () => $676fbae06b1dd615$export$7aa40502ac76885f);

var $34Y9w = parcelRequire("34Y9w");

var $jrkdU = parcelRequire("jrkdU");

var $4Vvms = parcelRequire("4Vvms");

var $7fgpS = parcelRequire("7fgpS");

var $5mUlK = parcelRequire("5mUlK");
function $676fbae06b1dd615$export$7aa40502ac76885f(client, params) {
    const models = {};
    const config = params.amplify.getConfig();
    if (!config.API?.GraphQL) // breaks compatibility with certain bundler, e.g. Vite where component files are evaluated before
    // the entry point causing false positive errors. Revisit how to better handle this post-launch
    // throw new Error(
    // 	'The API configuration is missing. This is likely due to Amplify.configure() not being called
    // prior to generateClient().'
    // );
    return {};
    const modelIntrospection = config.API.GraphQL.modelIntrospection;
    if (!modelIntrospection) return {};
    const SUBSCRIPTION_OPS = [
        "ONCREATE",
        "ONUPDATE",
        "ONDELETE"
    ];
    for (const model of Object.values(modelIntrospection.models)){
        const { name: name } = model;
        models[name] = {};
        Object.entries((0, $34Y9w.graphQLOperationsInfo)).forEach(([key, { operationPrefix: operationPrefix }])=>{
            const operation = key;
            if (operation === "LIST") models[name][operationPrefix] = (0, $jrkdU.listFactory)(client, modelIntrospection, model);
            else if (SUBSCRIPTION_OPS.includes(operation)) models[name][operationPrefix] = (0, $7fgpS.subscriptionFactory)(client, modelIntrospection, model, operation);
            else if (operation === "OBSERVE_QUERY") models[name][operationPrefix] = (0, $5mUlK.observeQueryFactory)(models, model);
            else models[name][operationPrefix] = (0, $4Vvms.getFactory)(client, modelIntrospection, model, operation);
        });
    }
    return models;
}

});
parcelRegister("34Y9w", function(module, exports) {

$parcel$export(module.exports, "flattenItems", () => $ce6c69ad8e54ec20$export$a1df7bca853facc8);
$parcel$export(module.exports, "initializeModel", () => $ce6c69ad8e54ec20$export$2dab78d5abd0247d);
$parcel$export(module.exports, "graphQLOperationsInfo", () => $ce6c69ad8e54ec20$export$c2d7461810dc0165);
$parcel$export(module.exports, "generateGraphQLDocument", () => $ce6c69ad8e54ec20$export$d6645ba197f595e0);
$parcel$export(module.exports, "buildGraphQLVariables", () => $ce6c69ad8e54ec20$export$95bea254c9042858);
$parcel$export(module.exports, "authModeParams", () => $ce6c69ad8e54ec20$export$f5679e96571d0641);
$parcel$export(module.exports, "getCustomHeaders", () => $ce6c69ad8e54ec20$export$3fc25db7b420c1a4);

var $7y4CF = parcelRequire("7y4CF");

var $lvJDy = parcelRequire("lvJDy");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ce6c69ad8e54ec20$var$connectionType = {
    HAS_ONE: "HAS_ONE",
    HAS_MANY: "HAS_MANY",
    BELONGS_TO: "BELONGS_TO"
};
/**
 *
 * @param GraphQL response object
 * @returns response object with `items` properties flattened
 */ const $ce6c69ad8e54ec20$export$a1df7bca853facc8 = (obj)=>{
    const res = {};
    Object.entries(obj).forEach(([prop, value])=>{
        if (typeof value === "object" && !Array.isArray(value) && value !== null) {
            if (value.items !== undefined) {
                res[prop] = value.items.map((item)=>$ce6c69ad8e54ec20$export$a1df7bca853facc8(item));
                return;
            }
            res[prop] = $ce6c69ad8e54ec20$export$a1df7bca853facc8(value);
            return;
        }
        res[prop] = value;
    });
    return res;
};
// TODO: this should accept single result to support CRUD methods; create helper for array/list
function $ce6c69ad8e54ec20$export$2dab78d5abd0247d(client, modelName, result, modelIntrospection, authMode, authToken, context = false) {
    const introModel = modelIntrospection.models[modelName];
    const introModelFields = introModel.fields;
    const modelFields = Object.entries(introModelFields).filter(([_, field])=>field?.type?.model !== undefined).map(([fieldName])=>fieldName);
    return result.map((record)=>{
        const initializedRelationalFields = {};
        for (const fieldName of modelFields){
            const modelField = introModelFields[fieldName];
            const modelFieldType = modelField?.type;
            const relatedModelName = modelFieldType.model;
            const relatedModel = modelIntrospection.models[relatedModelName];
            const relatedModelPKFieldName = relatedModel.primaryKeyInfo.primaryKeyFieldName;
            const relatedModelSKFieldNames = relatedModel.primaryKeyInfo.sortKeyFieldNames;
            const relationType = modelField.association?.connectionType;
            let connectionFields = [];
            if (modelField.association && "associatedWith" in modelField.association) connectionFields = modelField.association.associatedWith;
            let targetNames = [];
            if (modelField.association && "targetNames" in modelField.association) targetNames = modelField.association.targetNames;
            switch(relationType){
                case $ce6c69ad8e54ec20$var$connectionType.HAS_ONE:
                case $ce6c69ad8e54ec20$var$connectionType.BELONGS_TO:
                    const sortKeyValues = relatedModelSKFieldNames.reduce((acc, curVal)=>{
                        if (record[curVal]) return acc[curVal] = record[curVal];
                    }, {});
                    if (context) initializedRelationalFields[fieldName] = (contextSpec, options)=>{
                        if (record[targetNames[0]]) return client.models[relatedModelName].get(contextSpec, {
                            [relatedModelPKFieldName]: record[targetNames[0]],
                            ...sortKeyValues
                        }, {
                            authMode: options?.authMode || authMode,
                            authToken: options?.authToken || authToken
                        });
                        return undefined;
                    };
                    else initializedRelationalFields[fieldName] = (options)=>{
                        if (record[targetNames[0]]) return client.models[relatedModelName].get({
                            [relatedModelPKFieldName]: record[targetNames[0]],
                            ...sortKeyValues
                        }, {
                            authMode: options?.authMode || authMode,
                            authToken: options?.authToken || authToken
                        });
                        return undefined;
                    };
                    break;
                case $ce6c69ad8e54ec20$var$connectionType.HAS_MANY:
                    const parentPk = introModel.primaryKeyInfo.primaryKeyFieldName;
                    const parentSK = introModel.primaryKeyInfo.sortKeyFieldNames;
                    // M:N check - TODO: refactor
                    const relatedModelField = relatedModel.fields[connectionFields[0]];
                    const relatedModelFieldType = relatedModelField.type;
                    if (relatedModelFieldType.model) {
                        let relatedTargetNames = [];
                        if (relatedModelField.association && "targetNames" in relatedModelField.association) relatedTargetNames = relatedModelField.association?.targetNames;
                        const hasManyFilter = relatedTargetNames.map((field, idx)=>{
                            if (idx === 0) return {
                                [field]: {
                                    eq: record[parentPk]
                                }
                            };
                            return {
                                [field]: {
                                    eq: record[parentSK[idx - 1]]
                                }
                            };
                        });
                        if (context) initializedRelationalFields[fieldName] = (contextSpec, options)=>{
                            if (record[parentPk]) return client.models[relatedModelName].list(contextSpec, {
                                filter: {
                                    and: hasManyFilter
                                },
                                limit: options?.limit,
                                nextToken: options?.nextToken,
                                authMode: options?.authMode || authMode,
                                authToken: options?.authToken || authToken
                            });
                            return [];
                        };
                        else initializedRelationalFields[fieldName] = (options)=>{
                            if (record[parentPk]) return client.models[relatedModelName].list({
                                filter: {
                                    and: hasManyFilter
                                },
                                limit: options?.limit,
                                nextToken: options?.nextToken,
                                authMode: options?.authMode || authMode,
                                authToken: options?.authToken || authToken
                            });
                            return [];
                        };
                        break;
                    }
                    const hasManyFilter = connectionFields.map((field, idx)=>{
                        if (idx === 0) return {
                            [field]: {
                                eq: record[parentPk]
                            }
                        };
                        return {
                            [field]: {
                                eq: record[parentSK[idx - 1]]
                            }
                        };
                    });
                    if (context) initializedRelationalFields[fieldName] = (contextSpec, options)=>{
                        if (record[parentPk]) return client.models[relatedModelName].list(contextSpec, {
                            filter: {
                                and: hasManyFilter
                            },
                            limit: options?.limit,
                            nextToken: options?.nextToken,
                            authMode: options?.authMode || authMode,
                            authToken: options?.authToken || authToken
                        });
                        return [];
                    };
                    else initializedRelationalFields[fieldName] = (options)=>{
                        if (record[parentPk]) return client.models[relatedModelName].list({
                            filter: {
                                and: hasManyFilter
                            },
                            limit: options?.limit,
                            nextToken: options?.nextToken,
                            authMode: options?.authMode || authMode,
                            authToken: options?.authToken || authToken
                        });
                        return [];
                    };
                    break;
            }
        }
        return {
            ...record,
            ...initializedRelationalFields
        };
    });
}
const $ce6c69ad8e54ec20$export$c2d7461810dc0165 = {
    CREATE: {
        operationPrefix: "create",
        usePlural: false
    },
    READ: {
        operationPrefix: "get",
        usePlural: false
    },
    UPDATE: {
        operationPrefix: "update",
        usePlural: false
    },
    DELETE: {
        operationPrefix: "delete",
        usePlural: false
    },
    LIST: {
        operationPrefix: "list",
        usePlural: true
    },
    ONCREATE: {
        operationPrefix: "onCreate",
        usePlural: false
    },
    ONUPDATE: {
        operationPrefix: "onUpdate",
        usePlural: false
    },
    ONDELETE: {
        operationPrefix: "onDelete",
        usePlural: false
    },
    OBSERVE_QUERY: {
        operationPrefix: "observeQuery",
        usePlural: false
    }
};
const $ce6c69ad8e54ec20$var$SELECTION_SET_WILDCARD = "*";
function $ce6c69ad8e54ec20$var$defaultSelectionSetForModel(modelDefinition) {
    // fields that are explicitly part of the graphql schema; not
    // inferred from owner auth rules.
    const { fields: fields } = modelDefinition;
    const explicitFields = Object.values(fields)// Default selection set omits model fields
    .map(({ type: type, name: name })=>(typeof type === "string" || typeof type === "object" && typeof type?.enum === "string") && name).filter(Boolean);
    // fields used for owner auth rules that may or may not also
    // be explicit on the model.
    const ownerFields = (0, $7y4CF.resolveOwnerFields)(modelDefinition);
    return Array.from(new Set(explicitFields.concat(ownerFields)));
}
const $ce6c69ad8e54ec20$var$FIELD_IR = "";
/**
 * Generates nested Custom Selection Set IR from path
 *
 * @param modelDefinitions
 * @param modelName
 * @param selectionSet - array of object paths
 * @example
 * ### Given
 * `selectionSet = ['id', 'comments.post.id']`
 * ### Returns
 * ```ts
 * {
 *   id: '',
 *   comments: {
 *     items: { post: { id: '' } }
 *   }
 * }
 * ```
 */ function $ce6c69ad8e54ec20$export$be1dc2e500ab0740(modelDefinitions, modelName, selectionSet) {
    const dotNotationToObject = (path, modelName)=>{
        const [fieldName, ...rest] = path.split(".");
        let result = {};
        if (rest.length === 0) result = {
            [fieldName]: $ce6c69ad8e54ec20$var$FIELD_IR
        };
        else {
            const nested = rest[0];
            const modelDefinition = modelDefinitions[modelName];
            const modelFields = modelDefinition.fields;
            const relatedModel = modelFields[fieldName]?.type?.model;
            if (!relatedModel) // TODO: may need to change this to support custom types
            throw Error(`${fieldName} is not a model field`);
            if (nested === $ce6c69ad8e54ec20$var$SELECTION_SET_WILDCARD) {
                const relatedModelDefinition = modelDefinitions[relatedModel];
                result = {
                    [fieldName]: $ce6c69ad8e54ec20$var$defaultSelectionSetIR(relatedModelDefinition)
                };
            } else {
                const exists = Boolean(modelFields[fieldName]);
                if (!exists) throw Error(`${fieldName} is not a field of model ${modelName}`);
                result = {
                    [fieldName]: dotNotationToObject(rest.join("."), relatedModel)
                };
            }
            if (modelFields[fieldName]?.isArray) result = {
                [fieldName]: {
                    items: result[fieldName]
                }
            };
        }
        return result;
    };
    return selectionSet.reduce((resultObj, path)=>$ce6c69ad8e54ec20$var$deepMergeSelectionSetObjects(dotNotationToObject(path, modelName), resultObj), {});
}
const $ce6c69ad8e54ec20$var$defaultSelectionSetIR = (relatedModelDefinition)=>{
    const defaultSelectionSet = $ce6c69ad8e54ec20$var$defaultSelectionSetForModel(relatedModelDefinition);
    const reduced = defaultSelectionSet.reduce((acc, curVal)=>{
        acc[curVal] = $ce6c69ad8e54ec20$var$FIELD_IR;
        return acc;
    }, {});
    return reduced;
};
/**
 * Stringifies selection set IR
 * * @example
 * ### Given
 * ```ts
 * {
 *   id: '',
 *   comments: {
 *     items: { post: { id: '' } }
 *   }
 * }
 * ```
 * ### Returns
 * `'id comments { items { post { id } } }'`
 */ function $ce6c69ad8e54ec20$export$c9a913a0e0b06132(obj) {
    const res = [];
    Object.entries(obj).forEach(([fieldName, value])=>{
        if (value === $ce6c69ad8e54ec20$var$FIELD_IR) res.push(fieldName);
        else if (typeof value === "object" && value !== null) {
            if (value?.items) res.push(fieldName, "{", "items", "{", $ce6c69ad8e54ec20$export$c9a913a0e0b06132(value.items), "}", "}");
            else res.push(fieldName, "{", $ce6c69ad8e54ec20$export$c9a913a0e0b06132(value), "}");
        }
    });
    return res.join(" ");
}
/**
 * Recursively merges selection set objects from `source` onto `target`.
 *
 * `target` will be updated. `source` will be left alone.
 *
 * @param source The object to merge into target.
 * @param target The object to be mutated.
 */ function $ce6c69ad8e54ec20$var$deepMergeSelectionSetObjects(source, target) {
    const isObject = (obj)=>obj && typeof obj === "object";
    for(const key in source){
        // This verification avoids 'Prototype Pollution' issue
        if (!source.hasOwnProperty(key)) continue;
        if (target.hasOwnProperty(key) && isObject(target[key])) $ce6c69ad8e54ec20$var$deepMergeSelectionSetObjects(source[key], target[key]);
        else target[key] = source[key];
    }
    return target;
}
function $ce6c69ad8e54ec20$export$f1b80cae6b6c9807(modelDefinitions, modelName, selectionSet) {
    const modelDefinition = modelDefinitions[modelName];
    if (!selectionSet) return $ce6c69ad8e54ec20$var$defaultSelectionSetForModel(modelDefinition).join(" ");
    const selSetIr = $ce6c69ad8e54ec20$export$be1dc2e500ab0740(modelDefinitions, modelName, selectionSet);
    const selSetString = $ce6c69ad8e54ec20$export$c9a913a0e0b06132(selSetIr);
    return selSetString;
}
function $ce6c69ad8e54ec20$export$d6645ba197f595e0(modelDefinitions, modelName, modelOperation, listArgs) {
    const modelDefinition = modelDefinitions[modelName];
    const { name: name, pluralName: pluralName, fields: fields, primaryKeyInfo: { isCustomPrimaryKey: isCustomPrimaryKey, primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames } } = modelDefinition;
    const { operationPrefix: operationPrefix, usePlural: usePlural } = $ce6c69ad8e54ec20$export$c2d7461810dc0165[modelOperation];
    const { selectionSet: selectionSet } = listArgs || {};
    const graphQLFieldName = `${operationPrefix}${usePlural ? pluralName : name}`;
    let graphQLOperationType;
    let graphQLSelectionSet;
    let graphQLArguments;
    const selectionSetFields = $ce6c69ad8e54ec20$export$f1b80cae6b6c9807(modelDefinitions, modelName, selectionSet);
    switch(modelOperation){
        case "CREATE":
        case "UPDATE":
        case "DELETE":
            graphQLArguments ?? (graphQLArguments = {
                input: `${operationPrefix.charAt(0).toLocaleUpperCase() + operationPrefix.slice(1)}${name}Input!`
            });
            graphQLOperationType ?? (graphQLOperationType = "mutation");
        case "READ":
            graphQLArguments ?? (graphQLArguments = isCustomPrimaryKey ? [
                primaryKeyFieldName,
                ...sortKeyFieldNames
            ].reduce((acc, fieldName)=>{
                acc[fieldName] = `${fields[fieldName].type}!`;
                return acc;
            }, {}) : {
                [primaryKeyFieldName]: `${fields[primaryKeyFieldName].type}!`
            });
            graphQLSelectionSet ?? (graphQLSelectionSet = selectionSetFields);
        case "LIST":
            graphQLArguments ?? (graphQLArguments = {
                filter: `Model${name}FilterInput`,
                limit: "Int",
                nextToken: "String"
            });
            graphQLOperationType ?? (graphQLOperationType = "query");
            graphQLSelectionSet ?? (graphQLSelectionSet = `items { ${selectionSetFields} } nextToken __typename`);
        case "ONCREATE":
        case "ONUPDATE":
        case "ONDELETE":
            graphQLArguments ?? (graphQLArguments = {
                filter: `ModelSubscription${name}FilterInput`
            });
            graphQLOperationType ?? (graphQLOperationType = "subscription");
            graphQLSelectionSet ?? (graphQLSelectionSet = selectionSetFields);
            break;
        case "OBSERVE_QUERY":
        default:
            throw new Error("Internal error: Attempted to generate graphql document for observeQuery. Please report this error.");
    }
    const graphQLDocument = `${graphQLOperationType}${graphQLArguments ? `(${Object.entries(graphQLArguments).map(([fieldName, type])=>`\$${fieldName}: ${type}`)})` : ""} { ${graphQLFieldName}${graphQLArguments ? `(${Object.keys(graphQLArguments).map((fieldName)=>`${fieldName}: \$${fieldName}`)})` : ""} { ${graphQLSelectionSet} } }`;
    return graphQLDocument;
}
function $ce6c69ad8e54ec20$export$95bea254c9042858(modelDefinition, operation, arg, modelIntrospection) {
    const { fields: fields, primaryKeyInfo: { isCustomPrimaryKey: isCustomPrimaryKey, primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames } } = modelDefinition;
    let variables = {};
    // TODO: process input
    switch(operation){
        case "CREATE":
            variables = {
                input: arg ? $ce6c69ad8e54ec20$export$ab9adbcee87919b5(arg, modelDefinition, modelIntrospection) : {}
            };
            break;
        case "UPDATE":
            // readonly fields are not  updated
            variables = {
                input: arg ? Object.fromEntries(Object.entries($ce6c69ad8e54ec20$export$ab9adbcee87919b5(arg, modelDefinition, modelIntrospection)).filter(([fieldName])=>{
                    const { isReadOnly: isReadOnly } = fields[fieldName];
                    return !isReadOnly;
                })) : {}
            };
            break;
        case "READ":
        case "DELETE":
            // only identifiers are sent
            if (arg) variables = isCustomPrimaryKey ? [
                primaryKeyFieldName,
                ...sortKeyFieldNames
            ].reduce((acc, fieldName)=>{
                acc[fieldName] = arg[fieldName];
                return acc;
            }, {}) : {
                [primaryKeyFieldName]: arg[primaryKeyFieldName]
            };
            if (operation === "DELETE") variables = {
                input: variables
            };
            break;
        case "LIST":
            if (arg?.filter) variables.filter = arg.filter;
            if (arg?.nextToken) variables.nextToken = arg.nextToken;
            if (arg?.limit) variables.limit = arg.limit;
            break;
        case "ONCREATE":
        case "ONUPDATE":
        case "ONDELETE":
            if (arg?.filter) variables = {
                filter: arg.filter
            };
            break;
        case "OBSERVE_QUERY":
            throw new Error("Internal error: Attempted to build variables for observeQuery. Please report this error.");
        default:
            const exhaustiveCheck = operation;
            throw new Error(`Unhandled operation case: ${exhaustiveCheck}`);
    }
    return variables;
}
/**
 * Iterates over mutation input values and resolves any model inputs to their corresponding join fields/values
 *
 * @example
 * ### Usage
 * ```ts
 * const result = normalizeMutationInput({ post: post }, model, modelDefinition);
 * ```
 * ### Result
 * ```ts
 * { postId: "abc123" }
 * ```
 *
 */ function $ce6c69ad8e54ec20$export$ab9adbcee87919b5(mutationInput, model, modelIntrospection) {
    const { fields: fields } = model;
    const normalized = {};
    Object.entries(mutationInput).forEach(([inputFieldName, inputValue])=>{
        const fieldType = fields[inputFieldName]?.type;
        const relatedModelName = fieldType?.model;
        if (relatedModelName) {
            const association = fields[inputFieldName]?.association;
            const relatedModelDef = modelIntrospection.models[relatedModelName];
            const relatedModelPkInfo = relatedModelDef.primaryKeyInfo;
            if (association?.connectionType === $ce6c69ad8e54ec20$var$connectionType.HAS_ONE) {
                const associationHasOne = association;
                associationHasOne.targetNames.forEach((targetName, idx)=>{
                    const associatedFieldName = associationHasOne.associatedWith[idx];
                    normalized[targetName] = inputValue[associatedFieldName];
                });
            }
            if (association?.connectionType === $ce6c69ad8e54ec20$var$connectionType.BELONGS_TO) {
                const associationBelongsTo = association;
                associationBelongsTo.targetNames.forEach((targetName, idx)=>{
                    if (idx === 0) {
                        const associatedFieldName = relatedModelPkInfo.primaryKeyFieldName;
                        normalized[targetName] = inputValue[associatedFieldName];
                    } else {
                        const associatedFieldName = relatedModelPkInfo.sortKeyFieldNames[idx - 1];
                        normalized[targetName] = inputValue[associatedFieldName];
                    }
                });
            }
        } else normalized[inputFieldName] = inputValue;
    });
    return normalized;
}
/**
 * Produces a parameter object that can contains auth mode/token overrides
 * only if present in either `options` (first) or configured on the `client`
 * as a fallback.
 *
 * @param client Configured client from `generateClient`
 * @param options Args/Options obect from call site.
 * @returns
 */ function $ce6c69ad8e54ec20$export$f5679e96571d0641(client, options = {}) {
    return {
        authMode: options.authMode || client[0, $lvJDy.__authMode],
        authToken: options.authToken || client[0, $lvJDy.__authToken]
    };
}
/**
 * Retrieves custom headers from either the client or request options.
 * @param {client} V6Client | V6ClientSSRRequest | V6ClientSSRCookies - for extracting client headers
 * @param {requestHeaders} [CustomHeaders] - request headers
 * @returns {CustomHeaders} - custom headers
 */ function $ce6c69ad8e54ec20$export$3fc25db7b420c1a4(client, requestHeaders) {
    let headers = client[0, $lvJDy.__headers] || {};
    // Individual request headers will take precedence over client headers.
    // We intentionally do *not* merge client and request headers.
    if (requestHeaders) headers = requestHeaders;
    return headers;
}

});
parcelRegister("7y4CF", function(module, exports) {

$parcel$export(module.exports, "resolveOwnerFields", () => $75f9c59c45b035b9$export$597cd394a923f2bd);
/**
 * Given an introspection schema model, returns all owner fields.
 *
 * @param model Model from an introspection schema
 * @returns List of owner field names
 */ function $75f9c59c45b035b9$export$597cd394a923f2bd(model) {
    const ownerFields = new Set();
    for (const attr of model.attributes || [])if ($75f9c59c45b035b9$var$isAuthAttribute(attr)) {
        for (const rule of attr.properties.rules)if (rule.allow === "owner") ownerFields.add(rule.ownerField || "owner");
    }
    return Array.from(ownerFields);
}
/**
 * Type guard that identifies an auth attribute with an attached rules list that
 * specifies an `allow` attribute at a minimum.
 *
 * @param attribute Any object. Ideally a model introspection schema model attribute
 * @returns True if given object is an auth attribute
 */ function $75f9c59c45b035b9$var$isAuthAttribute(attribute) {
    if (attribute?.type === "auth") {
        if (typeof attribute?.properties === "object") {
            if (Array.isArray(attribute?.properties?.rules)) return attribute?.properties?.rules.every((rule)=>!!rule.allow);
        }
    }
    return false;
}

});


parcelRegister("jrkdU", function(module, exports) {

$parcel$export(module.exports, "listFactory", () => $123412da346ca4b9$export$b6e08b958e381d1b);

var $34Y9w = parcelRequire("34Y9w");
function $123412da346ca4b9$export$b6e08b958e381d1b(client, modelIntrospection, model, context = false) {
    const listWithContext = async (contextSpec, args)=>{
        return $123412da346ca4b9$var$_list(client, modelIntrospection, model, args, contextSpec);
    };
    const list = async (args)=>{
        return $123412da346ca4b9$var$_list(client, modelIntrospection, model, args);
    };
    return context ? listWithContext : list;
}
async function $123412da346ca4b9$var$_list(client, modelIntrospection, model, args, contextSpec) {
    const { name: name } = model;
    const query = (0, $34Y9w.generateGraphQLDocument)(modelIntrospection.models, name, "LIST", args);
    const variables = (0, $34Y9w.buildGraphQLVariables)(model, "LIST", args, modelIntrospection);
    try {
        const auth = (0, $34Y9w.authModeParams)(client, args);
        const headers = (0, $34Y9w.getCustomHeaders)(client, args?.headers);
        const { data: data, extensions: extensions } = !!contextSpec ? await client.graphql(contextSpec, {
            ...auth,
            query: query,
            variables: variables
        }, headers) : await client.graphql({
            ...auth,
            query: query,
            variables: variables
        }, headers);
        // flatten response
        if (data !== undefined) {
            const [key] = Object.keys(data);
            if (data[key].items) {
                const flattenedResult = (0, $34Y9w.flattenItems)(data)[key];
                // don't init if custom selection set
                if (args?.selectionSet) return {
                    data: flattenedResult,
                    nextToken: data[key].nextToken,
                    extensions: extensions
                };
                else {
                    const initialized = (0, $34Y9w.initializeModel)(client, name, flattenedResult, modelIntrospection, auth.authMode, auth.authToken, !!contextSpec);
                    return {
                        data: initialized,
                        nextToken: data[key].nextToken,
                        extensions: extensions
                    };
                }
            }
            return {
                data: data[key],
                nextToken: data[key].nextToken,
                extensions: extensions
            };
        }
    } catch (error) {
        if (error.errors) // graphql errors pass through
        return error;
        else // non-graphql errors re re-thrown
        throw error;
    }
}

});

parcelRegister("4Vvms", function(module, exports) {

$parcel$export(module.exports, "getFactory", () => $7bff1b9f98e0e4a5$export$4dc777407e7dc1ac);

var $34Y9w = parcelRequire("34Y9w");
function $7bff1b9f98e0e4a5$export$4dc777407e7dc1ac(client, modelIntrospection, model, operation, useContext = false) {
    const getWithContext = async (contextSpec, arg, options)=>{
        return $7bff1b9f98e0e4a5$var$_get(client, modelIntrospection, model, arg, options, operation, contextSpec);
    };
    const get = async (arg, options)=>{
        return $7bff1b9f98e0e4a5$var$_get(client, modelIntrospection, model, arg, options, operation);
    };
    return useContext ? getWithContext : get;
}
async function $7bff1b9f98e0e4a5$var$_get(client, modelIntrospection, model, arg, options, operation, context) {
    const { name: name } = model;
    const query = (0, $34Y9w.generateGraphQLDocument)(modelIntrospection.models, name, operation, options);
    const variables = (0, $34Y9w.buildGraphQLVariables)(model, operation, arg, modelIntrospection);
    try {
        const auth = (0, $34Y9w.authModeParams)(client, options);
        const headers = (0, $34Y9w.getCustomHeaders)(client, options?.headers);
        const { data: data, extensions: extensions } = context ? await client.graphql(context, {
            ...auth,
            query: query,
            variables: variables
        }, headers) : await client.graphql({
            ...auth,
            query: query,
            variables: variables
        }, headers);
        // flatten response
        if (data) {
            const [key] = Object.keys(data);
            const flattenedResult = (0, $34Y9w.flattenItems)(data)[key];
            if (options?.selectionSet) return {
                data: flattenedResult,
                extensions: extensions
            };
            else {
                // TODO: refactor to avoid destructuring here
                const [initialized] = (0, $34Y9w.initializeModel)(client, name, [
                    flattenedResult
                ], modelIntrospection, auth.authMode, auth.authToken, !!context);
                return {
                    data: initialized,
                    extensions: extensions
                };
            }
        } else return {
            data: null,
            extensions: extensions
        };
    } catch (error) {
        if (error.errors) // graphql errors pass through
        return error;
        else // non-graphql errors re re-thrown
        throw error;
    }
}

});

parcelRegister("7fgpS", function(module, exports) {

$parcel$export(module.exports, "subscriptionFactory", () => $f3a38387185e555a$export$90a8a93856dc32cc);

var $d4PzE = parcelRequire("d4PzE");

var $34Y9w = parcelRequire("34Y9w");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f3a38387185e555a$export$90a8a93856dc32cc(client, modelIntrospection, model, operation) {
    const { name: name } = model;
    const subscription = (args)=>{
        const query = (0, $34Y9w.generateGraphQLDocument)(modelIntrospection.models, name, operation);
        const variables = (0, $34Y9w.buildGraphQLVariables)(model, operation, args, modelIntrospection);
        const auth = (0, $34Y9w.authModeParams)(client, args);
        const headers = (0, $34Y9w.getCustomHeaders)(client, args?.headers);
        const observable = client.graphql({
            ...auth,
            query: query,
            variables: variables
        }, headers);
        return observable.pipe((0, $d4PzE.map)((value)=>{
            const [key] = Object.keys(value.data);
            const data = value.data[key];
            const [initialized] = (0, $34Y9w.initializeModel)(client, name, [
                data
            ], modelIntrospection, auth.authMode, auth.authToken);
            return initialized;
        }));
    };
    return subscription;
}

});

parcelRegister("5mUlK", function(module, exports) {

$parcel$export(module.exports, "observeQueryFactory", () => $be2633a784525c2c$export$9cf24fed4882559a);

var $6OiYn = parcelRequire("6OiYn");


var $3Ot4Z = parcelRequire("3Ot4Z");

var $kUVqC = parcelRequire("kUVqC");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $be2633a784525c2c$export$9cf24fed4882559a(models, model) {
    const { name: name } = model;
    const observeQuery = (arg)=>new (0, $6OiYn.Observable)((subscriber)=>{
            // what we'll be sending to our subscribers
            const items = [];
            // To enqueue subscription messages while we collect our initial
            // result set.
            const messageQueue = [];
            // operation to take when message(s) arrive.
            // this operation will be swapped out once initial "sync" is complete
            // to immediately ingest messsages.
            let receiveMessages = (...messages)=>{
                return messageQueue.push(...messages);
            };
            // start subscriptions
            const onCreateSub = models[name].onCreate(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "create"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onCreate",
                        error: error
                    });
                }
            });
            const onUpdateSub = models[name].onUpdate(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "update"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onUpdate",
                        error: error
                    });
                }
            });
            const onDeleteSub = models[name].onDelete(arg).subscribe({
                next (item) {
                    receiveMessages({
                        item: item,
                        type: "delete"
                    });
                },
                error (error) {
                    subscriber.error({
                        type: "onDelete",
                        error: error
                    });
                }
            });
            // consumes a list of messages and sends a snapshot
            function ingestMessages(messages) {
                for (const message of messages){
                    const idx = (0, $kUVqC.findIndexByFields)(message.item, items, pkFields);
                    switch(message.type){
                        case "create":
                            if (idx < 0) items.push(message.item);
                            break;
                        case "update":
                            if (idx >= 0) items[idx] = message.item;
                            break;
                        case "delete":
                            if (idx >= 0) items.splice(idx, 1);
                            break;
                        default:
                            console.error("Unrecognized message in observeQuery.", message);
                    }
                }
                subscriber.next({
                    items: items,
                    isSynced: true
                });
            }
            const pkFields = (0, $3Ot4Z.resolvePKFields)(model);
            // initial results
            (async ()=>{
                let firstPage = true;
                let nextToken = null;
                while(!subscriber.closed && (firstPage || nextToken)){
                    firstPage = false;
                    const { data: page, errors: errors, nextToken: _nextToken } = await models[name].list({
                        ...arg,
                        nextToken: nextToken
                    });
                    nextToken = _nextToken;
                    items.push(...page);
                    // if there are no more pages and no items we already know about
                    // that need to be merged in from sub, we're "synced"
                    const isSynced = messageQueue.length === 0 && (nextToken === null || nextToken === undefined);
                    subscriber.next({
                        items: items,
                        isSynced: isSynced
                    });
                    if (Array.isArray(errors)) for (const error of errors)subscriber.error(error);
                }
                // play through the queue
                if (messageQueue.length > 0) ingestMessages(messageQueue);
                // switch the queue to write directly to the items collection
                receiveMessages = (...messages)=>{
                    ingestMessages(messages);
                    return items.length;
                };
            })();
            // when subscriber unsubscribes, tear down internal subs
            return ()=>{
                // 1. tear down internal subs
                onCreateSub.unsubscribe();
                onUpdateSub.unsubscribe();
                onDeleteSub.unsubscribe();
            // 2. there is no need to explicitly stop paging. instead, we
            // just check `subscriber.closed` above before fetching each page.
            };
        });
    return observeQuery;
}

});
parcelRegister("3Ot4Z", function(module, exports) {

$parcel$export(module.exports, "resolvePKFields", () => $632989c53e360370$export$b46c507f59d0394c);
/**
 * Given a SchemaModel from a ModelIntrospectionSchema, returns the primary key
 * as an array of field names.
 *
 * @param model The model object
 * @returns Array of field names
 */ function $632989c53e360370$export$b46c507f59d0394c(model) {
    const { primaryKeyFieldName: primaryKeyFieldName, sortKeyFieldNames: sortKeyFieldNames } = model.primaryKeyInfo;
    return [
        primaryKeyFieldName,
        ...sortKeyFieldNames
    ];
}

});

parcelRegister("kUVqC", function(module, exports) {

$parcel$export(module.exports, "findIndexByFields", () => $0e7b2bfc69fdf9ec$export$dc565815e1b88e94);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Iterates through a collection to find a matching item and returns the index.
 *
 * @param needle The item to search for
 * @param haystack The collection to search
 * @param keyFields The fields used to indicate a match
 * @returns Index of `needle` in `haystack`, otherwise -1 if not found.
 */ function $0e7b2bfc69fdf9ec$export$dc565815e1b88e94(needle, haystack, keyFields) {
    const searchObject = Object.fromEntries(keyFields.map((fieldName)=>[
            fieldName,
            needle[fieldName]
        ]));
    for(let i = 0; i < haystack.length; i++){
        if (Object.keys(searchObject).every((k)=>searchObject[k] === haystack[i][k])) return i;
    }
    return -1;
}

});





parcelRegister("le7Hi", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"aws_project_region":"us-east-2","aws_appsync_graphqlEndpoint":"https://fdaufhhmbbgtffmis2dsc6seeu.appsync-api.us-east-2.amazonaws.com/graphql","aws_appsync_region":"us-east-2","aws_appsync_authenticationType":"API_KEY","aws_appsync_apiKey":"da2-4ae7twr2xreexlqemqaklhokbe"}');

});


//# sourceMappingURL=index.40c3b1af.js.map
